!function(i){"use strict";"function"==typeof define&&define.amd?define(["jquery"],i):"undefined"!=typeof exports?module.exports=i(require("jquery")):i(jQuery)}(function(i){"use strict";var e=window.Slick||{};(e=function(){var e=0;return function(t,o){var s,n=this;n.defaults={accessibility:!0,adaptiveHeight:!1,appendArrows:i(t),appendDots:i(t),arrows:!0,asNavFor:null,prevArrow:'<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',nextArrow:'<button class="slick-next" aria-label="Next" type="button">Next</button>',autoplay:!1,autoplaySpeed:3e3,centerMode:!1,centerPadding:"50px",cssEase:"ease",customPaging:function(e,t){return i('<button type="button" />').text(t+1)},dots:!1,dotsClass:"slick-dots",draggable:!0,easing:"linear",edgeFriction:.35,fade:!1,focusOnSelect:!1,focusOnChange:!1,infinite:!0,initialSlide:0,lazyLoad:"ondemand",mobileFirst:!1,pauseOnHover:!0,pauseOnFocus:!0,pauseOnDotsHover:!1,respondTo:"window",responsive:null,rows:1,rtl:!1,slide:"",slidesPerRow:1,slidesToShow:1,slidesToScroll:1,speed:500,swipe:!0,swipeToSlide:!1,touchMove:!0,touchThreshold:5,useCSS:!0,useTransform:!0,variableWidth:!1,vertical:!1,verticalSwiping:!1,waitForAnimate:!0,zIndex:1e3},n.initials={animating:!1,dragging:!1,autoPlayTimer:null,currentDirection:0,currentLeft:null,currentSlide:0,direction:1,$dots:null,listWidth:null,listHeight:null,loadIndex:0,$nextArrow:null,$prevArrow:null,scrolling:!1,slideCount:null,slideWidth:null,$slideTrack:null,$slides:null,sliding:!1,slideOffset:0,swipeLeft:null,swiping:!1,$list:null,touchObject:{},transformsEnabled:!1,unslicked:!1},i.extend(n,n.initials),n.activeBreakpoint=null,n.animType=null,n.animProp=null,n.breakpoints=[],n.breakpointSettings=[],n.cssTransitions=!1,n.focussed=!1,n.interrupted=!1,n.hidden="hidden",n.paused=!0,n.positionProp=null,n.respondTo=null,n.rowCount=1,n.shouldClick=!0,n.$slider=i(t),n.$slidesCache=null,n.transformType=null,n.transitionType=null,n.visibilityChange="visibilitychange",n.windowWidth=0,n.windowTimer=null,s=i(t).data("slick")||{},n.options=i.extend({},n.defaults,o,s),n.currentSlide=n.options.initialSlide,n.originalSettings=n.options,void 0!==document.mozHidden?(n.hidden="mozHidden",n.visibilityChange="mozvisibilitychange"):void 0!==document.webkitHidden&&(n.hidden="webkitHidden",n.visibilityChange="webkitvisibilitychange"),n.autoPlay=i.proxy(n.autoPlay,n),n.autoPlayClear=i.proxy(n.autoPlayClear,n),n.autoPlayIterator=i.proxy(n.autoPlayIterator,n),n.changeSlide=i.proxy(n.changeSlide,n),n.clickHandler=i.proxy(n.clickHandler,n),n.selectHandler=i.proxy(n.selectHandler,n),n.setPosition=i.proxy(n.setPosition,n),n.swipeHandler=i.proxy(n.swipeHandler,n),n.dragHandler=i.proxy(n.dragHandler,n),n.keyHandler=i.proxy(n.keyHandler,n),n.instanceUid=e++,n.htmlExpr=/^(?:\s*(<[\w\W]+>)[^>]*)$/,n.registerBreakpoints(),n.init(!0)}}()).prototype.activateADA=function(){this.$slideTrack.find(".slick-active").attr({"aria-hidden":"false"}).find("a, input, button, select").attr({tabindex:"0"})},e.prototype.addSlide=e.prototype.slickAdd=function(e,t,o){var s=this;if("boolean"==typeof t)o=t,t=null;else if(t<0||t>=s.slideCount)return!1;s.unload(),"number"==typeof t?0===t&&0===s.$slides.length?i(e).appendTo(s.$slideTrack):o?i(e).insertBefore(s.$slides.eq(t)):i(e).insertAfter(s.$slides.eq(t)):!0===o?i(e).prependTo(s.$slideTrack):i(e).appendTo(s.$slideTrack),s.$slides=s.$slideTrack.children(this.options.slide),s.$slideTrack.children(this.options.slide).detach(),s.$slideTrack.append(s.$slides),s.$slides.each(function(e,t){i(t).attr("data-slick-index",e)}),s.$slidesCache=s.$slides,s.reinit()},e.prototype.animateHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.animate({height:e},i.options.speed)}},e.prototype.animateSlide=function(e,t){var o={},s=this;s.animateHeight(),!0===s.options.rtl&&!1===s.options.vertical&&(e=-e),!1===s.transformsEnabled?!1===s.options.vertical?s.$slideTrack.animate({left:e},s.options.speed,s.options.easing,t):s.$slideTrack.animate({top:e},s.options.speed,s.options.easing,t):!1===s.cssTransitions?(!0===s.options.rtl&&(s.currentLeft=-s.currentLeft),i({animStart:s.currentLeft}).animate({animStart:e},{duration:s.options.speed,easing:s.options.easing,step:function(i){i=Math.ceil(i),!1===s.options.vertical?(o[s.animType]="translate("+i+"px, 0px)",s.$slideTrack.css(o)):(o[s.animType]="translate(0px,"+i+"px)",s.$slideTrack.css(o))},complete:function(){t&&t.call()}})):(s.applyTransition(),e=Math.ceil(e),!1===s.options.vertical?o[s.animType]="translate3d("+e+"px, 0px, 0px)":o[s.animType]="translate3d(0px,"+e+"px, 0px)",s.$slideTrack.css(o),t&&setTimeout(function(){s.disableTransition(),t.call()},s.options.speed))},e.prototype.getNavTarget=function(){var e=this,t=e.options.asNavFor;return t&&null!==t&&(t=i(t).not(e.$slider)),t},e.prototype.asNavFor=function(e){var t=this.getNavTarget();null!==t&&"object"==typeof t&&t.each(function(){var t=i(this).slick("getSlick");t.unslicked||t.slideHandler(e,!0)})},e.prototype.applyTransition=function(i){var e=this,t={};!1===e.options.fade?t[e.transitionType]=e.transformType+" "+e.options.speed+"ms "+e.options.cssEase:t[e.transitionType]="opacity "+e.options.speed+"ms "+e.options.cssEase,!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.autoPlay=function(){var i=this;i.autoPlayClear(),i.slideCount>i.options.slidesToShow&&(i.autoPlayTimer=setInterval(i.autoPlayIterator,i.options.autoplaySpeed))},e.prototype.autoPlayClear=function(){var i=this;i.autoPlayTimer&&clearInterval(i.autoPlayTimer)},e.prototype.autoPlayIterator=function(){var i=this,e=i.currentSlide+i.options.slidesToScroll;i.paused||i.interrupted||i.focussed||(!1===i.options.infinite&&(1===i.direction&&i.currentSlide+1===i.slideCount-1?i.direction=0:0===i.direction&&(e=i.currentSlide-i.options.slidesToScroll,i.currentSlide-1==0&&(i.direction=1))),i.slideHandler(e))},e.prototype.buildArrows=function(){var e=this;!0===e.options.arrows&&(e.$prevArrow=i(e.options.prevArrow).addClass("slick-arrow"),e.$nextArrow=i(e.options.nextArrow).addClass("slick-arrow"),e.slideCount>e.options.slidesToShow?(e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.prependTo(e.options.appendArrows),e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.appendTo(e.options.appendArrows),!0!==e.options.infinite&&e.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true")):e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({"aria-disabled":"true",tabindex:"-1"}))},e.prototype.buildDots=function(){var e,t,o=this;if(!0===o.options.dots){for(o.$slider.addClass("slick-dotted"),t=i("<ul />").addClass(o.options.dotsClass),e=0;e<=o.getDotCount();e+=1)t.append(i("<li />").append(o.options.customPaging.call(this,o,e)));o.$dots=t.appendTo(o.options.appendDots),o.$dots.find("li").first().addClass("slick-active")}},e.prototype.buildOut=function(){var e=this;e.$slides=e.$slider.children(e.options.slide+":not(.slick-cloned)").addClass("slick-slide"),e.slideCount=e.$slides.length,e.$slides.each(function(e,t){i(t).attr("data-slick-index",e).data("originalStyling",i(t).attr("style")||"")}),e.$slider.addClass("slick-slider"),e.$slideTrack=0===e.slideCount?i('<div class="slick-track"/>').appendTo(e.$slider):e.$slides.wrapAll('<div class="slick-track"/>').parent(),e.$list=e.$slideTrack.wrap('<div class="slick-list"/>').parent(),e.$slideTrack.css("opacity",0),!0!==e.options.centerMode&&!0!==e.options.swipeToSlide||(e.options.slidesToScroll=1),i("img[data-lazy]",e.$slider).not("[src]").addClass("slick-loading"),e.setupInfinite(),e.buildArrows(),e.buildDots(),e.updateDots(),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),!0===e.options.draggable&&e.$list.addClass("draggable")},e.prototype.buildRows=function(){var i,e,t,o,s,n,r,l=this;if(o=document.createDocumentFragment(),n=l.$slider.children(),l.options.rows>1){for(r=l.options.slidesPerRow*l.options.rows,s=Math.ceil(n.length/r),i=0;i<s;i++){var d=document.createElement("div");for(e=0;e<l.options.rows;e++){var a=document.createElement("div");for(t=0;t<l.options.slidesPerRow;t++){var c=i*r+(e*l.options.slidesPerRow+t);n.get(c)&&a.appendChild(n.get(c))}d.appendChild(a)}o.appendChild(d)}l.$slider.empty().append(o),l.$slider.children().children().children().css({width:100/l.options.slidesPerRow+"%",display:"inline-block"})}},e.prototype.checkResponsive=function(e,t){var o,s,n,r=this,l=!1,d=r.$slider.width(),a=window.innerWidth||i(window).width();if("window"===r.respondTo?n=a:"slider"===r.respondTo?n=d:"min"===r.respondTo&&(n=Math.min(a,d)),r.options.responsive&&r.options.responsive.length&&null!==r.options.responsive){s=null;for(o in r.breakpoints)r.breakpoints.hasOwnProperty(o)&&(!1===r.originalSettings.mobileFirst?n<r.breakpoints[o]&&(s=r.breakpoints[o]):n>r.breakpoints[o]&&(s=r.breakpoints[o]));null!==s?null!==r.activeBreakpoint?(s!==r.activeBreakpoint||t)&&(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):null!==r.activeBreakpoint&&(r.activeBreakpoint=null,r.options=r.originalSettings,!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e),l=s),e||!1===l||r.$slider.trigger("breakpoint",[r,l])}},e.prototype.changeSlide=function(e,t){var o,s,n,r=this,l=i(e.currentTarget);switch(l.is("a")&&e.preventDefault(),l.is("li")||(l=l.closest("li")),n=r.slideCount%r.options.slidesToScroll!=0,o=n?0:(r.slideCount-r.currentSlide)%r.options.slidesToScroll,e.data.message){case"previous":s=0===o?r.options.slidesToScroll:r.options.slidesToShow-o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide-s,!1,t);break;case"next":s=0===o?r.options.slidesToScroll:o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide+s,!1,t);break;case"index":var d=0===e.data.index?0:e.data.index||l.index()*r.options.slidesToScroll;r.slideHandler(r.checkNavigable(d),!1,t),l.children().trigger("focus");break;default:return}},e.prototype.checkNavigable=function(i){var e,t;if(e=this.getNavigableIndexes(),t=0,i>e[e.length-1])i=e[e.length-1];else for(var o in e){if(i<e[o]){i=t;break}t=e[o]}return i},e.prototype.cleanUpEvents=function(){var e=this;e.options.dots&&null!==e.$dots&&(i("li",e.$dots).off("click.slick",e.changeSlide).off("mouseenter.slick",i.proxy(e.interrupt,e,!0)).off("mouseleave.slick",i.proxy(e.interrupt,e,!1)),!0===e.options.accessibility&&e.$dots.off("keydown.slick",e.keyHandler)),e.$slider.off("focus.slick blur.slick"),!0===e.options.arrows&&e.slideCount>e.options.slidesToShow&&(e.$prevArrow&&e.$prevArrow.off("click.slick",e.changeSlide),e.$nextArrow&&e.$nextArrow.off("click.slick",e.changeSlide),!0===e.options.accessibility&&(e.$prevArrow&&e.$prevArrow.off("keydown.slick",e.keyHandler),e.$nextArrow&&e.$nextArrow.off("keydown.slick",e.keyHandler))),e.$list.off("touchstart.slick mousedown.slick",e.swipeHandler),e.$list.off("touchmove.slick mousemove.slick",e.swipeHandler),e.$list.off("touchend.slick mouseup.slick",e.swipeHandler),e.$list.off("touchcancel.slick mouseleave.slick",e.swipeHandler),e.$list.off("click.slick",e.clickHandler),i(document).off(e.visibilityChange,e.visibility),e.cleanUpSlideEvents(),!0===e.options.accessibility&&e.$list.off("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().off("click.slick",e.selectHandler),i(window).off("orientationchange.slick.slick-"+e.instanceUid,e.orientationChange),i(window).off("resize.slick.slick-"+e.instanceUid,e.resize),i("[draggable!=true]",e.$slideTrack).off("dragstart",e.preventDefault),i(window).off("load.slick.slick-"+e.instanceUid,e.setPosition)},e.prototype.cleanUpSlideEvents=function(){var e=this;e.$list.off("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.off("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.cleanUpRows=function(){var i,e=this;e.options.rows>1&&((i=e.$slides.children().children()).removeAttr("style"),e.$slider.empty().append(i))},e.prototype.clickHandler=function(i){!1===this.shouldClick&&(i.stopImmediatePropagation(),i.stopPropagation(),i.preventDefault())},e.prototype.destroy=function(e){var t=this;t.autoPlayClear(),t.touchObject={},t.cleanUpEvents(),i(".slick-cloned",t.$slider).detach(),t.$dots&&t.$dots.remove(),t.$prevArrow&&t.$prevArrow.length&&(t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.prevArrow)&&t.$prevArrow.remove()),t.$nextArrow&&t.$nextArrow.length&&(t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.nextArrow)&&t.$nextArrow.remove()),t.$slides&&(t.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function(){i(this).attr("style",i(this).data("originalStyling"))}),t.$slideTrack.children(this.options.slide).detach(),t.$slideTrack.detach(),t.$list.detach(),t.$slider.append(t.$slides)),t.cleanUpRows(),t.$slider.removeClass("slick-slider"),t.$slider.removeClass("slick-initialized"),t.$slider.removeClass("slick-dotted"),t.unslicked=!0,e||t.$slider.trigger("destroy",[t])},e.prototype.disableTransition=function(i){var e=this,t={};t[e.transitionType]="",!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.fadeSlide=function(i,e){var t=this;!1===t.cssTransitions?(t.$slides.eq(i).css({zIndex:t.options.zIndex}),t.$slides.eq(i).animate({opacity:1},t.options.speed,t.options.easing,e)):(t.applyTransition(i),t.$slides.eq(i).css({opacity:1,zIndex:t.options.zIndex}),e&&setTimeout(function(){t.disableTransition(i),e.call()},t.options.speed))},e.prototype.fadeSlideOut=function(i){var e=this;!1===e.cssTransitions?e.$slides.eq(i).animate({opacity:0,zIndex:e.options.zIndex-2},e.options.speed,e.options.easing):(e.applyTransition(i),e.$slides.eq(i).css({opacity:0,zIndex:e.options.zIndex-2}))},e.prototype.filterSlides=e.prototype.slickFilter=function(i){var e=this;null!==i&&(e.$slidesCache=e.$slides,e.unload(),e.$slideTrack.children(this.options.slide).detach(),e.$slidesCache.filter(i).appendTo(e.$slideTrack),e.reinit())},e.prototype.focusHandler=function(){var e=this;e.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick","*",function(t){t.stopImmediatePropagation();var o=i(this);setTimeout(function(){e.options.pauseOnFocus&&(e.focussed=o.is(":focus"),e.autoPlay())},0)})},e.prototype.getCurrent=e.prototype.slickCurrentSlide=function(){return this.currentSlide},e.prototype.getDotCount=function(){var i=this,e=0,t=0,o=0;if(!0===i.options.infinite)if(i.slideCount<=i.options.slidesToShow)++o;else for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else if(!0===i.options.centerMode)o=i.slideCount;else if(i.options.asNavFor)for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else o=1+Math.ceil((i.slideCount-i.options.slidesToShow)/i.options.slidesToScroll);return o-1},e.prototype.getLeft=function(i){var e,t,o,s,n=this,r=0;return n.slideOffset=0,t=n.$slides.first().outerHeight(!0),!0===n.options.infinite?(n.slideCount>n.options.slidesToShow&&(n.slideOffset=n.slideWidth*n.options.slidesToShow*-1,s=-1,!0===n.options.vertical&&!0===n.options.centerMode&&(2===n.options.slidesToShow?s=-1.5:1===n.options.slidesToShow&&(s=-2)),r=t*n.options.slidesToShow*s),n.slideCount%n.options.slidesToScroll!=0&&i+n.options.slidesToScroll>n.slideCount&&n.slideCount>n.options.slidesToShow&&(i>n.slideCount?(n.slideOffset=(n.options.slidesToShow-(i-n.slideCount))*n.slideWidth*-1,r=(n.options.slidesToShow-(i-n.slideCount))*t*-1):(n.slideOffset=n.slideCount%n.options.slidesToScroll*n.slideWidth*-1,r=n.slideCount%n.options.slidesToScroll*t*-1))):i+n.options.slidesToShow>n.slideCount&&(n.slideOffset=(i+n.options.slidesToShow-n.slideCount)*n.slideWidth,r=(i+n.options.slidesToShow-n.slideCount)*t),n.slideCount<=n.options.slidesToShow&&(n.slideOffset=0,r=0),!0===n.options.centerMode&&n.slideCount<=n.options.slidesToShow?n.slideOffset=n.slideWidth*Math.floor(n.options.slidesToShow)/2-n.slideWidth*n.slideCount/2:!0===n.options.centerMode&&!0===n.options.infinite?n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)-n.slideWidth:!0===n.options.centerMode&&(n.slideOffset=0,n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)),e=!1===n.options.vertical?i*n.slideWidth*-1+n.slideOffset:i*t*-1+r,!0===n.options.variableWidth&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,!0===n.options.centerMode&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow+1),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,e+=(n.$list.width()-o.outerWidth())/2)),e},e.prototype.getOption=e.prototype.slickGetOption=function(i){return this.options[i]},e.prototype.getNavigableIndexes=function(){var i,e=this,t=0,o=0,s=[];for(!1===e.options.infinite?i=e.slideCount:(t=-1*e.options.slidesToScroll,o=-1*e.options.slidesToScroll,i=2*e.slideCount);t<i;)s.push(t),t=o+e.options.slidesToScroll,o+=e.options.slidesToScroll<=e.options.slidesToShow?e.options.slidesToScroll:e.options.slidesToShow;return s},e.prototype.getSlick=function(){return this},e.prototype.getSlideCount=function(){var e,t,o=this;return t=!0===o.options.centerMode?o.slideWidth*Math.floor(o.options.slidesToShow/2):0,!0===o.options.swipeToSlide?(o.$slideTrack.find(".slick-slide").each(function(s,n){if(n.offsetLeft-t+i(n).outerWidth()/2>-1*o.swipeLeft)return e=n,!1}),Math.abs(i(e).attr("data-slick-index")-o.currentSlide)||1):o.options.slidesToScroll},e.prototype.goTo=e.prototype.slickGoTo=function(i,e){this.changeSlide({data:{message:"index",index:parseInt(i)}},e)},e.prototype.init=function(e){var t=this;i(t.$slider).hasClass("slick-initialized")||(i(t.$slider).addClass("slick-initialized"),t.buildRows(),t.buildOut(),t.setProps(),t.startLoad(),t.loadSlider(),t.initializeEvents(),t.updateArrows(),t.updateDots(),t.checkResponsive(!0),t.focusHandler()),e&&t.$slider.trigger("init",[t]),!0===t.options.accessibility&&t.initADA(),t.options.autoplay&&(t.paused=!1,t.autoPlay())},e.prototype.initADA=function(){var e=this,t=Math.ceil(e.slideCount/e.options.slidesToShow),o=e.getNavigableIndexes().filter(function(i){return i>=0&&i<e.slideCount});e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({"aria-hidden":"true",tabindex:"-1"}).find("a, input, button, select").attr({tabindex:"-1"}),null!==e.$dots&&(e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function(t){var s=o.indexOf(t);i(this).attr({role:"tabpanel",id:"slick-slide"+e.instanceUid+t,tabindex:-1}),-1!==s&&i(this).attr({"aria-describedby":"slick-slide-control"+e.instanceUid+s})}),e.$dots.attr("role","tablist").find("li").each(function(s){var n=o[s];i(this).attr({role:"presentation"}),i(this).find("button").first().attr({role:"tab",id:"slick-slide-control"+e.instanceUid+s,"aria-controls":"slick-slide"+e.instanceUid+n,"aria-label":s+1+" of "+t,"aria-selected":null,tabindex:"-1"})}).eq(e.currentSlide).find("button").attr({"aria-selected":"true",tabindex:"0"}).end());for(var s=e.currentSlide,n=s+e.options.slidesToShow;s<n;s++)e.$slides.eq(s).attr("tabindex",0);e.activateADA()},e.prototype.initArrowEvents=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.off("click.slick").on("click.slick",{message:"previous"},i.changeSlide),i.$nextArrow.off("click.slick").on("click.slick",{message:"next"},i.changeSlide),!0===i.options.accessibility&&(i.$prevArrow.on("keydown.slick",i.keyHandler),i.$nextArrow.on("keydown.slick",i.keyHandler)))},e.prototype.initDotEvents=function(){var e=this;!0===e.options.dots&&(i("li",e.$dots).on("click.slick",{message:"index"},e.changeSlide),!0===e.options.accessibility&&e.$dots.on("keydown.slick",e.keyHandler)),!0===e.options.dots&&!0===e.options.pauseOnDotsHover&&i("li",e.$dots).on("mouseenter.slick",i.proxy(e.interrupt,e,!0)).on("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.initSlideEvents=function(){var e=this;e.options.pauseOnHover&&(e.$list.on("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.on("mouseleave.slick",i.proxy(e.interrupt,e,!1)))},e.prototype.initializeEvents=function(){var e=this;e.initArrowEvents(),e.initDotEvents(),e.initSlideEvents(),e.$list.on("touchstart.slick mousedown.slick",{action:"start"},e.swipeHandler),e.$list.on("touchmove.slick mousemove.slick",{action:"move"},e.swipeHandler),e.$list.on("touchend.slick mouseup.slick",{action:"end"},e.swipeHandler),e.$list.on("touchcancel.slick mouseleave.slick",{action:"end"},e.swipeHandler),e.$list.on("click.slick",e.clickHandler),i(document).on(e.visibilityChange,i.proxy(e.visibility,e)),!0===e.options.accessibility&&e.$list.on("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),i(window).on("orientationchange.slick.slick-"+e.instanceUid,i.proxy(e.orientationChange,e)),i(window).on("resize.slick.slick-"+e.instanceUid,i.proxy(e.resize,e)),i("[draggable!=true]",e.$slideTrack).on("dragstart",e.preventDefault),i(window).on("load.slick.slick-"+e.instanceUid,e.setPosition),i(e.setPosition)},e.prototype.initUI=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.show(),i.$nextArrow.show()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.show()},e.prototype.keyHandler=function(i){var e=this;i.target.tagName.match("TEXTAREA|INPUT|SELECT")||(37===i.keyCode&&!0===e.options.accessibility?e.changeSlide({data:{message:!0===e.options.rtl?"next":"previous"}}):39===i.keyCode&&!0===e.options.accessibility&&e.changeSlide({data:{message:!0===e.options.rtl?"previous":"next"}}))},e.prototype.lazyLoad=function(){function e(e){i("img[data-lazy]",e).each(function(){var e=i(this),t=i(this).attr("data-lazy"),o=i(this).attr("data-srcset"),s=i(this).attr("data-sizes")||n.$slider.attr("data-sizes"),r=document.createElement("img");r.onload=function(){e.animate({opacity:0},100,function(){o&&(e.attr("srcset",o),s&&e.attr("sizes",s)),e.attr("src",t).animate({opacity:1},200,function(){e.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")}),n.$slider.trigger("lazyLoaded",[n,e,t])})},r.onerror=function(){e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),n.$slider.trigger("lazyLoadError",[n,e,t])},r.src=t})}var t,o,s,n=this;if(!0===n.options.centerMode?!0===n.options.infinite?s=(o=n.currentSlide+(n.options.slidesToShow/2+1))+n.options.slidesToShow+2:(o=Math.max(0,n.currentSlide-(n.options.slidesToShow/2+1)),s=n.options.slidesToShow/2+1+2+n.currentSlide):(o=n.options.infinite?n.options.slidesToShow+n.currentSlide:n.currentSlide,s=Math.ceil(o+n.options.slidesToShow),!0===n.options.fade&&(o>0&&o--,s<=n.slideCount&&s++)),t=n.$slider.find(".slick-slide").slice(o,s),"anticipated"===n.options.lazyLoad)for(var r=o-1,l=s,d=n.$slider.find(".slick-slide"),a=0;a<n.options.slidesToScroll;a++)r<0&&(r=n.slideCount-1),t=(t=t.add(d.eq(r))).add(d.eq(l)),r--,l++;e(t),n.slideCount<=n.options.slidesToShow?e(n.$slider.find(".slick-slide")):n.currentSlide>=n.slideCount-n.options.slidesToShow?e(n.$slider.find(".slick-cloned").slice(0,n.options.slidesToShow)):0===n.currentSlide&&e(n.$slider.find(".slick-cloned").slice(-1*n.options.slidesToShow))},e.prototype.loadSlider=function(){var i=this;i.setPosition(),i.$slideTrack.css({opacity:1}),i.$slider.removeClass("slick-loading"),i.initUI(),"progressive"===i.options.lazyLoad&&i.progressiveLazyLoad()},e.prototype.next=e.prototype.slickNext=function(){this.changeSlide({data:{message:"next"}})},e.prototype.orientationChange=function(){var i=this;i.checkResponsive(),i.setPosition()},e.prototype.pause=e.prototype.slickPause=function(){var i=this;i.autoPlayClear(),i.paused=!0},e.prototype.play=e.prototype.slickPlay=function(){var i=this;i.autoPlay(),i.options.autoplay=!0,i.paused=!1,i.focussed=!1,i.interrupted=!1},e.prototype.postSlide=function(e){var t=this;t.unslicked||(t.$slider.trigger("afterChange",[t,e]),t.animating=!1,t.slideCount>t.options.slidesToShow&&t.setPosition(),t.swipeLeft=null,t.options.autoplay&&t.autoPlay(),!0===t.options.accessibility&&(t.initADA(),t.options.focusOnChange&&i(t.$slides.get(t.currentSlide)).attr("tabindex",0).focus()))},e.prototype.prev=e.prototype.slickPrev=function(){this.changeSlide({data:{message:"previous"}})},e.prototype.preventDefault=function(i){i.preventDefault()},e.prototype.progressiveLazyLoad=function(e){e=e||1;var t,o,s,n,r,l=this,d=i("img[data-lazy]",l.$slider);d.length?(t=d.first(),o=t.attr("data-lazy"),s=t.attr("data-srcset"),n=t.attr("data-sizes")||l.$slider.attr("data-sizes"),(r=document.createElement("img")).onload=function(){s&&(t.attr("srcset",s),n&&t.attr("sizes",n)),t.attr("src",o).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"),!0===l.options.adaptiveHeight&&l.setPosition(),l.$slider.trigger("lazyLoaded",[l,t,o]),l.progressiveLazyLoad()},r.onerror=function(){e<3?setTimeout(function(){l.progressiveLazyLoad(e+1)},500):(t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),l.$slider.trigger("lazyLoadError",[l,t,o]),l.progressiveLazyLoad())},r.src=o):l.$slider.trigger("allImagesLoaded",[l])},e.prototype.refresh=function(e){var t,o,s=this;o=s.slideCount-s.options.slidesToShow,!s.options.infinite&&s.currentSlide>o&&(s.currentSlide=o),s.slideCount<=s.options.slidesToShow&&(s.currentSlide=0),t=s.currentSlide,s.destroy(!0),i.extend(s,s.initials,{currentSlide:t}),s.init(),e||s.changeSlide({data:{message:"index",index:t}},!1)},e.prototype.registerBreakpoints=function(){var e,t,o,s=this,n=s.options.responsive||null;if("array"===i.type(n)&&n.length){s.respondTo=s.options.respondTo||"window";for(e in n)if(o=s.breakpoints.length-1,n.hasOwnProperty(e)){for(t=n[e].breakpoint;o>=0;)s.breakpoints[o]&&s.breakpoints[o]===t&&s.breakpoints.splice(o,1),o--;s.breakpoints.push(t),s.breakpointSettings[t]=n[e].settings}s.breakpoints.sort(function(i,e){return s.options.mobileFirst?i-e:e-i})}},e.prototype.reinit=function(){var e=this;e.$slides=e.$slideTrack.children(e.options.slide).addClass("slick-slide"),e.slideCount=e.$slides.length,e.currentSlide>=e.slideCount&&0!==e.currentSlide&&(e.currentSlide=e.currentSlide-e.options.slidesToScroll),e.slideCount<=e.options.slidesToShow&&(e.currentSlide=0),e.registerBreakpoints(),e.setProps(),e.setupInfinite(),e.buildArrows(),e.updateArrows(),e.initArrowEvents(),e.buildDots(),e.updateDots(),e.initDotEvents(),e.cleanUpSlideEvents(),e.initSlideEvents(),e.checkResponsive(!1,!0),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),e.setPosition(),e.focusHandler(),e.paused=!e.options.autoplay,e.autoPlay(),e.$slider.trigger("reInit",[e])},e.prototype.resize=function(){var e=this;i(window).width()!==e.windowWidth&&(clearTimeout(e.windowDelay),e.windowDelay=window.setTimeout(function(){e.windowWidth=i(window).width(),e.checkResponsive(),e.unslicked||e.setPosition()},50))},e.prototype.removeSlide=e.prototype.slickRemove=function(i,e,t){var o=this;if(i="boolean"==typeof i?!0===(e=i)?0:o.slideCount-1:!0===e?--i:i,o.slideCount<1||i<0||i>o.slideCount-1)return!1;o.unload(),!0===t?o.$slideTrack.children().remove():o.$slideTrack.children(this.options.slide).eq(i).remove(),o.$slides=o.$slideTrack.children(this.options.slide),o.$slideTrack.children(this.options.slide).detach(),o.$slideTrack.append(o.$slides),o.$slidesCache=o.$slides,o.reinit()},e.prototype.setCSS=function(i){var e,t,o=this,s={};!0===o.options.rtl&&(i=-i),e="left"==o.positionProp?Math.ceil(i)+"px":"0px",t="top"==o.positionProp?Math.ceil(i)+"px":"0px",s[o.positionProp]=i,!1===o.transformsEnabled?o.$slideTrack.css(s):(s={},!1===o.cssTransitions?(s[o.animType]="translate("+e+", "+t+")",o.$slideTrack.css(s)):(s[o.animType]="translate3d("+e+", "+t+", 0px)",o.$slideTrack.css(s)))},e.prototype.setDimensions=function(){var i=this;!1===i.options.vertical?!0===i.options.centerMode&&i.$list.css({padding:"0px "+i.options.centerPadding}):(i.$list.height(i.$slides.first().outerHeight(!0)*i.options.slidesToShow),!0===i.options.centerMode&&i.$list.css({padding:i.options.centerPadding+" 0px"})),i.listWidth=i.$list.width(),i.listHeight=i.$list.height(),!1===i.options.vertical&&!1===i.options.variableWidth?(i.slideWidth=Math.ceil(i.listWidth/i.options.slidesToShow),i.$slideTrack.width(Math.ceil(i.slideWidth*i.$slideTrack.children(".slick-slide").length))):!0===i.options.variableWidth?i.$slideTrack.width(5e3*i.slideCount):(i.slideWidth=Math.ceil(i.listWidth),i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0)*i.$slideTrack.children(".slick-slide").length)));var e=i.$slides.first().outerWidth(!0)-i.$slides.first().width();!1===i.options.variableWidth&&i.$slideTrack.children(".slick-slide").width(i.slideWidth-e)},e.prototype.setFade=function(){var e,t=this;t.$slides.each(function(o,s){e=t.slideWidth*o*-1,!0===t.options.rtl?i(s).css({position:"relative",right:e,top:0,zIndex:t.options.zIndex-2,opacity:0}):i(s).css({position:"relative",left:e,top:0,zIndex:t.options.zIndex-2,opacity:0})}),t.$slides.eq(t.currentSlide).css({zIndex:t.options.zIndex-1,opacity:1})},e.prototype.setHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.css("height",e)}},e.prototype.setOption=e.prototype.slickSetOption=function(){var e,t,o,s,n,r=this,l=!1;if("object"===i.type(arguments[0])?(o=arguments[0],l=arguments[1],n="multiple"):"string"===i.type(arguments[0])&&(o=arguments[0],s=arguments[1],l=arguments[2],"responsive"===arguments[0]&&"array"===i.type(arguments[1])?n="responsive":void 0!==arguments[1]&&(n="single")),"single"===n)r.options[o]=s;else if("multiple"===n)i.each(o,function(i,e){r.options[i]=e});else if("responsive"===n)for(t in s)if("array"!==i.type(r.options.responsive))r.options.responsive=[s[t]];else{for(e=r.options.responsive.length-1;e>=0;)r.options.responsive[e].breakpoint===s[t].breakpoint&&r.options.responsive.splice(e,1),e--;r.options.responsive.push(s[t])}l&&(r.unload(),r.reinit())},e.prototype.setPosition=function(){var i=this;i.setDimensions(),i.setHeight(),!1===i.options.fade?i.setCSS(i.getLeft(i.currentSlide)):i.setFade(),i.$slider.trigger("setPosition",[i])},e.prototype.setProps=function(){var i=this,e=document.body.style;i.positionProp=!0===i.options.vertical?"top":"left","top"===i.positionProp?i.$slider.addClass("slick-vertical"):i.$slider.removeClass("slick-vertical"),void 0===e.WebkitTransition&&void 0===e.MozTransition&&void 0===e.msTransition||!0===i.options.useCSS&&(i.cssTransitions=!0),i.options.fade&&("number"==typeof i.options.zIndex?i.options.zIndex<3&&(i.options.zIndex=3):i.options.zIndex=i.defaults.zIndex),void 0!==e.OTransform&&(i.animType="OTransform",i.transformType="-o-transform",i.transitionType="OTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.MozTransform&&(i.animType="MozTransform",i.transformType="-moz-transform",i.transitionType="MozTransition",void 0===e.perspectiveProperty&&void 0===e.MozPerspective&&(i.animType=!1)),void 0!==e.webkitTransform&&(i.animType="webkitTransform",i.transformType="-webkit-transform",i.transitionType="webkitTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.msTransform&&(i.animType="msTransform",i.transformType="-ms-transform",i.transitionType="msTransition",void 0===e.msTransform&&(i.animType=!1)),void 0!==e.transform&&!1!==i.animType&&(i.animType="transform",i.transformType="transform",i.transitionType="transition"),i.transformsEnabled=i.options.useTransform&&null!==i.animType&&!1!==i.animType},e.prototype.setSlideClasses=function(i){var e,t,o,s,n=this;if(t=n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden","true"),n.$slides.eq(i).addClass("slick-current"),!0===n.options.centerMode){var r=n.options.slidesToShow%2==0?1:0;e=Math.floor(n.options.slidesToShow/2),!0===n.options.infinite&&(i>=e&&i<=n.slideCount-1-e?n.$slides.slice(i-e+r,i+e+1).addClass("slick-active").attr("aria-hidden","false"):(o=n.options.slidesToShow+i,t.slice(o-e+1+r,o+e+2).addClass("slick-active").attr("aria-hidden","false")),0===i?t.eq(t.length-1-n.options.slidesToShow).addClass("slick-center"):i===n.slideCount-1&&t.eq(n.options.slidesToShow).addClass("slick-center")),n.$slides.eq(i).addClass("slick-center")}else i>=0&&i<=n.slideCount-n.options.slidesToShow?n.$slides.slice(i,i+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"):t.length<=n.options.slidesToShow?t.addClass("slick-active").attr("aria-hidden","false"):(s=n.slideCount%n.options.slidesToShow,o=!0===n.options.infinite?n.options.slidesToShow+i:i,n.options.slidesToShow==n.options.slidesToScroll&&n.slideCount-i<n.options.slidesToShow?t.slice(o-(n.options.slidesToShow-s),o+s).addClass("slick-active").attr("aria-hidden","false"):t.slice(o,o+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"));"ondemand"!==n.options.lazyLoad&&"anticipated"!==n.options.lazyLoad||n.lazyLoad()},e.prototype.setupInfinite=function(){var e,t,o,s=this;if(!0===s.options.fade&&(s.options.centerMode=!1),!0===s.options.infinite&&!1===s.options.fade&&(t=null,s.slideCount>s.options.slidesToShow)){for(o=!0===s.options.centerMode?s.options.slidesToShow+1:s.options.slidesToShow,e=s.slideCount;e>s.slideCount-o;e-=1)t=e-1,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t-s.slideCount).prependTo(s.$slideTrack).addClass("slick-cloned");for(e=0;e<o+s.slideCount;e+=1)t=e,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t+s.slideCount).appendTo(s.$slideTrack).addClass("slick-cloned");s.$slideTrack.find(".slick-cloned").find("[id]").each(function(){i(this).attr("id","")})}},e.prototype.interrupt=function(i){var e=this;i||e.autoPlay(),e.interrupted=i},e.prototype.selectHandler=function(e){var t=this,o=i(e.target).is(".slick-slide")?i(e.target):i(e.target).parents(".slick-slide"),s=parseInt(o.attr("data-slick-index"));s||(s=0),t.slideCount<=t.options.slidesToShow?t.slideHandler(s,!1,!0):t.slideHandler(s)},e.prototype.slideHandler=function(i,e,t){var o,s,n,r,l,d=null,a=this;if(e=e||!1,!(!0===a.animating&&!0===a.options.waitForAnimate||!0===a.options.fade&&a.currentSlide===i))if(!1===e&&a.asNavFor(i),o=i,d=a.getLeft(o),r=a.getLeft(a.currentSlide),a.currentLeft=null===a.swipeLeft?r:a.swipeLeft,!1===a.options.infinite&&!1===a.options.centerMode&&(i<0||i>a.getDotCount()*a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else if(!1===a.options.infinite&&!0===a.options.centerMode&&(i<0||i>a.slideCount-a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else{if(a.options.autoplay&&clearInterval(a.autoPlayTimer),s=o<0?a.slideCount%a.options.slidesToScroll!=0?a.slideCount-a.slideCount%a.options.slidesToScroll:a.slideCount+o:o>=a.slideCount?a.slideCount%a.options.slidesToScroll!=0?0:o-a.slideCount:o,a.animating=!0,a.$slider.trigger("beforeChange",[a,a.currentSlide,s]),n=a.currentSlide,a.currentSlide=s,a.setSlideClasses(a.currentSlide),a.options.asNavFor&&(l=(l=a.getNavTarget()).slick("getSlick")).slideCount<=l.options.slidesToShow&&l.setSlideClasses(a.currentSlide),a.updateDots(),a.updateArrows(),!0===a.options.fade)return!0!==t?(a.fadeSlideOut(n),a.fadeSlide(s,function(){a.postSlide(s)})):a.postSlide(s),void a.animateHeight();!0!==t?a.animateSlide(d,function(){a.postSlide(s)}):a.postSlide(s)}},e.prototype.startLoad=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.hide(),i.$nextArrow.hide()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.hide(),i.$slider.addClass("slick-loading")},e.prototype.swipeDirection=function(){var i,e,t,o,s=this;return i=s.touchObject.startX-s.touchObject.curX,e=s.touchObject.startY-s.touchObject.curY,t=Math.atan2(e,i),(o=Math.round(180*t/Math.PI))<0&&(o=360-Math.abs(o)),o<=45&&o>=0?!1===s.options.rtl?"left":"right":o<=360&&o>=315?!1===s.options.rtl?"left":"right":o>=135&&o<=225?!1===s.options.rtl?"right":"left":!0===s.options.verticalSwiping?o>=35&&o<=135?"down":"up":"vertical"},e.prototype.swipeEnd=function(i){var e,t,o=this;if(o.dragging=!1,o.swiping=!1,o.scrolling)return o.scrolling=!1,!1;if(o.interrupted=!1,o.shouldClick=!(o.touchObject.swipeLength>10),void 0===o.touchObject.curX)return!1;if(!0===o.touchObject.edgeHit&&o.$slider.trigger("edge",[o,o.swipeDirection()]),o.touchObject.swipeLength>=o.touchObject.minSwipe){switch(t=o.swipeDirection()){case"left":case"down":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide+o.getSlideCount()):o.currentSlide+o.getSlideCount(),o.currentDirection=0;break;case"right":case"up":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide-o.getSlideCount()):o.currentSlide-o.getSlideCount(),o.currentDirection=1}"vertical"!=t&&(o.slideHandler(e),o.touchObject={},o.$slider.trigger("swipe",[o,t]))}else o.touchObject.startX!==o.touchObject.curX&&(o.slideHandler(o.currentSlide),o.touchObject={})},e.prototype.swipeHandler=function(i){var e=this;if(!(!1===e.options.swipe||"ontouchend"in document&&!1===e.options.swipe||!1===e.options.draggable&&-1!==i.type.indexOf("mouse")))switch(e.touchObject.fingerCount=i.originalEvent&&void 0!==i.originalEvent.touches?i.originalEvent.touches.length:1,e.touchObject.minSwipe=e.listWidth/e.options.touchThreshold,!0===e.options.verticalSwiping&&(e.touchObject.minSwipe=e.listHeight/e.options.touchThreshold),i.data.action){case"start":e.swipeStart(i);break;case"move":e.swipeMove(i);break;case"end":e.swipeEnd(i)}},e.prototype.swipeMove=function(i){var e,t,o,s,n,r,l=this;return n=void 0!==i.originalEvent?i.originalEvent.touches:null,!(!l.dragging||l.scrolling||n&&1!==n.length)&&(e=l.getLeft(l.currentSlide),l.touchObject.curX=void 0!==n?n[0].pageX:i.clientX,l.touchObject.curY=void 0!==n?n[0].pageY:i.clientY,l.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(l.touchObject.curX-l.touchObject.startX,2))),r=Math.round(Math.sqrt(Math.pow(l.touchObject.curY-l.touchObject.startY,2))),!l.options.verticalSwiping&&!l.swiping&&r>4?(l.scrolling=!0,!1):(!0===l.options.verticalSwiping&&(l.touchObject.swipeLength=r),t=l.swipeDirection(),void 0!==i.originalEvent&&l.touchObject.swipeLength>4&&(l.swiping=!0,i.preventDefault()),s=(!1===l.options.rtl?1:-1)*(l.touchObject.curX>l.touchObject.startX?1:-1),!0===l.options.verticalSwiping&&(s=l.touchObject.curY>l.touchObject.startY?1:-1),o=l.touchObject.swipeLength,l.touchObject.edgeHit=!1,!1===l.options.infinite&&(0===l.currentSlide&&"right"===t||l.currentSlide>=l.getDotCount()&&"left"===t)&&(o=l.touchObject.swipeLength*l.options.edgeFriction,l.touchObject.edgeHit=!0),!1===l.options.vertical?l.swipeLeft=e+o*s:l.swipeLeft=e+o*(l.$list.height()/l.listWidth)*s,!0===l.options.verticalSwiping&&(l.swipeLeft=e+o*s),!0!==l.options.fade&&!1!==l.options.touchMove&&(!0===l.animating?(l.swipeLeft=null,!1):void l.setCSS(l.swipeLeft))))},e.prototype.swipeStart=function(i){var e,t=this;if(t.interrupted=!0,1!==t.touchObject.fingerCount||t.slideCount<=t.options.slidesToShow)return t.touchObject={},!1;void 0!==i.originalEvent&&void 0!==i.originalEvent.touches&&(e=i.originalEvent.touches[0]),t.touchObject.startX=t.touchObject.curX=void 0!==e?e.pageX:i.clientX,t.touchObject.startY=t.touchObject.curY=void 0!==e?e.pageY:i.clientY,t.dragging=!0},e.prototype.unfilterSlides=e.prototype.slickUnfilter=function(){var i=this;null!==i.$slidesCache&&(i.unload(),i.$slideTrack.children(this.options.slide).detach(),i.$slidesCache.appendTo(i.$slideTrack),i.reinit())},e.prototype.unload=function(){var e=this;i(".slick-cloned",e.$slider).remove(),e.$dots&&e.$dots.remove(),e.$prevArrow&&e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.remove(),e.$nextArrow&&e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.remove(),e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden","true").css("width","")},e.prototype.unslick=function(i){var e=this;e.$slider.trigger("unslick",[e,i]),e.destroy()},e.prototype.updateArrows=function(){var i=this;Math.floor(i.options.slidesToShow/2),!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&!i.options.infinite&&(i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false"),0===i.currentSlide?(i.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-i.options.slidesToShow&&!1===i.options.centerMode?(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-1&&!0===i.options.centerMode&&(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")))},e.prototype.updateDots=function(){var i=this;null!==i.$dots&&(i.$dots.find("li").removeClass("slick-active").end(),i.$dots.find("li").eq(Math.floor(i.currentSlide/i.options.slidesToScroll)).addClass("slick-active"))},e.prototype.visibility=function(){var i=this;i.options.autoplay&&(document[i.hidden]?i.interrupted=!0:i.interrupted=!1)},i.fn.slick=function(){var i,t,o=this,s=arguments[0],n=Array.prototype.slice.call(arguments,1),r=o.length;for(i=0;i<r;i++)if("object"==typeof s||void 0===s?o[i].slick=new e(o[i],s):t=o[i].slick[s].apply(o[i].slick,n),void 0!==t)return t;return o}});

// /*! jQuery UI - v1.11.4 - 2016-05-10
// * http://jqueryui.com
// * Includes: core.js, widget.js, mouse.js, position.js, draggable.js
// * Copyright jQuery Foundation and other contributors; Licensed MIT */

// (function(t){"function"==typeof define&&define.amd?define(["jquery"],t):t(jQuery)})(function(t){function e(e,s){var n,a,o,r=e.nodeName.toLowerCase();return"area"===r?(n=e.parentNode,a=n.name,e.href&&a&&"map"===n.nodeName.toLowerCase()?(o=t("img[usemap='#"+a+"']")[0],!!o&&i(o)):!1):(/^(input|select|textarea|button|object)$/.test(r)?!e.disabled:"a"===r?e.href||s:s)&&i(e)}function i(e){return t.expr.filters.visible(e)&&!t(e).parents().addBack().filter(function(){return"hidden"===t.css(this,"visibility")}).length}t.ui=t.ui||{},t.extend(t.ui,{version:"1.11.4",keyCode:{BACKSPACE:8,COMMA:188,DELETE:46,DOWN:40,END:35,ENTER:13,ESCAPE:27,HOME:36,LEFT:37,PAGE_DOWN:34,PAGE_UP:33,PERIOD:190,RIGHT:39,SPACE:32,TAB:9,UP:38}}),t.fn.extend({scrollParent:function(e){var i=this.css("position"),s="absolute"===i,n=e?/(auto|scroll|hidden)/:/(auto|scroll)/,a=this.parents().filter(function(){var e=t(this);return s&&"static"===e.css("position")?!1:n.test(e.css("overflow")+e.css("overflow-y")+e.css("overflow-x"))}).eq(0);return"fixed"!==i&&a.length?a:t(this[0].ownerDocument||document)},uniqueId:function(){var t=0;return function(){return this.each(function(){this.id||(this.id="ui-id-"+ ++t)})}}(),removeUniqueId:function(){return this.each(function(){/^ui-id-\d+$/.test(this.id)&&t(this).removeAttr("id")})}}),t.extend(t.expr[":"],{data:t.expr.createPseudo?t.expr.createPseudo(function(e){return function(i){return!!t.data(i,e)}}):function(e,i,s){return!!t.data(e,s[3])},focusable:function(i){return e(i,!isNaN(t.attr(i,"tabindex")))},tabbable:function(i){var s=t.attr(i,"tabindex"),n=isNaN(s);return(n||s>=0)&&e(i,!n)}}),t("<a>").outerWidth(1).jquery||t.each(["Width","Height"],function(e,i){function s(e,i,s,a){return t.each(n,function(){i-=parseFloat(t.css(e,"padding"+this))||0,s&&(i-=parseFloat(t.css(e,"border"+this+"Width"))||0),a&&(i-=parseFloat(t.css(e,"margin"+this))||0)}),i}var n="Width"===i?["Left","Right"]:["Top","Bottom"],a=i.toLowerCase(),o={innerWidth:t.fn.innerWidth,innerHeight:t.fn.innerHeight,outerWidth:t.fn.outerWidth,outerHeight:t.fn.outerHeight};t.fn["inner"+i]=function(e){return void 0===e?o["inner"+i].call(this):this.each(function(){t(this).css(a,s(this,e)+"px")})},t.fn["outer"+i]=function(e,n){return"number"!=typeof e?o["outer"+i].call(this,e):this.each(function(){t(this).css(a,s(this,e,!0,n)+"px")})}}),t.fn.addBack||(t.fn.addBack=function(t){return this.add(null==t?this.prevObject:this.prevObject.filter(t))}),t("<a>").data("a-b","a").removeData("a-b").data("a-b")&&(t.fn.removeData=function(e){return function(i){return arguments.length?e.call(this,t.camelCase(i)):e.call(this)}}(t.fn.removeData)),t.ui.ie=!!/msie [\w.]+/.exec(navigator.userAgent.toLowerCase()),t.fn.extend({focus:function(e){return function(i,s){return"number"==typeof i?this.each(function(){var e=this;setTimeout(function(){t(e).focus(),s&&s.call(e)},i)}):e.apply(this,arguments)}}(t.fn.focus),disableSelection:function(){var t="onselectstart"in document.createElement("div")?"selectstart":"mousedown";return function(){return this.bind(t+".ui-disableSelection",function(t){t.preventDefault()})}}(),enableSelection:function(){return this.unbind(".ui-disableSelection")},zIndex:function(e){if(void 0!==e)return this.css("zIndex",e);if(this.length)for(var i,s,n=t(this[0]);n.length&&n[0]!==document;){if(i=n.css("position"),("absolute"===i||"relative"===i||"fixed"===i)&&(s=parseInt(n.css("zIndex"),10),!isNaN(s)&&0!==s))return s;n=n.parent()}return 0}}),t.ui.plugin={add:function(e,i,s){var n,a=t.ui[e].prototype;for(n in s)a.plugins[n]=a.plugins[n]||[],a.plugins[n].push([i,s[n]])},call:function(t,e,i,s){var n,a=t.plugins[e];if(a&&(s||t.element[0].parentNode&&11!==t.element[0].parentNode.nodeType))for(n=0;a.length>n;n++)t.options[a[n][0]]&&a[n][1].apply(t.element,i)}};var s=0,n=Array.prototype.slice;t.cleanData=function(e){return function(i){var s,n,a;for(a=0;null!=(n=i[a]);a++)try{s=t._data(n,"events"),s&&s.remove&&t(n).triggerHandler("remove")}catch(o){}e(i)}}(t.cleanData),t.widget=function(e,i,s){var n,a,o,r,h={},l=e.split(".")[0];return e=e.split(".")[1],n=l+"-"+e,s||(s=i,i=t.Widget),t.expr[":"][n.toLowerCase()]=function(e){return!!t.data(e,n)},t[l]=t[l]||{},a=t[l][e],o=t[l][e]=function(t,e){return this._createWidget?(arguments.length&&this._createWidget(t,e),void 0):new o(t,e)},t.extend(o,a,{version:s.version,_proto:t.extend({},s),_childConstructors:[]}),r=new i,r.options=t.widget.extend({},r.options),t.each(s,function(e,s){return t.isFunction(s)?(h[e]=function(){var t=function(){return i.prototype[e].apply(this,arguments)},n=function(t){return i.prototype[e].apply(this,t)};return function(){var e,i=this._super,a=this._superApply;return this._super=t,this._superApply=n,e=s.apply(this,arguments),this._super=i,this._superApply=a,e}}(),void 0):(h[e]=s,void 0)}),o.prototype=t.widget.extend(r,{widgetEventPrefix:a?r.widgetEventPrefix||e:e},h,{constructor:o,namespace:l,widgetName:e,widgetFullName:n}),a?(t.each(a._childConstructors,function(e,i){var s=i.prototype;t.widget(s.namespace+"."+s.widgetName,o,i._proto)}),delete a._childConstructors):i._childConstructors.push(o),t.widget.bridge(e,o),o},t.widget.extend=function(e){for(var i,s,a=n.call(arguments,1),o=0,r=a.length;r>o;o++)for(i in a[o])s=a[o][i],a[o].hasOwnProperty(i)&&void 0!==s&&(e[i]=t.isPlainObject(s)?t.isPlainObject(e[i])?t.widget.extend({},e[i],s):t.widget.extend({},s):s);return e},t.widget.bridge=function(e,i){var s=i.prototype.widgetFullName||e;t.fn[e]=function(a){var o="string"==typeof a,r=n.call(arguments,1),h=this;return o?this.each(function(){var i,n=t.data(this,s);return"instance"===a?(h=n,!1):n?t.isFunction(n[a])&&"_"!==a.charAt(0)?(i=n[a].apply(n,r),i!==n&&void 0!==i?(h=i&&i.jquery?h.pushStack(i.get()):i,!1):void 0):t.error("no such method '"+a+"' for "+e+" widget instance"):t.error("cannot call methods on "+e+" prior to initialization; "+"attempted to call method '"+a+"'")}):(r.length&&(a=t.widget.extend.apply(null,[a].concat(r))),this.each(function(){var e=t.data(this,s);e?(e.option(a||{}),e._init&&e._init()):t.data(this,s,new i(a,this))})),h}},t.Widget=function(){},t.Widget._childConstructors=[],t.Widget.prototype={widgetName:"widget",widgetEventPrefix:"",defaultElement:"<div>",options:{disabled:!1,create:null},_createWidget:function(e,i){i=t(i||this.defaultElement||this)[0],this.element=t(i),this.uuid=s++,this.eventNamespace="."+this.widgetName+this.uuid,this.bindings=t(),this.hoverable=t(),this.focusable=t(),i!==this&&(t.data(i,this.widgetFullName,this),this._on(!0,this.element,{remove:function(t){t.target===i&&this.destroy()}}),this.document=t(i.style?i.ownerDocument:i.document||i),this.window=t(this.document[0].defaultView||this.document[0].parentWindow)),this.options=t.widget.extend({},this.options,this._getCreateOptions(),e),this._create(),this._trigger("create",null,this._getCreateEventData()),this._init()},_getCreateOptions:t.noop,_getCreateEventData:t.noop,_create:t.noop,_init:t.noop,destroy:function(){this._destroy(),this.element.unbind(this.eventNamespace).removeData(this.widgetFullName).removeData(t.camelCase(this.widgetFullName)),this.widget().unbind(this.eventNamespace).removeAttr("aria-disabled").removeClass(this.widgetFullName+"-disabled "+"ui-state-disabled"),this.bindings.unbind(this.eventNamespace),this.hoverable.removeClass("ui-state-hover"),this.focusable.removeClass("ui-state-focus")},_destroy:t.noop,widget:function(){return this.element},option:function(e,i){var s,n,a,o=e;if(0===arguments.length)return t.widget.extend({},this.options);if("string"==typeof e)if(o={},s=e.split("."),e=s.shift(),s.length){for(n=o[e]=t.widget.extend({},this.options[e]),a=0;s.length-1>a;a++)n[s[a]]=n[s[a]]||{},n=n[s[a]];if(e=s.pop(),1===arguments.length)return void 0===n[e]?null:n[e];n[e]=i}else{if(1===arguments.length)return void 0===this.options[e]?null:this.options[e];o[e]=i}return this._setOptions(o),this},_setOptions:function(t){var e;for(e in t)this._setOption(e,t[e]);return this},_setOption:function(t,e){return this.options[t]=e,"disabled"===t&&(this.widget().toggleClass(this.widgetFullName+"-disabled",!!e),e&&(this.hoverable.removeClass("ui-state-hover"),this.focusable.removeClass("ui-state-focus"))),this},enable:function(){return this._setOptions({disabled:!1})},disable:function(){return this._setOptions({disabled:!0})},_on:function(e,i,s){var n,a=this;"boolean"!=typeof e&&(s=i,i=e,e=!1),s?(i=n=t(i),this.bindings=this.bindings.add(i)):(s=i,i=this.element,n=this.widget()),t.each(s,function(s,o){function r(){return e||a.options.disabled!==!0&&!t(this).hasClass("ui-state-disabled")?("string"==typeof o?a[o]:o).apply(a,arguments):void 0}"string"!=typeof o&&(r.guid=o.guid=o.guid||r.guid||t.guid++);var h=s.match(/^([\w:-]*)\s*(.*)$/),l=h[1]+a.eventNamespace,u=h[2];u?n.delegate(u,l,r):i.bind(l,r)})},_off:function(e,i){i=(i||"").split(" ").join(this.eventNamespace+" ")+this.eventNamespace,e.unbind(i).undelegate(i),this.bindings=t(this.bindings.not(e).get()),this.focusable=t(this.focusable.not(e).get()),this.hoverable=t(this.hoverable.not(e).get())},_delay:function(t,e){function i(){return("string"==typeof t?s[t]:t).apply(s,arguments)}var s=this;return setTimeout(i,e||0)},_hoverable:function(e){this.hoverable=this.hoverable.add(e),this._on(e,{mouseenter:function(e){t(e.currentTarget).addClass("ui-state-hover")},mouseleave:function(e){t(e.currentTarget).removeClass("ui-state-hover")}})},_focusable:function(e){this.focusable=this.focusable.add(e),this._on(e,{focusin:function(e){t(e.currentTarget).addClass("ui-state-focus")},focusout:function(e){t(e.currentTarget).removeClass("ui-state-focus")}})},_trigger:function(e,i,s){var n,a,o=this.options[e];if(s=s||{},i=t.Event(i),i.type=(e===this.widgetEventPrefix?e:this.widgetEventPrefix+e).toLowerCase(),i.target=this.element[0],a=i.originalEvent)for(n in a)n in i||(i[n]=a[n]);return this.element.trigger(i,s),!(t.isFunction(o)&&o.apply(this.element[0],[i].concat(s))===!1||i.isDefaultPrevented())}},t.each({show:"fadeIn",hide:"fadeOut"},function(e,i){t.Widget.prototype["_"+e]=function(s,n,a){"string"==typeof n&&(n={effect:n});var o,r=n?n===!0||"number"==typeof n?i:n.effect||i:e;n=n||{},"number"==typeof n&&(n={duration:n}),o=!t.isEmptyObject(n),n.complete=a,n.delay&&s.delay(n.delay),o&&t.effects&&t.effects.effect[r]?s[e](n):r!==e&&s[r]?s[r](n.duration,n.easing,a):s.queue(function(i){t(this)[e](),a&&a.call(s[0]),i()})}}),t.widget;var a=!1;t(document).mouseup(function(){a=!1}),t.widget("ui.mouse",{version:"1.11.4",options:{cancel:"input,textarea,button,select,option",distance:1,delay:0},_mouseInit:function(){var e=this;this.element.bind("mousedown."+this.widgetName,function(t){return e._mouseDown(t)}).bind("click."+this.widgetName,function(i){return!0===t.data(i.target,e.widgetName+".preventClickEvent")?(t.removeData(i.target,e.widgetName+".preventClickEvent"),i.stopImmediatePropagation(),!1):void 0}),this.started=!1},_mouseDestroy:function(){this.element.unbind("."+this.widgetName),this._mouseMoveDelegate&&this.document.unbind("mousemove."+this.widgetName,this._mouseMoveDelegate).unbind("mouseup."+this.widgetName,this._mouseUpDelegate)},_mouseDown:function(e){if(!a){this._mouseMoved=!1,this._mouseStarted&&this._mouseUp(e),this._mouseDownEvent=e;var i=this,s=1===e.which,n="string"==typeof this.options.cancel&&e.target.nodeName?t(e.target).closest(this.options.cancel).length:!1;return s&&!n&&this._mouseCapture(e)?(this.mouseDelayMet=!this.options.delay,this.mouseDelayMet||(this._mouseDelayTimer=setTimeout(function(){i.mouseDelayMet=!0},this.options.delay)),this._mouseDistanceMet(e)&&this._mouseDelayMet(e)&&(this._mouseStarted=this._mouseStart(e)!==!1,!this._mouseStarted)?(e.preventDefault(),!0):(!0===t.data(e.target,this.widgetName+".preventClickEvent")&&t.removeData(e.target,this.widgetName+".preventClickEvent"),this._mouseMoveDelegate=function(t){return i._mouseMove(t)},this._mouseUpDelegate=function(t){return i._mouseUp(t)},this.document.bind("mousemove."+this.widgetName,this._mouseMoveDelegate).bind("mouseup."+this.widgetName,this._mouseUpDelegate),e.preventDefault(),a=!0,!0)):!0}},_mouseMove:function(e){if(this._mouseMoved){if(t.ui.ie&&(!document.documentMode||9>document.documentMode)&&!e.button)return this._mouseUp(e);if(!e.which)return this._mouseUp(e)}return(e.which||e.button)&&(this._mouseMoved=!0),this._mouseStarted?(this._mouseDrag(e),e.preventDefault()):(this._mouseDistanceMet(e)&&this._mouseDelayMet(e)&&(this._mouseStarted=this._mouseStart(this._mouseDownEvent,e)!==!1,this._mouseStarted?this._mouseDrag(e):this._mouseUp(e)),!this._mouseStarted)},_mouseUp:function(e){return this.document.unbind("mousemove."+this.widgetName,this._mouseMoveDelegate).unbind("mouseup."+this.widgetName,this._mouseUpDelegate),this._mouseStarted&&(this._mouseStarted=!1,e.target===this._mouseDownEvent.target&&t.data(e.target,this.widgetName+".preventClickEvent",!0),this._mouseStop(e)),a=!1,!1},_mouseDistanceMet:function(t){return Math.max(Math.abs(this._mouseDownEvent.pageX-t.pageX),Math.abs(this._mouseDownEvent.pageY-t.pageY))>=this.options.distance},_mouseDelayMet:function(){return this.mouseDelayMet},_mouseStart:function(){},_mouseDrag:function(){},_mouseStop:function(){},_mouseCapture:function(){return!0}}),function(){function e(t,e,i){return[parseFloat(t[0])*(p.test(t[0])?e/100:1),parseFloat(t[1])*(p.test(t[1])?i/100:1)]}function i(e,i){return parseInt(t.css(e,i),10)||0}function s(e){var i=e[0];return 9===i.nodeType?{width:e.width(),height:e.height(),offset:{top:0,left:0}}:t.isWindow(i)?{width:e.width(),height:e.height(),offset:{top:e.scrollTop(),left:e.scrollLeft()}}:i.preventDefault?{width:0,height:0,offset:{top:i.pageY,left:i.pageX}}:{width:e.outerWidth(),height:e.outerHeight(),offset:e.offset()}}t.ui=t.ui||{};var n,a,o=Math.max,r=Math.abs,h=Math.round,l=/left|center|right/,u=/top|center|bottom/,c=/[\+\-]\d+(\.[\d]+)?%?/,d=/^\w+/,p=/%$/,f=t.fn.position;t.position={scrollbarWidth:function(){if(void 0!==n)return n;var e,i,s=t("<div style='display:block;position:absolute;width:50px;height:50px;overflow:hidden;'><div style='height:100px;width:auto;'></div></div>"),a=s.children()[0];return t("body").append(s),e=a.offsetWidth,s.css("overflow","scroll"),i=a.offsetWidth,e===i&&(i=s[0].clientWidth),s.remove(),n=e-i},getScrollInfo:function(e){var i=e.isWindow||e.isDocument?"":e.element.css("overflow-x"),s=e.isWindow||e.isDocument?"":e.element.css("overflow-y"),n="scroll"===i||"auto"===i&&e.width<e.element[0].scrollWidth,a="scroll"===s||"auto"===s&&e.height<e.element[0].scrollHeight;return{width:a?t.position.scrollbarWidth():0,height:n?t.position.scrollbarWidth():0}},getWithinInfo:function(e){var i=t(e||window),s=t.isWindow(i[0]),n=!!i[0]&&9===i[0].nodeType;return{element:i,isWindow:s,isDocument:n,offset:i.offset()||{left:0,top:0},scrollLeft:i.scrollLeft(),scrollTop:i.scrollTop(),width:s||n?i.width():i.outerWidth(),height:s||n?i.height():i.outerHeight()}}},t.fn.position=function(n){if(!n||!n.of)return f.apply(this,arguments);n=t.extend({},n);var p,m,g,v,_,b,y=t(n.of),x=t.position.getWithinInfo(n.within),w=t.position.getScrollInfo(x),k=(n.collision||"flip").split(" "),D={};return b=s(y),y[0].preventDefault&&(n.at="left top"),m=b.width,g=b.height,v=b.offset,_=t.extend({},v),t.each(["my","at"],function(){var t,e,i=(n[this]||"").split(" ");1===i.length&&(i=l.test(i[0])?i.concat(["center"]):u.test(i[0])?["center"].concat(i):["center","center"]),i[0]=l.test(i[0])?i[0]:"center",i[1]=u.test(i[1])?i[1]:"center",t=c.exec(i[0]),e=c.exec(i[1]),D[this]=[t?t[0]:0,e?e[0]:0],n[this]=[d.exec(i[0])[0],d.exec(i[1])[0]]}),1===k.length&&(k[1]=k[0]),"right"===n.at[0]?_.left+=m:"center"===n.at[0]&&(_.left+=m/2),"bottom"===n.at[1]?_.top+=g:"center"===n.at[1]&&(_.top+=g/2),p=e(D.at,m,g),_.left+=p[0],_.top+=p[1],this.each(function(){var s,l,u=t(this),c=u.outerWidth(),d=u.outerHeight(),f=i(this,"marginLeft"),b=i(this,"marginTop"),T=c+f+i(this,"marginRight")+w.width,S=d+b+i(this,"marginBottom")+w.height,M=t.extend({},_),C=e(D.my,u.outerWidth(),u.outerHeight());"right"===n.my[0]?M.left-=c:"center"===n.my[0]&&(M.left-=c/2),"bottom"===n.my[1]?M.top-=d:"center"===n.my[1]&&(M.top-=d/2),M.left+=C[0],M.top+=C[1],a||(M.left=h(M.left),M.top=h(M.top)),s={marginLeft:f,marginTop:b},t.each(["left","top"],function(e,i){t.ui.position[k[e]]&&t.ui.position[k[e]][i](M,{targetWidth:m,targetHeight:g,elemWidth:c,elemHeight:d,collisionPosition:s,collisionWidth:T,collisionHeight:S,offset:[p[0]+C[0],p[1]+C[1]],my:n.my,at:n.at,within:x,elem:u})}),n.using&&(l=function(t){var e=v.left-M.left,i=e+m-c,s=v.top-M.top,a=s+g-d,h={target:{element:y,left:v.left,top:v.top,width:m,height:g},element:{element:u,left:M.left,top:M.top,width:c,height:d},horizontal:0>i?"left":e>0?"right":"center",vertical:0>a?"top":s>0?"bottom":"middle"};c>m&&m>r(e+i)&&(h.horizontal="center"),d>g&&g>r(s+a)&&(h.vertical="middle"),h.important=o(r(e),r(i))>o(r(s),r(a))?"horizontal":"vertical",n.using.call(this,t,h)}),u.offset(t.extend(M,{using:l}))})},t.ui.position={fit:{left:function(t,e){var i,s=e.within,n=s.isWindow?s.scrollLeft:s.offset.left,a=s.width,r=t.left-e.collisionPosition.marginLeft,h=n-r,l=r+e.collisionWidth-a-n;e.collisionWidth>a?h>0&&0>=l?(i=t.left+h+e.collisionWidth-a-n,t.left+=h-i):t.left=l>0&&0>=h?n:h>l?n+a-e.collisionWidth:n:h>0?t.left+=h:l>0?t.left-=l:t.left=o(t.left-r,t.left)},top:function(t,e){var i,s=e.within,n=s.isWindow?s.scrollTop:s.offset.top,a=e.within.height,r=t.top-e.collisionPosition.marginTop,h=n-r,l=r+e.collisionHeight-a-n;e.collisionHeight>a?h>0&&0>=l?(i=t.top+h+e.collisionHeight-a-n,t.top+=h-i):t.top=l>0&&0>=h?n:h>l?n+a-e.collisionHeight:n:h>0?t.top+=h:l>0?t.top-=l:t.top=o(t.top-r,t.top)}},flip:{left:function(t,e){var i,s,n=e.within,a=n.offset.left+n.scrollLeft,o=n.width,h=n.isWindow?n.scrollLeft:n.offset.left,l=t.left-e.collisionPosition.marginLeft,u=l-h,c=l+e.collisionWidth-o-h,d="left"===e.my[0]?-e.elemWidth:"right"===e.my[0]?e.elemWidth:0,p="left"===e.at[0]?e.targetWidth:"right"===e.at[0]?-e.targetWidth:0,f=-2*e.offset[0];0>u?(i=t.left+d+p+f+e.collisionWidth-o-a,(0>i||r(u)>i)&&(t.left+=d+p+f)):c>0&&(s=t.left-e.collisionPosition.marginLeft+d+p+f-h,(s>0||c>r(s))&&(t.left+=d+p+f))},top:function(t,e){var i,s,n=e.within,a=n.offset.top+n.scrollTop,o=n.height,h=n.isWindow?n.scrollTop:n.offset.top,l=t.top-e.collisionPosition.marginTop,u=l-h,c=l+e.collisionHeight-o-h,d="top"===e.my[1],p=d?-e.elemHeight:"bottom"===e.my[1]?e.elemHeight:0,f="top"===e.at[1]?e.targetHeight:"bottom"===e.at[1]?-e.targetHeight:0,m=-2*e.offset[1];0>u?(s=t.top+p+f+m+e.collisionHeight-o-a,(0>s||r(u)>s)&&(t.top+=p+f+m)):c>0&&(i=t.top-e.collisionPosition.marginTop+p+f+m-h,(i>0||c>r(i))&&(t.top+=p+f+m))}},flipfit:{left:function(){t.ui.position.flip.left.apply(this,arguments),t.ui.position.fit.left.apply(this,arguments)},top:function(){t.ui.position.flip.top.apply(this,arguments),t.ui.position.fit.top.apply(this,arguments)}}},function(){var e,i,s,n,o,r=document.getElementsByTagName("body")[0],h=document.createElement("div");e=document.createElement(r?"div":"body"),s={visibility:"hidden",width:0,height:0,border:0,margin:0,background:"none"},r&&t.extend(s,{position:"absolute",left:"-1000px",top:"-1000px"});for(o in s)e.style[o]=s[o];e.appendChild(h),i=r||document.documentElement,i.insertBefore(e,i.firstChild),h.style.cssText="position: absolute; left: 10.7432222px;",n=t(h).offset().left,a=n>10&&11>n,e.innerHTML="",i.removeChild(e)}()}(),t.ui.position,t.widget("ui.draggable",t.ui.mouse,{version:"1.11.4",widgetEventPrefix:"drag",options:{addClasses:!0,appendTo:"parent",axis:!1,connectToSortable:!1,containment:!1,cursor:"auto",cursorAt:!1,grid:!1,handle:!1,helper:"original",iframeFix:!1,opacity:!1,refreshPositions:!1,revert:!1,revertDuration:500,scope:"default",scroll:!0,scrollSensitivity:20,scrollSpeed:20,snap:!1,snapMode:"both",snapTolerance:20,stack:!1,zIndex:!1,drag:null,start:null,stop:null},_create:function(){"original"===this.options.helper&&this._setPositionRelative(),this.options.addClasses&&this.element.addClass("ui-draggable"),this.options.disabled&&this.element.addClass("ui-draggable-disabled"),this._setHandleClassName(),this._mouseInit()},_setOption:function(t,e){this._super(t,e),"handle"===t&&(this._removeHandleClassName(),this._setHandleClassName())},_destroy:function(){return(this.helper||this.element).is(".ui-draggable-dragging")?(this.destroyOnClear=!0,void 0):(this.element.removeClass("ui-draggable ui-draggable-dragging ui-draggable-disabled"),this._removeHandleClassName(),this._mouseDestroy(),void 0)},_mouseCapture:function(e){var i=this.options;return this._blurActiveElement(e),this.helper||i.disabled||t(e.target).closest(".ui-resizable-handle").length>0?!1:(this.handle=this._getHandle(e),this.handle?(this._blockFrames(i.iframeFix===!0?"iframe":i.iframeFix),!0):!1)},_blockFrames:function(e){this.iframeBlocks=this.document.find(e).map(function(){var e=t(this);return t("<div>").css("position","absolute").appendTo(e.parent()).outerWidth(e.outerWidth()).outerHeight(e.outerHeight()).offset(e.offset())[0]})},_unblockFrames:function(){this.iframeBlocks&&(this.iframeBlocks.remove(),delete this.iframeBlocks)},_blurActiveElement:function(e){var i=this.document[0];if(this.handleElement.is(e.target))try{i.activeElement&&"body"!==i.activeElement.nodeName.toLowerCase()&&t(i.activeElement).blur()}catch(s){}},_mouseStart:function(e){var i=this.options;return this.helper=this._createHelper(e),this.helper.addClass("ui-draggable-dragging"),this._cacheHelperProportions(),t.ui.ddmanager&&(t.ui.ddmanager.current=this),this._cacheMargins(),this.cssPosition=this.helper.css("position"),this.scrollParent=this.helper.scrollParent(!0),this.offsetParent=this.helper.offsetParent(),this.hasFixedAncestor=this.helper.parents().filter(function(){return"fixed"===t(this).css("position")}).length>0,this.positionAbs=this.element.offset(),this._refreshOffsets(e),this.originalPosition=this.position=this._generatePosition(e,!1),this.originalPageX=e.pageX,this.originalPageY=e.pageY,i.cursorAt&&this._adjustOffsetFromHelper(i.cursorAt),this._setContainment(),this._trigger("start",e)===!1?(this._clear(),!1):(this._cacheHelperProportions(),t.ui.ddmanager&&!i.dropBehaviour&&t.ui.ddmanager.prepareOffsets(this,e),this._normalizeRightBottom(),this._mouseDrag(e,!0),t.ui.ddmanager&&t.ui.ddmanager.dragStart(this,e),!0)},_refreshOffsets:function(t){this.offset={top:this.positionAbs.top-this.margins.top,left:this.positionAbs.left-this.margins.left,scroll:!1,parent:this._getParentOffset(),relative:this._getRelativeOffset()},this.offset.click={left:t.pageX-this.offset.left,top:t.pageY-this.offset.top}},_mouseDrag:function(e,i){if(this.hasFixedAncestor&&(this.offset.parent=this._getParentOffset()),this.position=this._generatePosition(e,!0),this.positionAbs=this._convertPositionTo("absolute"),!i){var s=this._uiHash();if(this._trigger("drag",e,s)===!1)return this._mouseUp({}),!1;this.position=s.position}return this.helper[0].style.left=this.position.left+"px",this.helper[0].style.top=this.position.top+"px",t.ui.ddmanager&&t.ui.ddmanager.drag(this,e),!1},_mouseStop:function(e){var i=this,s=!1;return t.ui.ddmanager&&!this.options.dropBehaviour&&(s=t.ui.ddmanager.drop(this,e)),this.dropped&&(s=this.dropped,this.dropped=!1),"invalid"===this.options.revert&&!s||"valid"===this.options.revert&&s||this.options.revert===!0||t.isFunction(this.options.revert)&&this.options.revert.call(this.element,s)?t(this.helper).animate(this.originalPosition,parseInt(this.options.revertDuration,10),function(){i._trigger("stop",e)!==!1&&i._clear()}):this._trigger("stop",e)!==!1&&this._clear(),!1},_mouseUp:function(e){return this._unblockFrames(),t.ui.ddmanager&&t.ui.ddmanager.dragStop(this,e),this.handleElement.is(e.target)&&this.element.focus(),t.ui.mouse.prototype._mouseUp.call(this,e)},cancel:function(){return this.helper.is(".ui-draggable-dragging")?this._mouseUp({}):this._clear(),this},_getHandle:function(e){return this.options.handle?!!t(e.target).closest(this.element.find(this.options.handle)).length:!0},_setHandleClassName:function(){this.handleElement=this.options.handle?this.element.find(this.options.handle):this.element,this.handleElement.addClass("ui-draggable-handle")},_removeHandleClassName:function(){this.handleElement.removeClass("ui-draggable-handle")},_createHelper:function(e){var i=this.options,s=t.isFunction(i.helper),n=s?t(i.helper.apply(this.element[0],[e])):"clone"===i.helper?this.element.clone().removeAttr("id"):this.element;return n.parents("body").length||n.appendTo("parent"===i.appendTo?this.element[0].parentNode:i.appendTo),s&&n[0]===this.element[0]&&this._setPositionRelative(),n[0]===this.element[0]||/(fixed|absolute)/.test(n.css("position"))||n.css("position","absolute"),n},_setPositionRelative:function(){/^(?:r|a|f)/.test(this.element.css("position"))||(this.element[0].style.position="relative")},_adjustOffsetFromHelper:function(e){"string"==typeof e&&(e=e.split(" ")),t.isArray(e)&&(e={left:+e[0],top:+e[1]||0}),"left"in e&&(this.offset.click.left=e.left+this.margins.left),"right"in e&&(this.offset.click.left=this.helperProportions.width-e.right+this.margins.left),"top"in e&&(this.offset.click.top=e.top+this.margins.top),"bottom"in e&&(this.offset.click.top=this.helperProportions.height-e.bottom+this.margins.top)},_isRootNode:function(t){return/(html|body)/i.test(t.tagName)||t===this.document[0]},_getParentOffset:function(){var e=this.offsetParent.offset(),i=this.document[0];return"absolute"===this.cssPosition&&this.scrollParent[0]!==i&&t.contains(this.scrollParent[0],this.offsetParent[0])&&(e.left+=this.scrollParent.scrollLeft(),e.top+=this.scrollParent.scrollTop()),this._isRootNode(this.offsetParent[0])&&(e={top:0,left:0}),{top:e.top+(parseInt(this.offsetParent.css("borderTopWidth"),10)||0),left:e.left+(parseInt(this.offsetParent.css("borderLeftWidth"),10)||0)}},_getRelativeOffset:function(){if("relative"!==this.cssPosition)return{top:0,left:0};var t=this.element.position(),e=this._isRootNode(this.scrollParent[0]);return{top:t.top-(parseInt(this.helper.css("top"),10)||0)+(e?0:this.scrollParent.scrollTop()),left:t.left-(parseInt(this.helper.css("left"),10)||0)+(e?0:this.scrollParent.scrollLeft())}},_cacheMargins:function(){this.margins={left:parseInt(this.element.css("marginLeft"),10)||0,top:parseInt(this.element.css("marginTop"),10)||0,right:parseInt(this.element.css("marginRight"),10)||0,bottom:parseInt(this.element.css("marginBottom"),10)||0}},_cacheHelperProportions:function(){this.helperProportions={width:this.helper.outerWidth(),height:this.helper.outerHeight()}},_setContainment:function(){var e,i,s,n=this.options,a=this.document[0];return this.relativeContainer=null,n.containment?"window"===n.containment?(this.containment=[t(window).scrollLeft()-this.offset.relative.left-this.offset.parent.left,t(window).scrollTop()-this.offset.relative.top-this.offset.parent.top,t(window).scrollLeft()+t(window).width()-this.helperProportions.width-this.margins.left,t(window).scrollTop()+(t(window).height()||a.body.parentNode.scrollHeight)-this.helperProportions.height-this.margins.top],void 0):"document"===n.containment?(this.containment=[0,0,t(a).width()-this.helperProportions.width-this.margins.left,(t(a).height()||a.body.parentNode.scrollHeight)-this.helperProportions.height-this.margins.top],void 0):n.containment.constructor===Array?(this.containment=n.containment,void 0):("parent"===n.containment&&(n.containment=this.helper[0].parentNode),i=t(n.containment),s=i[0],s&&(e=/(scroll|auto)/.test(i.css("overflow")),this.containment=[(parseInt(i.css("borderLeftWidth"),10)||0)+(parseInt(i.css("paddingLeft"),10)||0),(parseInt(i.css("borderTopWidth"),10)||0)+(parseInt(i.css("paddingTop"),10)||0),(e?Math.max(s.scrollWidth,s.offsetWidth):s.offsetWidth)-(parseInt(i.css("borderRightWidth"),10)||0)-(parseInt(i.css("paddingRight"),10)||0)-this.helperProportions.width-this.margins.left-this.margins.right,(e?Math.max(s.scrollHeight,s.offsetHeight):s.offsetHeight)-(parseInt(i.css("borderBottomWidth"),10)||0)-(parseInt(i.css("paddingBottom"),10)||0)-this.helperProportions.height-this.margins.top-this.margins.bottom],this.relativeContainer=i),void 0):(this.containment=null,void 0)},_convertPositionTo:function(t,e){e||(e=this.position);var i="absolute"===t?1:-1,s=this._isRootNode(this.scrollParent[0]);return{top:e.top+this.offset.relative.top*i+this.offset.parent.top*i-("fixed"===this.cssPosition?-this.offset.scroll.top:s?0:this.offset.scroll.top)*i,left:e.left+this.offset.relative.left*i+this.offset.parent.left*i-("fixed"===this.cssPosition?-this.offset.scroll.left:s?0:this.offset.scroll.left)*i}},_generatePosition:function(t,e){var i,s,n,a,o=this.options,r=this._isRootNode(this.scrollParent[0]),h=t.pageX,l=t.pageY;return r&&this.offset.scroll||(this.offset.scroll={top:this.scrollParent.scrollTop(),left:this.scrollParent.scrollLeft()}),e&&(this.containment&&(this.relativeContainer?(s=this.relativeContainer.offset(),i=[this.containment[0]+s.left,this.containment[1]+s.top,this.containment[2]+s.left,this.containment[3]+s.top]):i=this.containment,t.pageX-this.offset.click.left<i[0]&&(h=i[0]+this.offset.click.left),t.pageY-this.offset.click.top<i[1]&&(l=i[1]+this.offset.click.top),t.pageX-this.offset.click.left>i[2]&&(h=i[2]+this.offset.click.left),t.pageY-this.offset.click.top>i[3]&&(l=i[3]+this.offset.click.top)),o.grid&&(n=o.grid[1]?this.originalPageY+Math.round((l-this.originalPageY)/o.grid[1])*o.grid[1]:this.originalPageY,l=i?n-this.offset.click.top>=i[1]||n-this.offset.click.top>i[3]?n:n-this.offset.click.top>=i[1]?n-o.grid[1]:n+o.grid[1]:n,a=o.grid[0]?this.originalPageX+Math.round((h-this.originalPageX)/o.grid[0])*o.grid[0]:this.originalPageX,h=i?a-this.offset.click.left>=i[0]||a-this.offset.click.left>i[2]?a:a-this.offset.click.left>=i[0]?a-o.grid[0]:a+o.grid[0]:a),"y"===o.axis&&(h=this.originalPageX),"x"===o.axis&&(l=this.originalPageY)),{top:l-this.offset.click.top-this.offset.relative.top-this.offset.parent.top+("fixed"===this.cssPosition?-this.offset.scroll.top:r?0:this.offset.scroll.top),left:h-this.offset.click.left-this.offset.relative.left-this.offset.parent.left+("fixed"===this.cssPosition?-this.offset.scroll.left:r?0:this.offset.scroll.left)}},_clear:function(){this.helper.removeClass("ui-draggable-dragging"),this.helper[0]===this.element[0]||this.cancelHelperRemoval||this.helper.remove(),this.helper=null,this.cancelHelperRemoval=!1,this.destroyOnClear&&this.destroy()},_normalizeRightBottom:function(){"y"!==this.options.axis&&"auto"!==this.helper.css("right")&&(this.helper.width(this.helper.width()),this.helper.css("right","auto")),"x"!==this.options.axis&&"auto"!==this.helper.css("bottom")&&(this.helper.height(this.helper.height()),this.helper.css("bottom","auto"))},_trigger:function(e,i,s){return s=s||this._uiHash(),t.ui.plugin.call(this,e,[i,s,this],!0),/^(drag|start|stop)/.test(e)&&(this.positionAbs=this._convertPositionTo("absolute"),s.offset=this.positionAbs),t.Widget.prototype._trigger.call(this,e,i,s)},plugins:{},_uiHash:function(){return{helper:this.helper,position:this.position,originalPosition:this.originalPosition,offset:this.positionAbs}}}),t.ui.plugin.add("draggable","connectToSortable",{start:function(e,i,s){var n=t.extend({},i,{item:s.element});s.sortables=[],t(s.options.connectToSortable).each(function(){var i=t(this).sortable("instance");i&&!i.options.disabled&&(s.sortables.push(i),i.refreshPositions(),i._trigger("activate",e,n))})},stop:function(e,i,s){var n=t.extend({},i,{item:s.element});s.cancelHelperRemoval=!1,t.each(s.sortables,function(){var t=this;t.isOver?(t.isOver=0,s.cancelHelperRemoval=!0,t.cancelHelperRemoval=!1,t._storedCSS={position:t.placeholder.css("position"),top:t.placeholder.css("top"),left:t.placeholder.css("left")},t._mouseStop(e),t.options.helper=t.options._helper):(t.cancelHelperRemoval=!0,t._trigger("deactivate",e,n))})},drag:function(e,i,s){t.each(s.sortables,function(){var n=!1,a=this;a.positionAbs=s.positionAbs,a.helperProportions=s.helperProportions,a.offset.click=s.offset.click,a._intersectsWith(a.containerCache)&&(n=!0,t.each(s.sortables,function(){return this.positionAbs=s.positionAbs,this.helperProportions=s.helperProportions,this.offset.click=s.offset.click,this!==a&&this._intersectsWith(this.containerCache)&&t.contains(a.element[0],this.element[0])&&(n=!1),n
// })),n?(a.isOver||(a.isOver=1,s._parent=i.helper.parent(),a.currentItem=i.helper.appendTo(a.element).data("ui-sortable-item",!0),a.options._helper=a.options.helper,a.options.helper=function(){return i.helper[0]},e.target=a.currentItem[0],a._mouseCapture(e,!0),a._mouseStart(e,!0,!0),a.offset.click.top=s.offset.click.top,a.offset.click.left=s.offset.click.left,a.offset.parent.left-=s.offset.parent.left-a.offset.parent.left,a.offset.parent.top-=s.offset.parent.top-a.offset.parent.top,s._trigger("toSortable",e),s.dropped=a.element,t.each(s.sortables,function(){this.refreshPositions()}),s.currentItem=s.element,a.fromOutside=s),a.currentItem&&(a._mouseDrag(e),i.position=a.position)):a.isOver&&(a.isOver=0,a.cancelHelperRemoval=!0,a.options._revert=a.options.revert,a.options.revert=!1,a._trigger("out",e,a._uiHash(a)),a._mouseStop(e,!0),a.options.revert=a.options._revert,a.options.helper=a.options._helper,a.placeholder&&a.placeholder.remove(),i.helper.appendTo(s._parent),s._refreshOffsets(e),i.position=s._generatePosition(e,!0),s._trigger("fromSortable",e),s.dropped=!1,t.each(s.sortables,function(){this.refreshPositions()}))})}}),t.ui.plugin.add("draggable","cursor",{start:function(e,i,s){var n=t("body"),a=s.options;n.css("cursor")&&(a._cursor=n.css("cursor")),n.css("cursor",a.cursor)},stop:function(e,i,s){var n=s.options;n._cursor&&t("body").css("cursor",n._cursor)}}),t.ui.plugin.add("draggable","opacity",{start:function(e,i,s){var n=t(i.helper),a=s.options;n.css("opacity")&&(a._opacity=n.css("opacity")),n.css("opacity",a.opacity)},stop:function(e,i,s){var n=s.options;n._opacity&&t(i.helper).css("opacity",n._opacity)}}),t.ui.plugin.add("draggable","scroll",{start:function(t,e,i){i.scrollParentNotHidden||(i.scrollParentNotHidden=i.helper.scrollParent(!1)),i.scrollParentNotHidden[0]!==i.document[0]&&"HTML"!==i.scrollParentNotHidden[0].tagName&&(i.overflowOffset=i.scrollParentNotHidden.offset())},drag:function(e,i,s){var n=s.options,a=!1,o=s.scrollParentNotHidden[0],r=s.document[0];o!==r&&"HTML"!==o.tagName?(n.axis&&"x"===n.axis||(s.overflowOffset.top+o.offsetHeight-e.pageY<n.scrollSensitivity?o.scrollTop=a=o.scrollTop+n.scrollSpeed:e.pageY-s.overflowOffset.top<n.scrollSensitivity&&(o.scrollTop=a=o.scrollTop-n.scrollSpeed)),n.axis&&"y"===n.axis||(s.overflowOffset.left+o.offsetWidth-e.pageX<n.scrollSensitivity?o.scrollLeft=a=o.scrollLeft+n.scrollSpeed:e.pageX-s.overflowOffset.left<n.scrollSensitivity&&(o.scrollLeft=a=o.scrollLeft-n.scrollSpeed))):(n.axis&&"x"===n.axis||(e.pageY-t(r).scrollTop()<n.scrollSensitivity?a=t(r).scrollTop(t(r).scrollTop()-n.scrollSpeed):t(window).height()-(e.pageY-t(r).scrollTop())<n.scrollSensitivity&&(a=t(r).scrollTop(t(r).scrollTop()+n.scrollSpeed))),n.axis&&"y"===n.axis||(e.pageX-t(r).scrollLeft()<n.scrollSensitivity?a=t(r).scrollLeft(t(r).scrollLeft()-n.scrollSpeed):t(window).width()-(e.pageX-t(r).scrollLeft())<n.scrollSensitivity&&(a=t(r).scrollLeft(t(r).scrollLeft()+n.scrollSpeed)))),a!==!1&&t.ui.ddmanager&&!n.dropBehaviour&&t.ui.ddmanager.prepareOffsets(s,e)}}),t.ui.plugin.add("draggable","snap",{start:function(e,i,s){var n=s.options;s.snapElements=[],t(n.snap.constructor!==String?n.snap.items||":data(ui-draggable)":n.snap).each(function(){var e=t(this),i=e.offset();this!==s.element[0]&&s.snapElements.push({item:this,width:e.outerWidth(),height:e.outerHeight(),top:i.top,left:i.left})})},drag:function(e,i,s){var n,a,o,r,h,l,u,c,d,p,f=s.options,m=f.snapTolerance,g=i.offset.left,v=g+s.helperProportions.width,_=i.offset.top,b=_+s.helperProportions.height;for(d=s.snapElements.length-1;d>=0;d--)h=s.snapElements[d].left-s.margins.left,l=h+s.snapElements[d].width,u=s.snapElements[d].top-s.margins.top,c=u+s.snapElements[d].height,h-m>v||g>l+m||u-m>b||_>c+m||!t.contains(s.snapElements[d].item.ownerDocument,s.snapElements[d].item)?(s.snapElements[d].snapping&&s.options.snap.release&&s.options.snap.release.call(s.element,e,t.extend(s._uiHash(),{snapItem:s.snapElements[d].item})),s.snapElements[d].snapping=!1):("inner"!==f.snapMode&&(n=m>=Math.abs(u-b),a=m>=Math.abs(c-_),o=m>=Math.abs(h-v),r=m>=Math.abs(l-g),n&&(i.position.top=s._convertPositionTo("relative",{top:u-s.helperProportions.height,left:0}).top),a&&(i.position.top=s._convertPositionTo("relative",{top:c,left:0}).top),o&&(i.position.left=s._convertPositionTo("relative",{top:0,left:h-s.helperProportions.width}).left),r&&(i.position.left=s._convertPositionTo("relative",{top:0,left:l}).left)),p=n||a||o||r,"outer"!==f.snapMode&&(n=m>=Math.abs(u-_),a=m>=Math.abs(c-b),o=m>=Math.abs(h-g),r=m>=Math.abs(l-v),n&&(i.position.top=s._convertPositionTo("relative",{top:u,left:0}).top),a&&(i.position.top=s._convertPositionTo("relative",{top:c-s.helperProportions.height,left:0}).top),o&&(i.position.left=s._convertPositionTo("relative",{top:0,left:h}).left),r&&(i.position.left=s._convertPositionTo("relative",{top:0,left:l-s.helperProportions.width}).left)),!s.snapElements[d].snapping&&(n||a||o||r||p)&&s.options.snap.snap&&s.options.snap.snap.call(s.element,e,t.extend(s._uiHash(),{snapItem:s.snapElements[d].item})),s.snapElements[d].snapping=n||a||o||r||p)}}),t.ui.plugin.add("draggable","stack",{start:function(e,i,s){var n,a=s.options,o=t.makeArray(t(a.stack)).sort(function(e,i){return(parseInt(t(e).css("zIndex"),10)||0)-(parseInt(t(i).css("zIndex"),10)||0)});o.length&&(n=parseInt(t(o[0]).css("zIndex"),10)||0,t(o).each(function(e){t(this).css("zIndex",n+e)}),this.css("zIndex",n+o.length))}}),t.ui.plugin.add("draggable","zIndex",{start:function(e,i,s){var n=t(i.helper),a=s.options;n.css("zIndex")&&(a._zIndex=n.css("zIndex")),n.css("zIndex",a.zIndex)},stop:function(e,i,s){var n=s.options;n._zIndex&&t(i.helper).css("zIndex",n._zIndex)}}),t.ui.draggable});

/*! modernizr 3.5.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-flexbox-requestanimationframe-svg-mq-setclasses !*/
!function(e,n,t){function r(e,n){return typeof e===n}function o(){var e,n,t,o,i,s,a;for(var l in S)if(S.hasOwnProperty(l)){if(e=[],n=S[l],n.name&&(e.push(n.name.toLowerCase()),n.options&&n.options.aliases&&n.options.aliases.length))for(t=0;t<n.options.aliases.length;t++)e.push(n.options.aliases[t].toLowerCase());for(o=r(n.fn,"function")?n.fn():n.fn,i=0;i<e.length;i++)s=e[i],a=s.split("."),1===a.length?Modernizr[a[0]]=o:(!Modernizr[a[0]]||Modernizr[a[0]]instanceof Boolean||(Modernizr[a[0]]=new Boolean(Modernizr[a[0]])),Modernizr[a[0]][a[1]]=o),C.push((o?"":"no-")+a.join("-"))}}function i(e){var n=x.className,t=Modernizr._config.classPrefix||"";if(_&&(n=n.baseVal),Modernizr._config.enableJSClass){var r=new RegExp("(^|\\s)"+t+"no-js(\\s|$)");n=n.replace(r,"$1"+t+"js$2")}Modernizr._config.enableClasses&&(n+=" "+t+e.join(" "+t),_?x.className.baseVal=n:x.className=n)}function s(e){return e.replace(/([a-z])-([a-z])/g,function(e,n,t){return n+t.toUpperCase()}).replace(/^-/,"")}function a(e,n){return!!~(""+e).indexOf(n)}function l(){return"function"!=typeof n.createElement?n.createElement(arguments[0]):_?n.createElementNS.call(n,"http://www.w3.org/2000/svg",arguments[0]):n.createElement.apply(n,arguments)}function u(e,n){return function(){return e.apply(n,arguments)}}function f(e,n,t){var o;for(var i in e)if(e[i]in n)return t===!1?e[i]:(o=n[e[i]],r(o,"function")?u(o,t||n):o);return!1}function c(e){return e.replace(/([A-Z])/g,function(e,n){return"-"+n.toLowerCase()}).replace(/^ms-/,"-ms-")}function p(n,t,r){var o;if("getComputedStyle"in e){o=getComputedStyle.call(e,n,t);var i=e.console;if(null!==o)r&&(o=o.getPropertyValue(r));else if(i){var s=i.error?"error":"log";i[s].call(i,"getComputedStyle returning null, its possible modernizr test results are inaccurate")}}else o=!t&&n.currentStyle&&n.currentStyle[r];return o}function d(){var e=n.body;return e||(e=l(_?"svg":"body"),e.fake=!0),e}function m(e,t,r,o){var i,s,a,u,f="modernizr",c=l("div"),p=d();if(parseInt(r,10))for(;r--;)a=l("div"),a.id=o?o[r]:f+(r+1),c.appendChild(a);return i=l("style"),i.type="text/css",i.id="s"+f,(p.fake?p:c).appendChild(i),p.appendChild(c),i.styleSheet?i.styleSheet.cssText=e:i.appendChild(n.createTextNode(e)),c.id=f,p.fake&&(p.style.background="",p.style.overflow="hidden",u=x.style.overflow,x.style.overflow="hidden",x.appendChild(p)),s=t(c,e),p.fake?(p.parentNode.removeChild(p),x.style.overflow=u,x.offsetHeight):c.parentNode.removeChild(c),!!s}function v(n,r){var o=n.length;if("CSS"in e&&"supports"in e.CSS){for(;o--;)if(e.CSS.supports(c(n[o]),r))return!0;return!1}if("CSSSupportsRule"in e){for(var i=[];o--;)i.push("("+c(n[o])+":"+r+")");return i=i.join(" or "),m("@supports ("+i+") { #modernizr { position: absolute; } }",function(e){return"absolute"==p(e,null,"position")})}return t}function g(e,n,o,i){function u(){c&&(delete T.style,delete T.modElem)}if(i=r(i,"undefined")?!1:i,!r(o,"undefined")){var f=v(e,o);if(!r(f,"undefined"))return f}for(var c,p,d,m,g,y=["modernizr","tspan","samp"];!T.style&&y.length;)c=!0,T.modElem=l(y.shift()),T.style=T.modElem.style;for(d=e.length,p=0;d>p;p++)if(m=e[p],g=T.style[m],a(m,"-")&&(m=s(m)),T.style[m]!==t){if(i||r(o,"undefined"))return u(),"pfx"==n?m:!0;try{T.style[m]=o}catch(h){}if(T.style[m]!=g)return u(),"pfx"==n?m:!0}return u(),!1}function y(e,n,t,o,i){var s=e.charAt(0).toUpperCase()+e.slice(1),a=(e+" "+E.join(s+" ")+s).split(" ");return r(n,"string")||r(n,"undefined")?g(a,n,o,i):(a=(e+" "+N.join(s+" ")+s).split(" "),f(a,n,t))}function h(e,n,r){return y(e,t,t,n,r)}var C=[],S=[],w={_version:"3.5.0",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,n){var t=this;setTimeout(function(){n(t[e])},0)},addTest:function(e,n,t){S.push({name:e,fn:n,options:t})},addAsyncTest:function(e){S.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=w,Modernizr=new Modernizr,Modernizr.addTest("svg",!!n.createElementNS&&!!n.createElementNS("http://www.w3.org/2000/svg","svg").createSVGRect);var x=n.documentElement,_="svg"===x.nodeName.toLowerCase(),b="Moz O ms Webkit",E=w._config.usePrefixes?b.split(" "):[];w._cssomPrefixes=E;var z=function(n){var r,o=prefixes.length,i=e.CSSRule;if("undefined"==typeof i)return t;if(!n)return!1;if(n=n.replace(/^@/,""),r=n.replace(/-/g,"_").toUpperCase()+"_RULE",r in i)return"@"+n;for(var s=0;o>s;s++){var a=prefixes[s],l=a.toUpperCase()+"_"+r;if(l in i)return"@-"+a.toLowerCase()+"-"+n}return!1};w.atRule=z;var N=w._config.usePrefixes?b.toLowerCase().split(" "):[];w._domPrefixes=N;var P={elem:l("modernizr")};Modernizr._q.push(function(){delete P.elem});var T={style:P.elem.style};Modernizr._q.unshift(function(){delete T.style}),w.testAllProps=y;var q=w.prefixed=function(e,n,t){return 0===e.indexOf("@")?z(e):(-1!=e.indexOf("-")&&(e=s(e)),n?y(e,n,t):y(e,"pfx"))};Modernizr.addTest("requestanimationframe",!!q("requestAnimationFrame",e),{aliases:["raf"]}),w.testAllProps=h,Modernizr.addTest("flexbox",h("flexBasis","1px",!0));var j=function(){var n=e.matchMedia||e.msMatchMedia;return n?function(e){var t=n(e);return t&&t.matches||!1}:function(n){var t=!1;return m("@media "+n+" { #modernizr { position: absolute; } }",function(n){t="absolute"==(e.getComputedStyle?e.getComputedStyle(n,null):n.currentStyle).position}),t}}();w.mq=j,o(),i(C),delete w.addTest,delete w.addAsyncTest;for(var A=0;A<Modernizr._q.length;A++)Modernizr._q[A]();e.Modernizr=Modernizr}(window,document);

// 'use strict';

// // Polyfill for requestAnimationFrame
// (function() {
//   if (!Date.now)
//     Date.now = function() { return new Date().getTime(); };

//   var vendors = ['webkit', 'moz'];
//   for (var i = 0; i < vendors.length && !window.requestAnimationFrame; ++i) {
//       var vp = vendors[i];
//       window.requestAnimationFrame = window[vp+'RequestAnimationFrame'];
//       window.cancelAnimationFrame = (window[vp+'CancelAnimationFrame']
//                                  || window[vp+'CancelRequestAnimationFrame']);
//   }
//   if (/iP(ad|hone|od).*OS 6/.test(window.navigator.userAgent)
//     || !window.requestAnimationFrame || !window.cancelAnimationFrame) {
//     var lastTime = 0;
//     window.requestAnimationFrame = function(callback) {
//         var now = Date.now();
//         var nextTime = Math.max(lastTime + 16, now);
//         return setTimeout(function() { callback(lastTime = nextTime); },
//                           nextTime - now);
//     };
//     window.cancelAnimationFrame = clearTimeout;
//   }
// })();

// var initClasses   = ['mui-enter', 'mui-leave'];
// var activeClasses = ['mui-enter-active', 'mui-leave-active'];

// // Find the right "transitionend" event for this browser
// var endEvent = (function() {
//   var transitions = {
//     'transition': 'transitionend',
//     'WebkitTransition': 'webkitTransitionEnd',
//     'MozTransition': 'transitionend',
//     'OTransition': 'otransitionend'
//   }
//   var elem = window.document.createElement('div');

//   for (var t in transitions) {
//     if (typeof elem.style[t] !== 'undefined') {
//       return transitions[t];
//     }
//   }

//   return null;
// })();

// function animate(isIn, element, animation, cb) {
//   element = $(element).eq(0);

//   if (!element.length) return;

//   if (endEvent === null) {
//     isIn ? element.show() : element.hide();
//     cb();
//     return;
//   }

//   var initClass = isIn ? initClasses[0] : initClasses[1];
//   var activeClass = isIn ? activeClasses[0] : activeClasses[1];

//   // Set up the animation
//   reset();
//   element.addClass(animation);
//   element.css('transition', 'none');
//   requestAnimationFrame(function() {
//     element.addClass(initClass);
//     if (isIn) element.show();
//   });

//   // Start the animation
//   requestAnimationFrame(function() {
//     element[0].offsetWidth;
//     element.css('transition', '');
//     element.addClass(activeClass);
//   });

//   // Clean up the animation when it finishes
//   element.one('transitionend', finish);

//   // Hides the element (for out animations), resets the element, and runs a callback
//   function finish() {
//     if (!isIn) element.hide();
//     reset();
//     if (cb) cb.apply(element);
//   }

//   // Resets transitions and removes motion-specific classes
//   function reset() {
//     element[0].style.transitionDuration = 0;
//     element.removeClass(initClass + ' ' + activeClass + ' ' + animation);
//   }
// }

// var MotionUI = {
//   animateIn: function(element, animation, cb) {
//     animate(true, element, animation, cb);
//   },

//   animateOut: function(element, animation, cb) {
//     animate(false, element, animation, cb);
//   }
// };

/*!
 * perfect-scrollbar v1.4.0
 * (c) 2018 Hyunje Jun
 * @license MIT
 */
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global.PerfectScrollbar = factory());
}(this, (function () { 'use strict';

function get(element) {
  return getComputedStyle(element);
}

function set(element, obj) {
  for (var key in obj) {
    var val = obj[key];
    if (typeof val === 'number') {
      val = val + "px";
    }
    element.style[key] = val;
  }
  return element;
}

function div(className) {
  var div = document.createElement('div');
  div.className = className;
  return div;
}

var elMatches =
  typeof Element !== 'undefined' &&
  (Element.prototype.matches ||
    Element.prototype.webkitMatchesSelector ||
    Element.prototype.mozMatchesSelector ||
    Element.prototype.msMatchesSelector);

function matches(element, query) {
  if (!elMatches) {
    throw new Error('No element matching method supported');
  }

  return elMatches.call(element, query);
}

function remove(element) {
  if (element.remove) {
    element.remove();
  } else {
    if (element.parentNode) {
      element.parentNode.removeChild(element);
    }
  }
}

function queryChildren(element, selector) {
  return Array.prototype.filter.call(element.children, function (child) { return matches(child, selector); }
  );
}

var cls = {
  main: 'ps',
  element: {
    thumb: function (x) { return ("ps__thumb-" + x); },
    rail: function (x) { return ("ps__rail-" + x); },
    consuming: 'ps__child--consume',
  },
  state: {
    focus: 'ps--focus',
    clicking: 'ps--clicking',
    active: function (x) { return ("ps--active-" + x); },
    scrolling: function (x) { return ("ps--scrolling-" + x); },
  },
};

/*
 * Helper methods
 */
var scrollingClassTimeout = { x: null, y: null };

function addScrollingClass(i, x) {
  var classList = i.element.classList;
  var className = cls.state.scrolling(x);

  if (classList.contains(className)) {
    clearTimeout(scrollingClassTimeout[x]);
  } else {
    classList.add(className);
  }
}

function removeScrollingClass(i, x) {
  scrollingClassTimeout[x] = setTimeout(
    function () { return i.isAlive && i.element.classList.remove(cls.state.scrolling(x)); },
    i.settings.scrollingThreshold
  );
}

function setScrollingClassInstantly(i, x) {
  addScrollingClass(i, x);
  removeScrollingClass(i, x);
}

var EventElement = function EventElement(element) {
  this.element = element;
  this.handlers = {};
};

var prototypeAccessors = { isEmpty: { configurable: true } };

EventElement.prototype.bind = function bind (eventName, handler) {
  if (typeof this.handlers[eventName] === 'undefined') {
    this.handlers[eventName] = [];
  }
  this.handlers[eventName].push(handler);
  this.element.addEventListener(eventName, handler, false);
};

EventElement.prototype.unbind = function unbind (eventName, target) {
    var this$1 = this;

  this.handlers[eventName] = this.handlers[eventName].filter(function (handler) {
    if (target && handler !== target) {
      return true;
    }
    this$1.element.removeEventListener(eventName, handler, false);
    return false;
  });
};

EventElement.prototype.unbindAll = function unbindAll () {
    var this$1 = this;

  for (var name in this$1.handlers) {
    this$1.unbind(name);
  }
};

prototypeAccessors.isEmpty.get = function () {
    var this$1 = this;

  return Object.keys(this.handlers).every(
    function (key) { return this$1.handlers[key].length === 0; }
  );
};

Object.defineProperties( EventElement.prototype, prototypeAccessors );

var EventManager = function EventManager() {
  this.eventElements = [];
};

EventManager.prototype.eventElement = function eventElement (element) {
  var ee = this.eventElements.filter(function (ee) { return ee.element === element; })[0];
  if (!ee) {
    ee = new EventElement(element);
    this.eventElements.push(ee);
  }
  return ee;
};

EventManager.prototype.bind = function bind (element, eventName, handler) {
  this.eventElement(element).bind(eventName, handler);
};

EventManager.prototype.unbind = function unbind (element, eventName, handler) {
  var ee = this.eventElement(element);
  ee.unbind(eventName, handler);

  if (ee.isEmpty) {
    // remove
    this.eventElements.splice(this.eventElements.indexOf(ee), 1);
  }
};

EventManager.prototype.unbindAll = function unbindAll () {
  this.eventElements.forEach(function (e) { return e.unbindAll(); });
  this.eventElements = [];
};

EventManager.prototype.once = function once (element, eventName, handler) {
  var ee = this.eventElement(element);
  var onceHandler = function (evt) {
    ee.unbind(eventName, onceHandler);
    handler(evt);
  };
  ee.bind(eventName, onceHandler);
};

function createEvent(name) {
  if (typeof window.CustomEvent === 'function') {
    return new CustomEvent(name);
  } else {
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(name, false, false, undefined);
    return evt;
  }
}

var processScrollDiff = function(
  i,
  axis,
  diff,
  useScrollingClass,
  forceFireReachEvent
) {
  if ( useScrollingClass === void 0 ) useScrollingClass = true;
  if ( forceFireReachEvent === void 0 ) forceFireReachEvent = false;

  var fields;
  if (axis === 'top') {
    fields = [
      'contentHeight',
      'containerHeight',
      'scrollTop',
      'y',
      'up',
      'down' ];
  } else if (axis === 'left') {
    fields = [
      'contentWidth',
      'containerWidth',
      'scrollLeft',
      'x',
      'left',
      'right' ];
  } else {
    throw new Error('A proper axis should be provided');
  }

  processScrollDiff$1(i, diff, fields, useScrollingClass, forceFireReachEvent);
};

function processScrollDiff$1(
  i,
  diff,
  ref,
  useScrollingClass,
  forceFireReachEvent
) {
  var contentHeight = ref[0];
  var containerHeight = ref[1];
  var scrollTop = ref[2];
  var y = ref[3];
  var up = ref[4];
  var down = ref[5];
  if ( useScrollingClass === void 0 ) useScrollingClass = true;
  if ( forceFireReachEvent === void 0 ) forceFireReachEvent = false;

  var element = i.element;

  // reset reach
  i.reach[y] = null;

  // 1 for subpixel rounding
  if (element[scrollTop] < 1) {
    i.reach[y] = 'start';
  }

  // 1 for subpixel rounding
  if (element[scrollTop] > i[contentHeight] - i[containerHeight] - 1) {
    i.reach[y] = 'end';
  }

  if (diff) {
    element.dispatchEvent(createEvent(("ps-scroll-" + y)));

    if (diff < 0) {
      element.dispatchEvent(createEvent(("ps-scroll-" + up)));
    } else if (diff > 0) {
      element.dispatchEvent(createEvent(("ps-scroll-" + down)));
    }

    if (useScrollingClass) {
      setScrollingClassInstantly(i, y);
    }
  }

  if (i.reach[y] && (diff || forceFireReachEvent)) {
    element.dispatchEvent(createEvent(("ps-" + y + "-reach-" + (i.reach[y]))));
  }
}

function toInt(x) {
  return parseInt(x, 10) || 0;
}

function isEditable(el) {
  return (
    matches(el, 'input,[contenteditable]') ||
    matches(el, 'select,[contenteditable]') ||
    matches(el, 'textarea,[contenteditable]') ||
    matches(el, 'button,[contenteditable]')
  );
}

function outerWidth(element) {
  var styles = get(element);
  return (
    toInt(styles.width) +
    toInt(styles.paddingLeft) +
    toInt(styles.paddingRight) +
    toInt(styles.borderLeftWidth) +
    toInt(styles.borderRightWidth)
  );
}

var env = {
  isWebKit:
    typeof document !== 'undefined' &&
    'WebkitAppearance' in document.documentElement.style,
  supportsTouch:
    typeof window !== 'undefined' &&
    ('ontouchstart' in window ||
      (window.DocumentTouch && document instanceof window.DocumentTouch)),
  supportsIePointer:
    typeof navigator !== 'undefined' && navigator.msMaxTouchPoints,
  isChrome:
    typeof navigator !== 'undefined' &&
    /Chrome/i.test(navigator && navigator.userAgent),
};

var updateGeometry = function(i) {
  var element = i.element;
  var roundedScrollTop = Math.floor(element.scrollTop);

  i.containerWidth = element.clientWidth;
  i.containerHeight = element.clientHeight;
  i.contentWidth = element.scrollWidth;
  i.contentHeight = element.scrollHeight;

  if (!element.contains(i.scrollbarXRail)) {
    // clean up and append
    queryChildren(element, cls.element.rail('x')).forEach(function (el) { return remove(el); }
    );
    element.appendChild(i.scrollbarXRail);
  }
  if (!element.contains(i.scrollbarYRail)) {
    // clean up and append
    queryChildren(element, cls.element.rail('y')).forEach(function (el) { return remove(el); }
    );
    element.appendChild(i.scrollbarYRail);
  }

  if (
    !i.settings.suppressScrollX &&
    i.containerWidth + i.settings.scrollXMarginOffset < i.contentWidth
  ) {
    i.scrollbarXActive = true;
    i.railXWidth = i.containerWidth - i.railXMarginWidth;
    i.railXRatio = i.containerWidth / i.railXWidth;
    i.scrollbarXWidth = getThumbSize(
      i,
      toInt(i.railXWidth * i.containerWidth / i.contentWidth)
    );
    i.scrollbarXLeft = toInt(
      (i.negativeScrollAdjustment + element.scrollLeft) *
        (i.railXWidth - i.scrollbarXWidth) /
        (i.contentWidth - i.containerWidth)
    );
  } else {
    i.scrollbarXActive = false;
  }

  if (
    !i.settings.suppressScrollY &&
    i.containerHeight + i.settings.scrollYMarginOffset < i.contentHeight
  ) {
    i.scrollbarYActive = true;
    i.railYHeight = i.containerHeight - i.railYMarginHeight;
    i.railYRatio = i.containerHeight / i.railYHeight;
    i.scrollbarYHeight = getThumbSize(
      i,
      toInt(i.railYHeight * i.containerHeight / i.contentHeight)
    );
    i.scrollbarYTop = toInt(
      roundedScrollTop *
        (i.railYHeight - i.scrollbarYHeight) /
        (i.contentHeight - i.containerHeight)
    );
  } else {
    i.scrollbarYActive = false;
  }

  if (i.scrollbarXLeft >= i.railXWidth - i.scrollbarXWidth) {
    i.scrollbarXLeft = i.railXWidth - i.scrollbarXWidth;
  }
  if (i.scrollbarYTop >= i.railYHeight - i.scrollbarYHeight) {
    i.scrollbarYTop = i.railYHeight - i.scrollbarYHeight;
  }

  updateCss(element, i);

  if (i.scrollbarXActive) {
    element.classList.add(cls.state.active('x'));
  } else {
    element.classList.remove(cls.state.active('x'));
    i.scrollbarXWidth = 0;
    i.scrollbarXLeft = 0;
    element.scrollLeft = 0;
  }
  if (i.scrollbarYActive) {
    element.classList.add(cls.state.active('y'));
  } else {
    element.classList.remove(cls.state.active('y'));
    i.scrollbarYHeight = 0;
    i.scrollbarYTop = 0;
    element.scrollTop = 0;
  }
};

function getThumbSize(i, thumbSize) {
  if (i.settings.minScrollbarLength) {
    thumbSize = Math.max(thumbSize, i.settings.minScrollbarLength);
  }
  if (i.settings.maxScrollbarLength) {
    thumbSize = Math.min(thumbSize, i.settings.maxScrollbarLength);
  }
  return thumbSize;
}

function updateCss(element, i) {
  var xRailOffset = { width: i.railXWidth };
  var roundedScrollTop = Math.floor(element.scrollTop);

  if (i.isRtl) {
    xRailOffset.left =
      i.negativeScrollAdjustment +
      element.scrollLeft +
      i.containerWidth -
      i.contentWidth;
  } else {
    xRailOffset.left = element.scrollLeft;
  }
  if (i.isScrollbarXUsingBottom) {
    xRailOffset.bottom = i.scrollbarXBottom - roundedScrollTop;
  } else {
    xRailOffset.top = i.scrollbarXTop + roundedScrollTop;
  }
  set(i.scrollbarXRail, xRailOffset);

  var yRailOffset = { top: roundedScrollTop, height: i.railYHeight };
  if (i.isScrollbarYUsingRight) {
    if (i.isRtl) {
      yRailOffset.right =
        i.contentWidth -
        (i.negativeScrollAdjustment + element.scrollLeft) -
        i.scrollbarYRight -
        i.scrollbarYOuterWidth;
    } else {
      yRailOffset.right = i.scrollbarYRight - element.scrollLeft;
    }
  } else {
    if (i.isRtl) {
      yRailOffset.left =
        i.negativeScrollAdjustment +
        element.scrollLeft +
        i.containerWidth * 2 -
        i.contentWidth -
        i.scrollbarYLeft -
        i.scrollbarYOuterWidth;
    } else {
      yRailOffset.left = i.scrollbarYLeft + element.scrollLeft;
    }
  }
  set(i.scrollbarYRail, yRailOffset);

  set(i.scrollbarX, {
    left: i.scrollbarXLeft,
    width: i.scrollbarXWidth - i.railBorderXWidth,
  });
  set(i.scrollbarY, {
    top: i.scrollbarYTop,
    height: i.scrollbarYHeight - i.railBorderYWidth,
  });
}

var clickRail = function(i) {
  i.event.bind(i.scrollbarY, 'mousedown', function (e) { return e.stopPropagation(); });
  i.event.bind(i.scrollbarYRail, 'mousedown', function (e) {
    var positionTop =
      e.pageY -
      window.pageYOffset -
      i.scrollbarYRail.getBoundingClientRect().top;
    var direction = positionTop > i.scrollbarYTop ? 1 : -1;

    i.element.scrollTop += direction * i.containerHeight;
    updateGeometry(i);

    e.stopPropagation();
  });

  i.event.bind(i.scrollbarX, 'mousedown', function (e) { return e.stopPropagation(); });
  i.event.bind(i.scrollbarXRail, 'mousedown', function (e) {
    var positionLeft =
      e.pageX -
      window.pageXOffset -
      i.scrollbarXRail.getBoundingClientRect().left;
    var direction = positionLeft > i.scrollbarXLeft ? 1 : -1;

    i.element.scrollLeft += direction * i.containerWidth;
    updateGeometry(i);

    e.stopPropagation();
  });
};

var dragThumb = function(i) {
  bindMouseScrollHandler(i, [
    'containerWidth',
    'contentWidth',
    'pageX',
    'railXWidth',
    'scrollbarX',
    'scrollbarXWidth',
    'scrollLeft',
    'x',
    'scrollbarXRail' ]);
  bindMouseScrollHandler(i, [
    'containerHeight',
    'contentHeight',
    'pageY',
    'railYHeight',
    'scrollbarY',
    'scrollbarYHeight',
    'scrollTop',
    'y',
    'scrollbarYRail' ]);
};

function bindMouseScrollHandler(
  i,
  ref
) {
  var containerHeight = ref[0];
  var contentHeight = ref[1];
  var pageY = ref[2];
  var railYHeight = ref[3];
  var scrollbarY = ref[4];
  var scrollbarYHeight = ref[5];
  var scrollTop = ref[6];
  var y = ref[7];
  var scrollbarYRail = ref[8];

  var element = i.element;

  var startingScrollTop = null;
  var startingMousePageY = null;
  var scrollBy = null;

  function mouseMoveHandler(e) {
    element[scrollTop] =
      startingScrollTop + scrollBy * (e[pageY] - startingMousePageY);
    addScrollingClass(i, y);
    updateGeometry(i);

    e.stopPropagation();
    e.preventDefault();
  }

  function mouseUpHandler() {
    removeScrollingClass(i, y);
    i[scrollbarYRail].classList.remove(cls.state.clicking);
    i.event.unbind(i.ownerDocument, 'mousemove', mouseMoveHandler);
  }

  i.event.bind(i[scrollbarY], 'mousedown', function (e) {
    startingScrollTop = element[scrollTop];
    startingMousePageY = e[pageY];
    scrollBy =
      (i[contentHeight] - i[containerHeight]) /
      (i[railYHeight] - i[scrollbarYHeight]);

    i.event.bind(i.ownerDocument, 'mousemove', mouseMoveHandler);
    i.event.once(i.ownerDocument, 'mouseup', mouseUpHandler);

    i[scrollbarYRail].classList.add(cls.state.clicking);

    e.stopPropagation();
    e.preventDefault();
  });
}

var keyboard = function(i) {
  var element = i.element;

  var elementHovered = function () { return matches(element, ':hover'); };
  var scrollbarFocused = function () { return matches(i.scrollbarX, ':focus') || matches(i.scrollbarY, ':focus'); };

  function shouldPreventDefault(deltaX, deltaY) {
    var scrollTop = Math.floor(element.scrollTop);
    if (deltaX === 0) {
      if (!i.scrollbarYActive) {
        return false;
      }
      if (
        (scrollTop === 0 && deltaY > 0) ||
        (scrollTop >= i.contentHeight - i.containerHeight && deltaY < 0)
      ) {
        return !i.settings.wheelPropagation;
      }
    }

    var scrollLeft = element.scrollLeft;
    if (deltaY === 0) {
      if (!i.scrollbarXActive) {
        return false;
      }
      if (
        (scrollLeft === 0 && deltaX < 0) ||
        (scrollLeft >= i.contentWidth - i.containerWidth && deltaX > 0)
      ) {
        return !i.settings.wheelPropagation;
      }
    }
    return true;
  }

  i.event.bind(i.ownerDocument, 'keydown', function (e) {
    if (
      (e.isDefaultPrevented && e.isDefaultPrevented()) ||
      e.defaultPrevented
    ) {
      return;
    }

    if (!elementHovered() && !scrollbarFocused()) {
      return;
    }

    var activeElement = document.activeElement
      ? document.activeElement
      : i.ownerDocument.activeElement;
    if (activeElement) {
      if (activeElement.tagName === 'IFRAME') {
        activeElement = activeElement.contentDocument.activeElement;
      } else {
        // go deeper if element is a webcomponent
        while (activeElement.shadowRoot) {
          activeElement = activeElement.shadowRoot.activeElement;
        }
      }
      if (isEditable(activeElement)) {
        return;
      }
    }

    var deltaX = 0;
    var deltaY = 0;

    switch (e.which) {
      case 37: // left
        if (e.metaKey) {
          deltaX = -i.contentWidth;
        } else if (e.altKey) {
          deltaX = -i.containerWidth;
        } else {
          deltaX = -30;
        }
        break;
      case 38: // up
        if (e.metaKey) {
          deltaY = i.contentHeight;
        } else if (e.altKey) {
          deltaY = i.containerHeight;
        } else {
          deltaY = 30;
        }
        break;
      case 39: // right
        if (e.metaKey) {
          deltaX = i.contentWidth;
        } else if (e.altKey) {
          deltaX = i.containerWidth;
        } else {
          deltaX = 30;
        }
        break;
      case 40: // down
        if (e.metaKey) {
          deltaY = -i.contentHeight;
        } else if (e.altKey) {
          deltaY = -i.containerHeight;
        } else {
          deltaY = -30;
        }
        break;
      case 32: // space bar
        if (e.shiftKey) {
          deltaY = i.containerHeight;
        } else {
          deltaY = -i.containerHeight;
        }
        break;
      case 33: // page up
        deltaY = i.containerHeight;
        break;
      case 34: // page down
        deltaY = -i.containerHeight;
        break;
      case 36: // home
        deltaY = i.contentHeight;
        break;
      case 35: // end
        deltaY = -i.contentHeight;
        break;
      default:
        return;
    }

    if (i.settings.suppressScrollX && deltaX !== 0) {
      return;
    }
    if (i.settings.suppressScrollY && deltaY !== 0) {
      return;
    }

    element.scrollTop -= deltaY;
    element.scrollLeft += deltaX;
    updateGeometry(i);

    if (shouldPreventDefault(deltaX, deltaY)) {
      e.preventDefault();
    }
  });
};

var wheel = function(i) {
  var element = i.element;

  function shouldPreventDefault(deltaX, deltaY) {
    var roundedScrollTop = Math.floor(element.scrollTop);
    var isTop = element.scrollTop === 0;
    var isBottom =
      roundedScrollTop + element.offsetHeight === element.scrollHeight;
    var isLeft = element.scrollLeft === 0;
    var isRight =
      element.scrollLeft + element.offsetWidth === element.scrollWidth;

    var hitsBound;

    // pick axis with primary direction
    if (Math.abs(deltaY) > Math.abs(deltaX)) {
      hitsBound = isTop || isBottom;
    } else {
      hitsBound = isLeft || isRight;
    }

    return hitsBound ? !i.settings.wheelPropagation : true;
  }

  function getDeltaFromEvent(e) {
    var deltaX = e.deltaX;
    var deltaY = -1 * e.deltaY;

    if (typeof deltaX === 'undefined' || typeof deltaY === 'undefined') {
      // OS X Safari
      deltaX = -1 * e.wheelDeltaX / 6;
      deltaY = e.wheelDeltaY / 6;
    }

    if (e.deltaMode && e.deltaMode === 1) {
      // Firefox in deltaMode 1: Line scrolling
      deltaX *= 10;
      deltaY *= 10;
    }

    if (deltaX !== deltaX && deltaY !== deltaY /* NaN checks */) {
      // IE in some mouse drivers
      deltaX = 0;
      deltaY = e.wheelDelta;
    }

    if (e.shiftKey) {
      // reverse axis with shift key
      return [-deltaY, -deltaX];
    }
    return [deltaX, deltaY];
  }

  function shouldBeConsumedByChild(target, deltaX, deltaY) {
    // FIXME: this is a workaround for <select> issue in FF and IE #571
    if (!env.isWebKit && element.querySelector('select:focus')) {
      return true;
    }

    if (!element.contains(target)) {
      return false;
    }

    var cursor = target;

    while (cursor && cursor !== element) {
      if (cursor.classList.contains(cls.element.consuming)) {
        return true;
      }

      var style = get(cursor);
      var overflow = [style.overflow, style.overflowX, style.overflowY].join(
        ''
      );

      // if scrollable
      if (overflow.match(/(scroll|auto)/)) {
        var maxScrollTop = cursor.scrollHeight - cursor.clientHeight;
        if (maxScrollTop > 0) {
          if (
            !(cursor.scrollTop === 0 && deltaY > 0) &&
            !(cursor.scrollTop === maxScrollTop && deltaY < 0)
          ) {
            return true;
          }
        }
        var maxScrollLeft = cursor.scrollWidth - cursor.clientWidth;
        if (maxScrollLeft > 0) {
          if (
            !(cursor.scrollLeft === 0 && deltaX < 0) &&
            !(cursor.scrollLeft === maxScrollLeft && deltaX > 0)
          ) {
            return true;
          }
        }
      }

      cursor = cursor.parentNode;
    }

    return false;
  }

  function mousewheelHandler(e) {
    var ref = getDeltaFromEvent(e);
    var deltaX = ref[0];
    var deltaY = ref[1];

    if (shouldBeConsumedByChild(e.target, deltaX, deltaY)) {
      return;
    }

    var shouldPrevent = false;
    if (!i.settings.useBothWheelAxes) {
      // deltaX will only be used for horizontal scrolling and deltaY will
      // only be used for vertical scrolling - this is the default
      element.scrollTop -= deltaY * i.settings.wheelSpeed;
      element.scrollLeft += deltaX * i.settings.wheelSpeed;
    } else if (i.scrollbarYActive && !i.scrollbarXActive) {
      // only vertical scrollbar is active and useBothWheelAxes option is
      // active, so let's scroll vertical bar using both mouse wheel axes
      if (deltaY) {
        element.scrollTop -= deltaY * i.settings.wheelSpeed;
      } else {
        element.scrollTop += deltaX * i.settings.wheelSpeed;
      }
      shouldPrevent = true;
    } else if (i.scrollbarXActive && !i.scrollbarYActive) {
      // useBothWheelAxes and only horizontal bar is active, so use both
      // wheel axes for horizontal bar
      if (deltaX) {
        element.scrollLeft += deltaX * i.settings.wheelSpeed;
      } else {
        element.scrollLeft -= deltaY * i.settings.wheelSpeed;
      }
      shouldPrevent = true;
    }

    updateGeometry(i);

    shouldPrevent = shouldPrevent || shouldPreventDefault(deltaX, deltaY);
    if (shouldPrevent && !e.ctrlKey) {
      e.stopPropagation();
      e.preventDefault();
    }
  }

  if (typeof window.onwheel !== 'undefined') {
    i.event.bind(element, 'wheel', mousewheelHandler);
  } else if (typeof window.onmousewheel !== 'undefined') {
    i.event.bind(element, 'mousewheel', mousewheelHandler);
  }
};

var touch = function(i) {
  if (!env.supportsTouch && !env.supportsIePointer) {
    return;
  }

  var element = i.element;

  function shouldPrevent(deltaX, deltaY) {
    var scrollTop = Math.floor(element.scrollTop);
    var scrollLeft = element.scrollLeft;
    var magnitudeX = Math.abs(deltaX);
    var magnitudeY = Math.abs(deltaY);

    if (magnitudeY > magnitudeX) {
      // user is perhaps trying to swipe up/down the page

      if (
        (deltaY < 0 && scrollTop === i.contentHeight - i.containerHeight) ||
        (deltaY > 0 && scrollTop === 0)
      ) {
        // set prevent for mobile Chrome refresh
        return window.scrollY === 0 && deltaY > 0 && env.isChrome;
      }
    } else if (magnitudeX > magnitudeY) {
      // user is perhaps trying to swipe left/right across the page

      if (
        (deltaX < 0 && scrollLeft === i.contentWidth - i.containerWidth) ||
        (deltaX > 0 && scrollLeft === 0)
      ) {
        return true;
      }
    }

    return true;
  }

  function applyTouchMove(differenceX, differenceY) {
    element.scrollTop -= differenceY;
    element.scrollLeft -= differenceX;

    updateGeometry(i);
  }

  var startOffset = {};
  var startTime = 0;
  var speed = {};
  var easingLoop = null;

  function getTouch(e) {
    if (e.targetTouches) {
      return e.targetTouches[0];
    } else {
      // Maybe IE pointer
      return e;
    }
  }

  function shouldHandle(e) {
    if (e.pointerType && e.pointerType === 'pen' && e.buttons === 0) {
      return false;
    }
    if (e.targetTouches && e.targetTouches.length === 1) {
      return true;
    }
    if (
      e.pointerType &&
      e.pointerType !== 'mouse' &&
      e.pointerType !== e.MSPOINTER_TYPE_MOUSE
    ) {
      return true;
    }
    return false;
  }

  function touchStart(e) {
    if (!shouldHandle(e)) {
      return;
    }

    var touch = getTouch(e);

    startOffset.pageX = touch.pageX;
    startOffset.pageY = touch.pageY;

    startTime = new Date().getTime();

    if (easingLoop !== null) {
      clearInterval(easingLoop);
    }
  }

  function shouldBeConsumedByChild(target, deltaX, deltaY) {
    if (!element.contains(target)) {
      return false;
    }

    var cursor = target;

    while (cursor && cursor !== element) {
      if (cursor.classList.contains(cls.element.consuming)) {
        return true;
      }

      var style = get(cursor);
      var overflow = [style.overflow, style.overflowX, style.overflowY].join(
        ''
      );

      // if scrollable
      if (overflow.match(/(scroll|auto)/)) {
        var maxScrollTop = cursor.scrollHeight - cursor.clientHeight;
        if (maxScrollTop > 0) {
          if (
            !(cursor.scrollTop === 0 && deltaY > 0) &&
            !(cursor.scrollTop === maxScrollTop && deltaY < 0)
          ) {
            return true;
          }
        }
        var maxScrollLeft = cursor.scrollLeft - cursor.clientWidth;
        if (maxScrollLeft > 0) {
          if (
            !(cursor.scrollLeft === 0 && deltaX < 0) &&
            !(cursor.scrollLeft === maxScrollLeft && deltaX > 0)
          ) {
            return true;
          }
        }
      }

      cursor = cursor.parentNode;
    }

    return false;
  }

  function touchMove(e) {
    if (shouldHandle(e)) {
      var touch = getTouch(e);

      var currentOffset = { pageX: touch.pageX, pageY: touch.pageY };

      var differenceX = currentOffset.pageX - startOffset.pageX;
      var differenceY = currentOffset.pageY - startOffset.pageY;

      if (shouldBeConsumedByChild(e.target, differenceX, differenceY)) {
        return;
      }

      applyTouchMove(differenceX, differenceY);
      startOffset = currentOffset;

      var currentTime = new Date().getTime();

      var timeGap = currentTime - startTime;
      if (timeGap > 0) {
        speed.x = differenceX / timeGap;
        speed.y = differenceY / timeGap;
        startTime = currentTime;
      }

      if (shouldPrevent(differenceX, differenceY)) {
        e.preventDefault();
      }
    }
  }
  function touchEnd() {
    if (i.settings.swipeEasing) {
      clearInterval(easingLoop);
      easingLoop = setInterval(function() {
        if (i.isInitialized) {
          clearInterval(easingLoop);
          return;
        }

        if (!speed.x && !speed.y) {
          clearInterval(easingLoop);
          return;
        }

        if (Math.abs(speed.x) < 0.01 && Math.abs(speed.y) < 0.01) {
          clearInterval(easingLoop);
          return;
        }

        applyTouchMove(speed.x * 30, speed.y * 30);

        speed.x *= 0.8;
        speed.y *= 0.8;
      }, 10);
    }
  }

  if (env.supportsTouch) {
    i.event.bind(element, 'touchstart', touchStart);
    i.event.bind(element, 'touchmove', touchMove);
    i.event.bind(element, 'touchend', touchEnd);
  } else if (env.supportsIePointer) {
    if (window.PointerEvent) {
      i.event.bind(element, 'pointerdown', touchStart);
      i.event.bind(element, 'pointermove', touchMove);
      i.event.bind(element, 'pointerup', touchEnd);
    } else if (window.MSPointerEvent) {
      i.event.bind(element, 'MSPointerDown', touchStart);
      i.event.bind(element, 'MSPointerMove', touchMove);
      i.event.bind(element, 'MSPointerUp', touchEnd);
    }
  }
};

var defaultSettings = function () { return ({
  handlers: ['click-rail', 'drag-thumb', 'keyboard', 'wheel', 'touch'],
  maxScrollbarLength: null,
  minScrollbarLength: null,
  scrollingThreshold: 1000,
  scrollXMarginOffset: 0,
  scrollYMarginOffset: 0,
  suppressScrollX: false,
  suppressScrollY: false,
  swipeEasing: true,
  useBothWheelAxes: false,
  wheelPropagation: true,
  wheelSpeed: 1,
}); };

var handlers = {
  'click-rail': clickRail,
  'drag-thumb': dragThumb,
  keyboard: keyboard,
  wheel: wheel,
  touch: touch,
};

var PerfectScrollbar = function PerfectScrollbar(element, userSettings) {
  var this$1 = this;
  if ( userSettings === void 0 ) userSettings = {};

  if (typeof element === 'string') {
    element = document.querySelector(element);
  }

  if (!element || !element.nodeName) {
    throw new Error('no element is specified to initialize PerfectScrollbar');
  }

  this.element = element;

  element.classList.add(cls.main);

  this.settings = defaultSettings();
  for (var key in userSettings) {
    this$1.settings[key] = userSettings[key];
  }

  this.containerWidth = null;
  this.containerHeight = null;
  this.contentWidth = null;
  this.contentHeight = null;

  var focus = function () { return element.classList.add(cls.state.focus); };
  var blur = function () { return element.classList.remove(cls.state.focus); };

  this.isRtl = get(element).direction === 'rtl';
  this.isNegativeScroll = (function () {
    var originalScrollLeft = element.scrollLeft;
    var result = null;
    element.scrollLeft = -1;
    result = element.scrollLeft < 0;
    element.scrollLeft = originalScrollLeft;
    return result;
  })();
  this.negativeScrollAdjustment = this.isNegativeScroll
    ? element.scrollWidth - element.clientWidth
    : 0;
  this.event = new EventManager();
  this.ownerDocument = element.ownerDocument || document;

  this.scrollbarXRail = div(cls.element.rail('x'));
  element.appendChild(this.scrollbarXRail);
  this.scrollbarX = div(cls.element.thumb('x'));
  this.scrollbarXRail.appendChild(this.scrollbarX);
  this.scrollbarX.setAttribute('tabindex', 0);
  this.event.bind(this.scrollbarX, 'focus', focus);
  this.event.bind(this.scrollbarX, 'blur', blur);
  this.scrollbarXActive = null;
  this.scrollbarXWidth = null;
  this.scrollbarXLeft = null;
  var railXStyle = get(this.scrollbarXRail);
  this.scrollbarXBottom = parseInt(railXStyle.bottom, 10);
  if (isNaN(this.scrollbarXBottom)) {
    this.isScrollbarXUsingBottom = false;
    this.scrollbarXTop = toInt(railXStyle.top);
  } else {
    this.isScrollbarXUsingBottom = true;
  }
  this.railBorderXWidth =
    toInt(railXStyle.borderLeftWidth) + toInt(railXStyle.borderRightWidth);
  // Set rail to display:block to calculate margins
  set(this.scrollbarXRail, { display: 'block' });
  this.railXMarginWidth =
    toInt(railXStyle.marginLeft) + toInt(railXStyle.marginRight);
  set(this.scrollbarXRail, { display: '' });
  this.railXWidth = null;
  this.railXRatio = null;

  this.scrollbarYRail = div(cls.element.rail('y'));
  element.appendChild(this.scrollbarYRail);
  this.scrollbarY = div(cls.element.thumb('y'));
  this.scrollbarYRail.appendChild(this.scrollbarY);
  this.scrollbarY.setAttribute('tabindex', 0);
  this.event.bind(this.scrollbarY, 'focus', focus);
  this.event.bind(this.scrollbarY, 'blur', blur);
  this.scrollbarYActive = null;
  this.scrollbarYHeight = null;
  this.scrollbarYTop = null;
  var railYStyle = get(this.scrollbarYRail);
  this.scrollbarYRight = parseInt(railYStyle.right, 10);
  if (isNaN(this.scrollbarYRight)) {
    this.isScrollbarYUsingRight = false;
    this.scrollbarYLeft = toInt(railYStyle.left);
  } else {
    this.isScrollbarYUsingRight = true;
  }
  this.scrollbarYOuterWidth = this.isRtl ? outerWidth(this.scrollbarY) : null;
  this.railBorderYWidth =
    toInt(railYStyle.borderTopWidth) + toInt(railYStyle.borderBottomWidth);
  set(this.scrollbarYRail, { display: 'block' });
  this.railYMarginHeight =
    toInt(railYStyle.marginTop) + toInt(railYStyle.marginBottom);
  set(this.scrollbarYRail, { display: '' });
  this.railYHeight = null;
  this.railYRatio = null;

  this.reach = {
    x:
      element.scrollLeft <= 0
        ? 'start'
        : element.scrollLeft >= this.contentWidth - this.containerWidth
          ? 'end'
          : null,
    y:
      element.scrollTop <= 0
        ? 'start'
        : element.scrollTop >= this.contentHeight - this.containerHeight
          ? 'end'
          : null,
  };

  this.isAlive = true;

  this.settings.handlers.forEach(function (handlerName) { return handlers[handlerName](this$1); });

  this.lastScrollTop = Math.floor(element.scrollTop); // for onScroll only
  this.lastScrollLeft = element.scrollLeft; // for onScroll only
  this.event.bind(this.element, 'scroll', function (e) { return this$1.onScroll(e); });
  updateGeometry(this);
};

PerfectScrollbar.prototype.update = function update () {
  if (!this.isAlive) {
    return;
  }

  // Recalcuate negative scrollLeft adjustment
  this.negativeScrollAdjustment = this.isNegativeScroll
    ? this.element.scrollWidth - this.element.clientWidth
    : 0;

  // Recalculate rail margins
  set(this.scrollbarXRail, { display: 'block' });
  set(this.scrollbarYRail, { display: 'block' });
  this.railXMarginWidth =
    toInt(get(this.scrollbarXRail).marginLeft) +
    toInt(get(this.scrollbarXRail).marginRight);
  this.railYMarginHeight =
    toInt(get(this.scrollbarYRail).marginTop) +
    toInt(get(this.scrollbarYRail).marginBottom);

  // Hide scrollbars not to affect scrollWidth and scrollHeight
  set(this.scrollbarXRail, { display: 'none' });
  set(this.scrollbarYRail, { display: 'none' });

  updateGeometry(this);

  processScrollDiff(this, 'top', 0, false, true);
  processScrollDiff(this, 'left', 0, false, true);

  set(this.scrollbarXRail, { display: '' });
  set(this.scrollbarYRail, { display: '' });
};

PerfectScrollbar.prototype.onScroll = function onScroll (e) {
  if (!this.isAlive) {
    return;
  }

  updateGeometry(this);
  processScrollDiff(this, 'top', this.element.scrollTop - this.lastScrollTop);
  processScrollDiff(
    this,
    'left',
    this.element.scrollLeft - this.lastScrollLeft
  );

  this.lastScrollTop = Math.floor(this.element.scrollTop);
  this.lastScrollLeft = this.element.scrollLeft;
};

PerfectScrollbar.prototype.destroy = function destroy () {
  if (!this.isAlive) {
    return;
  }

  this.event.unbindAll();
  remove(this.scrollbarX);
  remove(this.scrollbarY);
  remove(this.scrollbarXRail);
  remove(this.scrollbarYRail);
  this.removePsClasses();

  // unset elements
  this.element = null;
  this.scrollbarX = null;
  this.scrollbarY = null;
  this.scrollbarXRail = null;
  this.scrollbarYRail = null;

  this.isAlive = false;
};

PerfectScrollbar.prototype.removePsClasses = function removePsClasses () {
  this.element.className = this.element.className
    .split(' ')
    .filter(function (name) { return !name.match(/^ps([-_].+|)$/); })
    .join(' ');
};

return PerfectScrollbar;

})));

(function (factory) {

    if ( typeof define === 'function' && define.amd ) {

        // AMD. Register as an anonymous module.
        define([], factory);

    } else if ( typeof exports === 'object' ) {

        // Node/CommonJS
        module.exports = factory();

    } else {

        // Browser globals
        window.wNumb = factory();
    }

}(function(){

	'use strict';

var FormatOptions = [
	'decimals',
	'thousand',
	'mark',
	'prefix',
	'suffix',
	'encoder',
	'decoder',
	'negativeBefore',
	'negative',
	'edit',
	'undo'
];

// General

	// Reverse a string
	function strReverse ( a ) {
		return a.split('').reverse().join('');
	}

	// Check if a string starts with a specified prefix.
	function strStartsWith ( input, match ) {
		return input.substring(0, match.length) === match;
	}

	// Check is a string ends in a specified suffix.
	function strEndsWith ( input, match ) {
		return input.slice(-1 * match.length) === match;
	}

	// Throw an error if formatting options are incompatible.
	function throwEqualError( F, a, b ) {
		if ( (F[a] || F[b]) && (F[a] === F[b]) ) {
			throw new Error(a);
		}
	}

	// Check if a number is finite and not NaN
	function isValidNumber ( input ) {
		return typeof input === 'number' && isFinite( input );
	}

	// Provide rounding-accurate toFixed method.
	// Borrowed: http://stackoverflow.com/a/21323330/775265
	function toFixed ( value, exp ) {
		value = value.toString().split('e');
		value = Math.round(+(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp)));
		value = value.toString().split('e');
		return (+(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp))).toFixed(exp);
	}


// Formatting

	// Accept a number as input, output formatted string.
	function formatTo ( decimals, thousand, mark, prefix, suffix, encoder, decoder, negativeBefore, negative, edit, undo, input ) {

		var originalInput = input, inputIsNegative, inputPieces, inputBase, inputDecimals = '', output = '';

		// Apply user encoder to the input.
		// Expected outcome: number.
		if ( encoder ) {
			input = encoder(input);
		}

		// Stop if no valid number was provided, the number is infinite or NaN.
		if ( !isValidNumber(input) ) {
			return false;
		}

		// Rounding away decimals might cause a value of -0
		// when using very small ranges. Remove those cases.
		if ( decimals !== false && parseFloat(input.toFixed(decimals)) === 0 ) {
			input = 0;
		}

		// Formatting is done on absolute numbers,
		// decorated by an optional negative symbol.
		if ( input < 0 ) {
			inputIsNegative = true;
			input = Math.abs(input);
		}

		// Reduce the number of decimals to the specified option.
		if ( decimals !== false ) {
			input = toFixed( input, decimals );
		}

		// Transform the number into a string, so it can be split.
		input = input.toString();

		// Break the number on the decimal separator.
		if ( input.indexOf('.') !== -1 ) {
			inputPieces = input.split('.');

			inputBase = inputPieces[0];

			if ( mark ) {
				inputDecimals = mark + inputPieces[1];
			}

		} else {

		// If it isn't split, the entire number will do.
			inputBase = input;
		}

		// Group numbers in sets of three.
		if ( thousand ) {
			inputBase = strReverse(inputBase).match(/.{1,3}/g);
			inputBase = strReverse(inputBase.join( strReverse( thousand ) ));
		}

		// If the number is negative, prefix with negation symbol.
		if ( inputIsNegative && negativeBefore ) {
			output += negativeBefore;
		}

		// Prefix the number
		if ( prefix ) {
			output += prefix;
		}

		// Normal negative option comes after the prefix. Defaults to '-'.
		if ( inputIsNegative && negative ) {
			output += negative;
		}

		// Append the actual number.
		output += inputBase;
		output += inputDecimals;

		// Apply the suffix.
		if ( suffix ) {
			output += suffix;
		}

		// Run the output through a user-specified post-formatter.
		if ( edit ) {
			output = edit ( output, originalInput );
		}

		// All done.
		return output;
	}

	// Accept a sting as input, output decoded number.
	function formatFrom ( decimals, thousand, mark, prefix, suffix, encoder, decoder, negativeBefore, negative, edit, undo, input ) {

		var originalInput = input, inputIsNegative, output = '';

		// User defined pre-decoder. Result must be a non empty string.
		if ( undo ) {
			input = undo(input);
		}

		// Test the input. Can't be empty.
		if ( !input || typeof input !== 'string' ) {
			return false;
		}

		// If the string starts with the negativeBefore value: remove it.
		// Remember is was there, the number is negative.
		if ( negativeBefore && strStartsWith(input, negativeBefore) ) {
			input = input.replace(negativeBefore, '');
			inputIsNegative = true;
		}

		// Repeat the same procedure for the prefix.
		if ( prefix && strStartsWith(input, prefix) ) {
			input = input.replace(prefix, '');
		}

		// And again for negative.
		if ( negative && strStartsWith(input, negative) ) {
			input = input.replace(negative, '');
			inputIsNegative = true;
		}

		// Remove the suffix.
		// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/slice
		if ( suffix && strEndsWith(input, suffix) ) {
			input = input.slice(0, -1 * suffix.length);
		}

		// Remove the thousand grouping.
		if ( thousand ) {
			input = input.split(thousand).join('');
		}

		// Set the decimal separator back to period.
		if ( mark ) {
			input = input.replace(mark, '.');
		}

		// Prepend the negative symbol.
		if ( inputIsNegative ) {
			output += '-';
		}

		// Add the number
		output += input;

		// Trim all non-numeric characters (allow '.' and '-');
		output = output.replace(/[^0-9\.\-.]/g, '');

		// The value contains no parse-able number.
		if ( output === '' ) {
			return false;
		}

		// Covert to number.
		output = Number(output);

		// Run the user-specified post-decoder.
		if ( decoder ) {
			output = decoder(output);
		}

		// Check is the output is valid, otherwise: return false.
		if ( !isValidNumber(output) ) {
			return false;
		}

		return output;
	}


// Framework

	// Validate formatting options
	function validate ( inputOptions ) {

		var i, optionName, optionValue,
			filteredOptions = {};

		if ( inputOptions.suffix === undefined ) {
			inputOptions.suffix = inputOptions.postfix;
		}

		for ( i = 0; i < FormatOptions.length; i+=1 ) {

			optionName = FormatOptions[i];
			optionValue = inputOptions[optionName];

			if ( optionValue === undefined ) {

				// Only default if negativeBefore isn't set.
				if ( optionName === 'negative' && !filteredOptions.negativeBefore ) {
					filteredOptions[optionName] = '-';
				// Don't set a default for mark when 'thousand' is set.
				} else if ( optionName === 'mark' && filteredOptions.thousand !== '.' ) {
					filteredOptions[optionName] = '.';
				} else {
					filteredOptions[optionName] = false;
				}

			// Floating points in JS are stable up to 7 decimals.
			} else if ( optionName === 'decimals' ) {
				if ( optionValue >= 0 && optionValue < 8 ) {
					filteredOptions[optionName] = optionValue;
				} else {
					throw new Error(optionName);
				}

			// These options, when provided, must be functions.
			} else if ( optionName === 'encoder' || optionName === 'decoder' || optionName === 'edit' || optionName === 'undo' ) {
				if ( typeof optionValue === 'function' ) {
					filteredOptions[optionName] = optionValue;
				} else {
					throw new Error(optionName);
				}

			// Other options are strings.
			} else {

				if ( typeof optionValue === 'string' ) {
					filteredOptions[optionName] = optionValue;
				} else {
					throw new Error(optionName);
				}
			}
		}

		// Some values can't be extracted from a
		// string if certain combinations are present.
		throwEqualError(filteredOptions, 'mark', 'thousand');
		throwEqualError(filteredOptions, 'prefix', 'negative');
		throwEqualError(filteredOptions, 'prefix', 'negativeBefore');

		return filteredOptions;
	}

	// Pass all options as function arguments
	function passAll ( options, method, input ) {
		var i, args = [];

		// Add all options in order of FormatOptions
		for ( i = 0; i < FormatOptions.length; i+=1 ) {
			args.push(options[FormatOptions[i]]);
		}

		// Append the input, then call the method, presenting all
		// options as arguments.
		args.push(input);
		return method.apply('', args);
	}

	function wNumb ( options ) {

		if ( !(this instanceof wNumb) ) {
			return new wNumb ( options );
		}

		if ( typeof options !== "object" ) {
			return;
		}

		options = validate(options);

		// Call 'formatTo' with proper arguments.
		this.to = function ( input ) {
			return passAll(options, formatTo, input);
		};

		// Call 'formatFrom' with proper arguments.
		this.from = function ( input ) {
			return passAll(options, formatFrom, input);
		};
	}

	return wNumb;

}));

(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

var $ = jQuery.noConflict();

$.fn.extend({
  calculators: function calculators() {
    self.init(this.selector);
  }
});

jQuery('<div class="quantity-nav"><div class="quantity-button quantity-up"><i class="fa fa-angle-right" aria-hidden="true"></i></div><div class="quantity-button quantity-down"><i class="fa fa-angle-left" aria-hidden="true"></i></div></div>').insertAfter('.quantity input');
jQuery('.quantity').each(function () {
  var spinner = jQuery(this),
      input = spinner.find('input[type="number"]'),
      btnUp = spinner.find('.quantity-up'),
      btnDown = spinner.find('.quantity-down'),
      min = input.attr('min'),
      max = input.attr('max');

  btnUp.on("click", function () {
    var oldValue = parseFloat(input.val());
    if (oldValue >= max) {
      var newVal = oldValue;
    } else {
      if (spinner.hasClass("mortgage-calculator-price")) {
        var newVal = oldValue + 1000;
      } else if (spinner.hasClass("mortgage-calculator-deposit")) {
        var newVal = oldValue + 500;
      } else {
        var newVal = oldValue + 1;
      }
    }
    spinner.find("input").val(newVal);
    spinner.find("input").trigger("change");
  });

  btnDown.on("click", function () {
    var oldValue = parseFloat(input.val());
    if (oldValue <= min) {
      var newVal = oldValue;
    } else {
      if (spinner.hasClass("mortgage-calculator-price")) {
        var newVal = oldValue - 1000;
      } else if (spinner.hasClass("mortgage-calculator-deposit")) {
        var newVal = oldValue - 500;
      } else {
        var newVal = oldValue - 1;
      }
    }
    spinner.find("input").val(newVal);
    spinner.find("input").trigger("change");
  });
});

},{}],2:[function(require,module,exports){
'use strict';

var $ = jQuery.noConflict();

var self = module.exports = {
  init: function init(trigger) {
    self.events.click(trigger);
  },

  events: {
    click: function click(trigger) {
      $(document).on('click', trigger, function (e) {
        e.preventDefault();
        var el = $(this).closest('[data-read-more]');
        self.service.open(el, $(this));
      });
    }
  },

  service: {
    open: function open(target, link) {
      $(target).toggleClass('active');
      $(target).find('.property-details__read-more').toggleClass('active');
      if ($(target).hasClass('active')) {
        $(link).text('Read less');
      } else {
        $(link).text('Read more');
      }
    }
  }
};

},{}],3:[function(require,module,exports){
'use strict';

var $ = jQuery.noConflict();

// Require utilities
require('./utility/object-entries.js');
require('./utility/request-timeout.js');
require('./utility/done-typing.js');
require('./utility/tabbing.js');

var Cookie = require('./utility/cookie.js');
var LazyLoad = require('./utility/lazy-load.js');
var ReadMore = require('./components/read-more.js');
var Calculators = require("./components/calculators.js");

// Require jquery extend modules
var Header = require('./modules/header.js');
var Footer = require('./modules/footer.js');
var Nav = require('./modules/nav.js');
var NavBurger = require('./modules/nav-burger.js');
var PropertySearch = require('./modules/property-search.js');
var Statement = require('./modules/statement.js');
var Process = require('./modules/process.js');
var Valuation = require("./modules/valuation.js");

// Require jquery extend plugins
var Accordion = require('./plugins/accordion.js');
var Arrive = require('./plugins/arrive.js');
var AutoComplete = require('./plugins/autocomplete.google.js');
var Calculator = require('./plugins/calculator.js');
var Collapse = require('./plugins/collapse.js');
var Copy = require('./plugins/copy.js');
var CountdownTimer = require('./plugins/countdown-timer.js');
var Fetch = require('./plugins/fetch.ajax.js');
var Form = require('./plugins/form.js');
var FormStaged = require('./plugins/form-staged.js');
var Locrating = require('./plugins/locrating.js');
var Maps = require('./plugins/maps.google.js');
var MatchHeight = require('./plugins/match-height.js');
var MatchRow = require('./plugins/match-row.js');
var Modal = require('./plugins/modal.js');
var DateField = require('./plugins/date.js');
var Duplicate = require('./plugins/duplicate.js');
var Print = require('./plugins/print.js');
var ProxyField = require('./plugins/proxy.js');
var Reviews = require('./plugins/reviews.ajax.js');
var Save = require('./plugins/save.js');
var Scroll = require('./plugins/scroll.js');
var SideScroll = require('./plugins/side-scroll.js');
var Share = require('./plugins/share.js');
var Slider = require('./plugins/slider.slick.js');
var StatCounter = require('./plugins/stat-counter.js');
var Streets = require('./plugins/streetview.google.js');
var Submit = require('./plugins/submit.js');
var Tabs = require('./plugins/tabs.js');
var Toggle = require('./plugins/toggle.js');
var TextToggle = require('./plugins/text-toggle.js');
var Tooltip = require('./plugins/tooltip.js');
var Validation = require('./plugins/validation.js');
var Freeze = require("./plugins/freeze.js");
var YTplayer = require("./plugins/ytplayer.js");
var EnquiryType = require('./plugins/contact-enquiry-type.js');

// Require jquery extend plugins with ajax
var BranchFinder = require('./plugins/branch-finder.ajax.js');
var CraftyClicks = require('./plugins/craftyclicks.ajax.js');
var Search = require('./plugins/search.ajax.js');

// Document ready event - executes when HTML-Document is loaded and DOM is ready
$(document).on('ready', function () {
  // Restart videos
  $('video').on('ended', function () {
    this.load();
    this.play();
  });

  // Initialisers
  Header.init('#header');
  Footer.init('#footer');
  Collapse.init('.menu-item-has-children > a');
  Collapse.init('[data-collapse]');
  Copy.init('[data-copy]');
  CountdownTimer.init('.countdown-time');
  Print.init('[data-print]');
  ProxyField.init('[data-proxy]');
  Scroll.init('[data-scroll]');
  SideScroll.init('[data-sidescroll]');
  StatCounter.init('[data-stat]');
  Process.init(".process__tab");
  Toggle.init('[data-toggle]');
  Share.init('.btn-share');
  Slider.init('.slick');
  Maps.init('.map');
  Streets.init('.street');
  Form.init('.ttf-form');
  FormStaged.init('.form-staged');
  Nav.init('.nav__close');
  NavBurger.init('.nav__burger');
  Nav.init('.header__toggle');
  PropertySearch.init('.property-search');
  CraftyClicks.init('[data-craftyclicks]');
  ReadMore.init('[href="#read-more"]');
  LazyLoad.init('[data-src]');
  AutoComplete.init('[data-autocomplete]');
  BranchFinder.init('[data-branch-finder]');
  Tabs.init('[data-tab]');
  $(".statement__title--tab").statementContent();
  YTplayer.init();
  EnquiryType.init();

  Arrive.init();
  //plugin freeze
  Freeze.init("[data-freeze]");

  Valuation.init();

  // Window resize event
  $(window).on('resize', function () {
    Header.init('#header');
    Footer.init('#footer');
    MatchHeight.init('[data-match-height]');
    MatchRow.init('[data-match-row]');
  });

  // Window scroll event
  $(window).on('scroll', function () {}).trigger('scroll');

  // Custom triggers
  //
  // Maps
  $(document).on('mapShown', {}, function (event) {
    Maps.init('.map');
  });

  // Slick
  $(document).on('slickInit', {}, function (event, slick) {
    Slider.init('.slick');
  });

  // Cookie
  $(document).on('cookieStore', {}, function (event, name, value) {
    Cookie.store(name, value, 3600 * 1000 * 24 * 365);
  });

  // Header link hotfix
  $(document).on('click', '.header__nav li', function () {
    $('.header__nav li').not($(this)).each(function () {
      $(this).removeClass('show');
    });
  });
});

// Window load event - executes when complete page is fully loaded, including all frames, objects and images
$(window).on('load', function () {
  MatchHeight.init('[data-match-height]');
  MatchRow.init('[data-match-row]');
  Modal.init('.modal');
  Calculator.init('[data-calculator]');
  Fetch.init('[data-fetch]');
  Search.init('[data-search]');
  Submit.init('[data-submit]');
  TextToggle.init('[data-text]');
  Validation.init('[data-validate]');
  Accordion.init('.accordion');
  Save.init('[data-save]');
  Reviews.init('.reviews');
  Tooltip.init('.tooltip');
  Locrating.init('.locrating');
  Duplicate.init('[data-duplicate]');
  DateField.init('[data-date]');
});

// video autoplay
if ($('#autoplay-video').length) {
  setTimeout(function () {
    var myVideo = document.getElementById("autoplay-video");
    myVideo.play();
  }, 3000);
}

// Fixed property search bar
$(document).ready(function () {
  var elementOffset = $('.property-search-wrapper #property-search').offset().top;
  var elementHeight = $('.property-search-wrapper #property-search').height();

  // Window resize
  $(window).on('resize', function () {
    elementOffset = $('.property-search-wrapper #property-search').offset().top;
    elementHeight = $('.property-search-wrapper #property-search').height();
  });

  // Window scroll
  $(window).bind('scroll', function () {
    if ($(window).width() > 767) {
      var scrollTop = $(window).scrollTop();
      if (scrollTop > elementOffset - elementHeight) {
        $(".property-search-wrapper #property-search").addClass("fixed");
      } else {
        $(".property-search-wrapper #property-search").removeClass("fixed");
      }
    } else {
      $(".property-search-wrapper #property-search").removeClass("fixed");
    }
  });
});

},{"./components/calculators.js":1,"./components/read-more.js":2,"./modules/footer.js":4,"./modules/header.js":5,"./modules/nav-burger.js":6,"./modules/nav.js":7,"./modules/process.js":8,"./modules/property-search.js":9,"./modules/statement.js":10,"./modules/valuation.js":11,"./plugins/accordion.js":12,"./plugins/arrive.js":13,"./plugins/autocomplete.google.js":14,"./plugins/branch-finder.ajax.js":15,"./plugins/calculator.js":16,"./plugins/collapse.js":17,"./plugins/contact-enquiry-type.js":18,"./plugins/copy.js":19,"./plugins/countdown-timer.js":20,"./plugins/craftyclicks.ajax.js":21,"./plugins/date.js":22,"./plugins/duplicate.js":23,"./plugins/fetch.ajax.js":24,"./plugins/form-staged.js":25,"./plugins/form.js":26,"./plugins/freeze.js":27,"./plugins/locrating.js":28,"./plugins/maps.google.js":29,"./plugins/match-height.js":30,"./plugins/match-row.js":31,"./plugins/modal.js":32,"./plugins/print.js":33,"./plugins/proxy.js":34,"./plugins/reviews.ajax.js":35,"./plugins/save.js":36,"./plugins/scroll.js":37,"./plugins/search.ajax.js":38,"./plugins/share.js":39,"./plugins/side-scroll.js":40,"./plugins/slider.slick.js":41,"./plugins/stat-counter.js":42,"./plugins/streetview.google.js":43,"./plugins/submit.js":44,"./plugins/tabs.js":45,"./plugins/text-toggle.js":46,"./plugins/toggle.js":47,"./plugins/tooltip.js":48,"./plugins/validation.js":49,"./plugins/ytplayer.js":50,"./utility/cookie.js":51,"./utility/done-typing.js":52,"./utility/lazy-load.js":53,"./utility/object-entries.js":54,"./utility/request-timeout.js":55,"./utility/tabbing.js":56}],4:[function(require,module,exports){
'use strict';

var $ = jQuery.noConflict();

var self = module.exports = {
  init: function init(target) {
    self.service.css(target);
  },

  service: {
    css: function css(target) {
      var wrapper = $('#wrapper');
      var height = $(target).outerHeight();
      // console.log(height)
      $(wrapper).css('min-height', 'calc(100% - ' + height + 'px)');
    }
  }
};

function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1);
  var sURLVariables = sPageURL.split('&');
  var sParameterName = '';
  var i = 0;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
    }
  }
};

/*get ulr parameter floorplan and scroll ab active floorplan tab*/

function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
    }
  }
};

var floortab = getUrlParameter('vtour');

if (floortab) {
  $('#property-tabs > div').removeClass('active');
  $('#property-tabs > #property-tabs-vtour').addClass('active');
  $('.property-content__tabs li').removeClass('active');
  $('.property-content__tabs li[data-tab="#property-tabs-vtour"]').addClass('active');

  $('html, body').animate({
    scrollTop: $('#property-tabs').offset().top
  }, 1000);
}

setInterval(function () {
  jQuery('#property-valuation-address').attr('autocomplete', 'chrome-off');
  jQuery('#property-valuation-address').attr('autocomplete', 'chrome-off');
}, 1000);

jQuery('#property-valuation-address').on('keyup', function () {
  jQuery('#property-valuation-address').attr('autocomplete', 'chrome-off');
});

$(".popular-search__title").click(function () {
  $(this).toggleClass('active');
  $(".popular-search__content").slideToggle();
});

var footer__top = $('.footer__top');

$(window).scroll(function () {
  if ($(window).scrollTop() > 1000) {
    $('.footer__top').addClass('show');
  } else {
    $('.footer__top').removeClass('show');
  }
});

$('.footer__top').on('click', function (e) {
  e.preventDefault();
  $('html, body').animate({ scrollTop: 0 }, '300');
});

},{}],5:[function(require,module,exports){
'use strict';

var $ = jQuery.noConflict();

var self = module.exports = {
  init: function init(target) {
    var body = $('body');
    var height = $(target).outerHeight();
    var inner = $(target).find('.header').outerHeight();
    var topbar = $(target).find('.topbar').outerHeight();
    var next = $('#wrapper').find('section').first();
    var hero = $(next).find('.hero-large');

    if ($(target).hasClass('transparent') && hero.length) {
      self.service.padding(body, topbar, 'top');
      self.service.height(hero, topbar);
    } else {
      self.service.padding(body, height, 'top');

      if (hero.length) {
        self.service.height(hero, height);
      }
    }

    self.events.scroll(target, height, topbar);
  },

  events: {
    scroll: function scroll(target, height, topbar) {
      var lastScrollTop = 0;

      $(window).on('scroll', function () {
        var st = $(this).scrollTop();
        self.service.class.toggle(target, topbar);
        self.service.padding(parent, height, 'top');

        if (st > lastScrollTop && st > 100) {
          $(target).removeClass('show').addClass('hide');
          $('.fixed-banner').removeClass('show').addClass('hide');
          $(target).css('transform', 'translateY(-' + topbar + 'px)');
        } else {
          $(target).removeClass('hide').addClass('show');
          $('.fixed-banner').removeClass('hide').addClass('show');
          $(target).css('transform', 'translateY(0)');
        }

        lastScrollTop = st;
      });
    }
  },

  service: {
    padding: function padding(target, height, position) {
      if (position === 'top') {
        $(target).css('padding-top', height);
      } else {
        $(target).css('padding-bottom', height);
      }
    },

    height: function height(target, _height) {
      var minHeight = 'calc(100vh - ' + _height + 'px)';
      $(target).css('height', minHeight);
    },

    position: function position() {
      var top = $(window).scrollTop();
      return top;
    },

    class: {
      toggle: function toggle(target) {
        if (self.service.position() > 100) {
          self.service.class.add(target);
        } else {
          self.service.class.remove(target);
        }
      },

      add: function add(target) {
        $(target).addClass('scrolled');
      },

      remove: function remove(target) {
        $(target).removeClass('scrolled');
      }
    }
  }

  // show branch nav on header

};$(".branch-dropdown").on("click", function (event) {
  event.preventDefault();
  $('#branch-nav').addClass('show');
});

$(".header__close").on("click", function () {
  $('#branch-nav').removeClass('show');
});

},{}],6:[function(require,module,exports){
'use strict';

var $ = jQuery.noConflict();

var self = module.exports = {

  init: function init(menu) {

    // Prepend title from parent link text
    $(menu).find('li').each(function () {
      if ($(this).hasClass('menu-item-has-children')) {
        var title = $(this).find('a').first().text();
        var submenu = $(this).find('.sub-menu');

        // $(submenu).prepend('<li class="h4 hidden-sm-down" style="margin-bottom: 1rem;">' + title + '</li>')
        // $(submenu).append('<div></div>')

        // var items = $(submenu).find('li')
        // var div = $(submenu).find('div').first()
        // $(items).each(function() {
        //   // $(this).appendTo(div)
        // })
      }
    });

    // Add click event to apply active class
    $(menu + ' li a').on('click', function () {
      $(menu + ' li a').removeClass('active');
      $(this).addClass('active');
    });
  },

  events: {
    click: function click(trigger) {}
  },

  service: {
    bodyClass: function bodyClass() {}
  }
};

},{}],7:[function(require,module,exports){
'use strict';

var $ = jQuery.noConflict();

var self = module.exports = {
  init: function init(trigger) {
    self.events.click(trigger);
    self.events.clickOutside(trigger);
  },

  events: {
    click: function click(trigger) {
      $(document).on('click', trigger, function () {
        self.service.bodyClass($(this));
      });
    },
    clickOutside: function clickOutside(trigger) {
      $(document).on("click", function (event) {

        var target = $(event.target);

        if ($(target).closest('.header').length) {} else {
          $('.sub-menu').removeClass('show');
          $('.header__nav .menu-item-has-children').removeClass('show');
        }
      });
    }
  },

  service: {
    bodyClass: function bodyClass(target) {
      if ($(target).is("#nav-toggle")) {
        $('body').addClass('prevent-scroll');
      } else {
        $('body').removeClass('prevent-scroll');
      }
    }
  }
};

},{}],8:[function(require,module,exports){
'use strict';

var $ = jQuery.noConflict();

var self = module.exports = {
  init: function init(trigger) {
    self.events.click(trigger);
  },

  events: {
    click: function click(trigger) {
      $(trigger).on('click', function () {
        self.service.disableSiblings($(this));
        self.service.activateTab($(this));
      });
    }
  },

  service: {
    disableSiblings: function disableSiblings(target) {},
    activateTab: function activateTab(target) {
      $('.process__tabs .process__tab').not($(target)).removeClass('active');
      $(target).toggleClass('active');
    }
  }
};

},{}],9:[function(require,module,exports){
'use strict';

var $ = jQuery.noConflict();

var self = module.exports = {
  props: {
    filters: {
      field: '.property-search__field',
      container: '.property-search__filters'
    },
    toggle: {
      parent: '[data-toggle-parent]'
    }
  },

  init: function init(form) {
    self.events.change(form);
    self.events.toggleTrigger(self.props.toggle.parent);

    $(form).each(function () {
      self.service.filter(this, self.props.filters.field);
    });
  },

  events: {
    change: function change(form) {
      $(form).on('change', 'input[type=radio], input[type=checkbox], input[type=text], select', function () {
        var parent = $(this);
        var alerts = $(form).data('alerts');
        var name = $(this).attr('name');
        var target = $(alerts).find('[name=' + name + ']');
        var value = $(this).val();

        if ($(this).is(':radio') && $(this).prop('checked')) {
          $(target).each(function () {
            var val = $(this).val();
            if (val == value) {
              $(this).prop('checked', true);
            } else {
              $(this).prop('checked', false);
            }
          });
        } else if ($(this).is(':checkbox')) {
          $(target).each(function () {
            var val = $(this).val();
            if (val == value) {
              if ($(parent).prop('checked')) {
                $(this).prop('checked', true);
              } else {
                $(this).prop('checked', false);
              }
            }
          });
        } else {
          $(target).val(value);
        }
      });
    },

    toggleTrigger: function toggleTrigger(parent) {
      $(document).on('change', parent, function (e) {
        var trigger = e.target;
        self.service.toggle($(trigger));
      });
    }
  },

  service: {
    filter: function filter(form, fields) {
      var filter = $(form).find(self.props.filters.container);

      $(fields).each(function () {
        var display = $(this).css('display');

        if (display === 'none') {
          $(filter).find('> .row').append($(this));
          $(this).removeClass('hidden-sm-down hidden-md-down hidden-lg-down hidden-xl-down hidden-xxl-down');
          $(this).css('display', 'block');
        }
      });
    },

    toggle: function toggle(trigger) {
      var group = $(trigger).data('toggle-parent');
      var match = $(trigger).val();
      var target = '[data-toggle-group="' + group + '"]';

      $(target).each(function () {
        var value = $(this).data('toggle-value');
        if (value === match) {
          $(this).addClass('show');
        } else {
          $(this).removeClass('show');
        }
      });
    }
  }
};

},{}],10:[function(require,module,exports){
'use strict';

var $ = jQuery.noConflict();

$.fn.extend({
  statementContent: function statementContent() {
    self.init('.statement__title--tab');
  }
});

var self = module.exports = {
  init: function init(trigger) {
    // console.log(trigger);
    self.events.hover(trigger);
    self.events.click();
  },

  events: {
    hover: function hover(trigger) {
      $(trigger).on('mouseover', function () {
        var imageTarget = $(this).data('statement-content');
        self.service.disableSiblings($(this), imageTarget);
        self.service.activateTab($(this), imageTarget);
      });
    },
    click: function click(trigger) {
      $('.statement__title--mobile').on('click', function () {
        var $this = $(this);

        if ($this.next().hasClass('show')) {
          $this.next().removeClass('show');
          $this.next().slideUp(350);
          $this.removeClass('active');
        } else {
          $this.parent().parent().find('.statement__content .statement__inner-content').removeClass('show');
          $this.parent().parent().find('.statement__title--mobile').removeClass('active');
          $this.parent().parent().find('.statement__content .statement__inner-content').slideUp(350);
          $this.next().toggleClass('show');
          $this.toggleClass('active');
          $this.next().slideToggle(350);
        }
      });
    }
  },

  service: {
    disableSiblings: function disableSiblings(target, imageTarget) {
      $(target).siblings().removeClass('active');
      $(imageTarget).siblings().removeClass('active');
    },
    activateTab: function activateTab(target, imageTarget) {
      $(target).addClass('active');
      $(imageTarget).addClass('active');
    }
  }
};

},{}],11:[function(require,module,exports){
'use strict';

var $ = jQuery.noConflict();

$.fn.extend({
  instantvaluation: function instantvaluation() {
    self.init(this.selector);
  }
});

var self = module.exports = {
  init: function init(trigger) {
    var data = {
      action: 'valpal',
      nonce: '',
      postcode: '',
      phone: '',
      bedrooms: '1',
      email: '',
      address: '',
      street: ''
    };

    $(trigger).on('click', '#instant-valuation-next .form-staged__next', function (e) {
      var responseDiv = $(trigger).attr('data-response-div');

      var data = {
        // action: 'valpal',
        // nonce: document.getElementById('instant-valuation_nonce_field').value,
        // address: document.getElementById('instant-valuation-address').value,
        // buildname: document.getElementById('instant-valuation-build_name').value,
        // subBname: document.getElementById('instant-valuation-sub_build_name').value,
        // number: document.getElementById('instant-valuation-street_number').value,
        // street: document.getElementById('instant-valuation-street_name').value,
        // postcode: document.getElementById('instant-valuation-postal_code').value,
        // forename: document.getElementById('instant-valuation-forename').value,
        // surname: document.getElementById('instant-valuation-surname').value,
        // phone: document.getElementById('instant-valuation-telephone').value,
        // emailaddress: document.getElementById('instant-valuation-email').value,
        // propertytype: document.getElementById('instant-valuation-property-type').value,
        // bedrooms: document.getElementById('instant-valuation-bedrooms-min').value
      };

      $('#' + responseDiv).hide();
      $('.estimate--range .range--value').html('Estimating...');
      $('.estimate--range .predicted--value').html('Estimating...');

      $.ajax({
        type: 'POST',
        // eslint-disable-next-line no-undef
        url: myAjax.ajaxurl,
        data: data,
        success: function success(response) {
          if (response.success) {
            var data = JSON.parse(response.data.data);
            var apiSuccess = data[0];
            var apiErrors = data[1];
            var apiResults = data[2];

            if (apiSuccess.status !== 'success') {
              $('#' + responseDiv).html('<div class="valpal-response">' + apiErrors.errors.message + '</div>').show();
            }

            $('.estimate--range .range--value').html(apiResults.results.minvaluation + '-' + apiResults.results.maxvaluation).show();

            $('#instant-valuation-sale-value').val(apiResults.results.minvaluation + '-' + apiResults.results.maxvaluation);

            $('.estimate--range .predicted--value').html('Predicted value = ' + apiResults.results.valuation).show();

            $('#instant-valuation-rental-value').val(apiResults.results.rentalvaluation);
          } else {
            // console.log('error case', response)
          }
        }
      });
      // return false;
    });

    $(document).on('click', '.pac-container.pac-logo .pac-item', function () {
      //$('#filledInstantValuationAdd').css('display', 'block');
      $('.property_val').find('.form-staged__next').trigger('click');
    });
  }
};

},{}],12:[function(require,module,exports){
'use strict';

var $ = jQuery.noConflict();

var self = module.exports = {
  options: {
    trigger: '',
    panel: '',
    content: ''
  },

  init: function init(selector) {
    self.options.trigger = '[data-' + selector.replace('.', '') + ']';
    self.options.panel = selector + '__panel';
    self.options.content = selector + '__content';
    self.events.click(selector);

    $(selector).each(function () {
      self.service.showInit(this);
    });
  },

  events: {
    click: function click(selector) {
      $(document).on('click', selector + ' ' + self.options.trigger, function (e) {
        var trigger = e.target;
        var parent = $(trigger).closest(selector);
        var panel = $(trigger).closest(self.options.panel);

        $(panel).addClass('activating');

        if ($(this).hasClass('disable') || $(panel).hasClass('active') && $(this).hasClass('disable-on-active')) {
          return;
        }

        if ($(parent).data('exclusive')) {
          self.service.hideAll(parent);
        }

        if ($(panel).hasClass('active')) {
          self.service.hide(panel, this);
        } else {
          self.service.show(panel, this);
        }

        e.preventDefault(); // Prevent default action of button
      });
    }
  },

  service: {
    showInit: function showInit(parent) {
      var panels = $(parent).find(self.options.panel);

      $(panels).each(function () {
        if ($(this).hasClass('active')) {
          var panel = $(this);
          var target = $(panel).find(self.options.content);

          $(target).not(':animated').slideDown(100);
        }
      });
    },

    hideAll: function hideAll(parent) {
      var panels = $(parent).find(self.options.panel);

      $(panels).each(function () {
        if (!$(this).hasClass('activating')) {
          var panel = $(this);
          var target = $(panel).find(self.options.content);

          $(panel).removeClass('active');
          $(target).not(':animated').slideUp(100);
        }
      });
    },

    hide: function hide(parent, link) {
      var target = $(link).data('accordion') || $(link).attr('href');
      var content = $(parent).find(target);

      $(parent).removeClass('active');
      $(content).not(':animated').slideUp(100);
      $(parent).removeClass('activating');
    },

    show: function show(parent, link) {
      var target = $(link).data('accordion') || $(link).attr('href');
      var content = $(parent).find(target);

      $(parent).addClass('active');
      $(content).not(':animated').slideDown(100);
      $(parent).removeClass('activating');
    }
  }
};

},{}],13:[function(require,module,exports){
'use strict';

var $ = jQuery.noConflict();

var self = module.exports = {

  // Methods
  initiated: false,

  init: function init(args) {

    if (!self.service.hasRaf()) {
      return;
    }

    self.customTriggers = $('[data-trigger]');
    self.triggers = $('.arrive:not(.arrive--delayed):not(.arrived):not([data-target])');

    self.loop();
    self.initiated = true;
  },

  loop: function loop() {
    self.service.sweep(self.triggers, self.customTriggers);

    window.requestAnimationFrame(function () {
      self.loop(self.triggers, self.customTriggers);
    });
  },

  // Services

  /**
  * Service Class
  * @type {Object}
  */
  service: {

    /**
    * Check for ARF
    * @return {Boolean} Returns true if the user is on a mobile.
    */
    hasRaf: function hasRaf() {
      if (typeof Modernizr !== 'undefined') {
        if (!Modernizr.requestanimationframe) {
          $('body').addClass('arrive--disable');
          return false;
        } else {
          return true;
        }
      }
    },

    /**
    * Force an arrival.
    * @param  {$Object} arrival The arrival element(s)
    * @return {null}
    */
    forceArrival: function forceArrival(arrival) {
      if (typeof arrival == 'undefined' || !arrival) {
        arrival = $('.arrive');
      }

      arrival.each(function () {
        var $this = $(this);
        $this.addClass('arrived');
      });
    },

    /**
    * Reset arrivals
    * @param {Function} callback [description]
    */
    reset: function reset(arrival, callback) {
      if (typeof arrival == 'undefined' || !arrival) {
        arrival = $('.arrived:not(.arrive--ignore-reset)');
      }

      arrival.removeClass('arrived');

      if (typeof callback !== 'undefined') {
        callback();
      }
    },

    atTriggerPosition: function atTriggerPosition(el) {
      var $this = el;
      var $window = $(window);
      var view_top = $window.scrollTop();
      var view_bottom = view_top + $window.height() - 100;
      var trigger_position = $this.offset().top;
      var offset = $this.attr('data-offset');

      if (typeof offset !== 'undefined') {
        trigger_position = trigger_position - offset;
      }

      if (trigger_position <= view_bottom) {
        return true;
      } else {
        return false;
      }
    },

    sweep: function sweep($triggers, $custom_triggers) {

      $triggers.not('.arrived').not('[data-target]').not('.arrive--delayed').each(function () {

        var $this = $(this);

        if (self.service.atTriggerPosition($this)) {
          var delay = $this.data('delay') ? $this.data('delay') : 0;

          $this.addClass('arrive--delayed');

          window.requestTimeout(function () {
            $this.removeClass('arrive--delayed');
            $this.addClass('arrived');
          }, delay);
        }
      });

      if ($custom_triggers.length) {
        $custom_triggers.not('.arrived').not('.arrive--delayed').each(function () {
          var $this = $(this);

          if (self.service.atTriggerPosition($this)) {

            var delay = $this.data('delay') ? $this.data('delay') : 0;

            $this.addClass('arrive--delayed');

            window.requestTimeout(function () {
              $this.removeClass('arrive--delayed');
              $this.addClass('arrived');

              var target = $this.data('trigger');
              target = $('[data-target="' + target + '"]');

              target.not('.arrived').each(function () {

                var $this = $(this);
                var target_delay = $this.data('delay') ? $this.data('delay') : 0;
                $this.addClass('arrive--delayed');

                window.requestTimeout(function () {
                  $this.removeClass('arrive--delayed');
                  $this.addClass('arrived');
                }, target_delay);
              });
            }, delay);
          }
        });
      }
    }
  }
};

},{}],14:[function(require,module,exports){
'use strict';

var $ = jQuery.noConflict();

$.fn.extend({
  autocomplete: function autocomplete() {
    self.init(this.selector);
  }
});

var self = module.exports = {
  options: {
    country: 'GB',
    types: ['geocode', 'establishment']
  },

  init: function init(selector) {
    $(selector).each(function () {
      self.events.init(this);
    });
  },

  events: {
    init: function init(field) {
      self.service.initField(field);
    }
  },

  service: {
    initField: function initField(field) {
      $(field).on('click', function (event) {
        var id = $(field).attr('id');
        var types = typeof $(field).data('types') === 'undefined' ? self.options.types : $(field).data('types');
        var input = document.getElementById(id);
        var options = {
          types: types,
          componentRestrictions: {
            country: self.options.country
          }
        };

        var componentForm = {
          street_number: 'long_name',
          route: 'long_name',
          postal_town: 'long_name',
          country: 'long_name',
          postal_code: 'short_name'
          // eslint-disable-next-line no-undef
        };var autocomplete = new google.maps.places.Autocomplete(input, options);

        autocomplete.setFields(['address_component']);
        // eslint-disable-next-line no-undef
        google.maps.event.addListener(autocomplete, 'place_changed', function () {
          $(input).change();

          var place = autocomplete.getPlace();
          if (!place) {
            // Inform the user that a place was not found and return.
            return;
          }

          document.querySelector('#filledInstantValuationAdd').style.display = 'block';

          try {
            // Get each component of the address from the place details,
            // and then fill-in the corresponding field on the form.
            for (var index = 0; index < place.address_components.length; index++) {
              var element = place.address_components[index];
              var addressType = element.types[0];
              //$('.property_val').find('.form-staged__next').trigger('click'); 
              // console.log(addressType);
              // console.log('element    '+ JSON.stringify(element));

              if (componentForm[addressType]) {
                var val = element[componentForm[addressType]];
                document.getElementById('property-valuation-' + addressType).value = val;
              }
            }
          } catch (error) {
            console.log('Google autocomplete error', error);
          }
          // end
        });

        // $(field).removeAttr('autocomplete')
        $(field).attr('autocomplete', 'chrome-off');
      });
    }
  }
};

},{}],15:[function(require,module,exports){
'use strict';

var $ = jQuery.noConflict();

var self = module.exports = {
  options: {
    action: 'search',
    method: 'GET',
    url: ajax.ajaxurl,
    dataType: 'json',
    contentType: false,
    processData: false,
    cookie: 'branch'
  },

  init: function init(selector) {
    self.events.change(selector);
    self.events.choose('[data-id]');
  },

  events: {
    change: function change(field) {

      var tenure_type = $("input[name='valuation']:checked").val();

      $(document).on('change', 'input[name="valuation"]', function () {
        tenure_type = $(this).val();

        if ($(field).val() != '') {
          $(field).change();
        }
      });

      $(document).on('change', field, function () {
        var location = $(this).val();
        var radius = 600;
        var per = 3;
        var sort = 'distance';

        if (location === '') {
          radius = 999999;
          per = -1;
          sort = 'title-asc';
        }

        var target = $(this).data('target');
        var data = {
          action: self.options.action,
          'type': 'branch',
          'view': 'option',
          'per-page': per,
          'sort': sort,
          'location': location,
          'radius': radius,
          'tenure_type': tenure_type
        };

        $(target).removeClass('loaded');
        $(target).html('');

        data = $.param(data);
        self.service.post(this, data);
      });
    },

    choose: function choose(field) {
      $(document).on('change', field, function () {
        var id = $(this).data('id');
        if ($(this).prop('checked')) {
          $(document).trigger('cookieStore', [self.options.cookie, id]);
        }
      });
    }
  },

  service: {
    post: function post(field, data) {
      $.ajax({
        method: self.options.method,
        url: self.options.url,
        data: data,
        dataType: self.options.dataType,
        contentType: self.options.contentType,
        processData: self.options.processData,
        success: function success(response) {
          self.service.show(response, field);
        },
        error: function error(data) {
          // console.log(data)
        }
      });
    },

    show: function show(response, field) {
      var target = $(field).data('target');
      $(target).addClass('loaded');
      $(target).html(response.html);
      $(target).trigger('change');
    }
  }
};

},{}],16:[function(require,module,exports){
'use strict';

var $ = jQuery.noConflict();

var self = module.exports = {
  options: {
    incrementor: '[data-increment]'
  },

  init: function init(form) {
    self.events.increment(self.options.incrementor);
    self.events.submit(form);

    $(form).each(function () {
      var calculate = $(this).data('calculator');
      var data = self.service.data(this);

      self.events.change(this);
      self.service[calculate](this, data);
    });
  },

  events: {
    submit: function submit(form) {
      $(document).on('submit', form, function (e) {
        var calculate = $(this).data('calculator');
        var data = self.service.data(this);
        e.preventDefault();
        self.service[calculate](this, data);
      });
    },

    change: function change(form) {
      $(form).on('change', 'input, select, textarea', function (event) {
        var form = $(this).closest('form');
        $(form).trigger('submit');
      });
    },

    increment: function increment(trigger) {
      $(document).on('click', trigger, function (event) {
        var el = this;
        var target = $(el).closest('.form-group').find('input[type="number"]');
        var increment = $(el).data('increment');
        var form = $(el).closest('form');

        self.service.increment(target, increment);
        $(form).trigger('submit');
      });
    }
  },

  service: {
    beautify: function beautify(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },

    result: function result(form, _result) {
      var target = $(form).find('[data-result]');

      target.text(self.service.beautify(_result));
    },

    results: function results(form, _results) {
      var targets = $(form).find('[data-result]');
      var i = 0;

      $(targets).each(function () {
        if (typeof _results === 'string') {
          $(this).text(self.service.beautify(_results));
        } else {
          $(this).text(self.service.beautify(_results[i]));
          i++;
        }
      });
    },

    increment: function increment(target, _increment) {
      var input = $(target).val();
      var decimals = $(target).data('decimals');
      var min = $(target).attr('min') ? $(target).attr('min') : false;
      var max = $(target).attr('max') ? $(target).attr('max') : false;
      var output = null;
      var valid = true;
      input = parseFloat(input);
      _increment = parseFloat(_increment);
      output = parseFloat(input + _increment);

      if (decimals > 0) {
        output = parseFloat(output.toFixed(decimals));
      }

      if (min !== false && output < min) {
        valid = false;
      }

      if (max !== false && output > max) {
        valid = false;
      }

      if (valid === true) {
        $(target).val(output);
      }
    },

    data: function data(form) {
      var formArray = $(form).serializeArray();
      var data = {};

      for (var i = 0; i < formArray.length; i++) {
        data[formArray[i]['name']] = isNaN(parseFloat(formArray[i]['value'])) ? formArray[i]['value'] : parseFloat(formArray[i]['value']);
      }

      return data;
    },

    mortgage: function mortgage(form, data) {
      data.loan = data.price - data.deposit;
      data.rateCalc = data.rate / 100 / 12;
      data.lengthCalc = data.length * 12;
      data.exponent = Math.pow(1 + data.rateCalc, -data.lengthCalc);
      var monthly = Math.round(data.loan * data.rateCalc / (1 - data.exponent));

      self.service.result(form, monthly);
    },

    yield: function _yield(form, data) {
      var value = 0;
      value = (data.rent * 12 / data.value * 100 + 0.00001).toFixed(2);

      self.service.result(form, value);
    },

    helptobuy: function helptobuy(form, data) {
      var results = [];
      var loan = data.price * .2;
      var mortgage = data.price - (data.deposit + loan);

      results.push(loan, mortgage);

      self.service.results(form, results);
    },

    stamp: function stamp(form, data) {
      var currentDate = new Date();
      var holidayStart = new Date("2020-07-08");
      // var holidayEnd = new Date('2021-07-01')
      var holidayEnd = new Date("2021-10-01"); // Bug in enddate
      var holidayActive = false;
      var reducedRateStartDate = holidayEnd;
      var reducedRateEndDate = new Date("2021-10-01");
      var reducedRateActive = false;

      var bands = [0, 250000, 925000, 1500000];
      var rates = [0, 0.05, 0.1, 0.12];
      var amounts = [];
      var stampDuty = 0;

      if (currentDate >= holidayStart && currentDate < holidayEnd) {
        holidayActive = true;
        bands = [0, 250000, 925000, 1500000]; // old value < 4 aug : [0, 500000, 925000, 1500000];
        rates = [0, 0.05, 0.1, 0.12];
      }

      // Adjust bands and rates for reduced rate of stamp duty after holiday ends.
      if (currentDate >= reducedRateStartDate && currentDate < reducedRateEndDate) {
        reducedRateActive = true;
        bands = [0, 250000, 925000, 1500000];
        rates = [0, 0.05, 0.1, 0.12];
      }

      if (data.type === "first" && data.price <= 625000) {
        if (holidayActive) {
          // Adjust bands and rates for stamp duty holiday
          bands = [0];
          rates = [0];
        } else {
          // Adjust bands and rates for threshold
          bands = [0, 425000]; //300000
          rates = [0, 0.05];
        }
      } else if (data.type === "additional") {
        if (holidayActive || reducedRateActive) {
          // Adjust rates for stamp duty holiday
          rates = [0.03, 0.08, 0.13, 0.15];
        } else {
          // Modified stamp duty on additional owned properties
          var modifier = 0.03;
          rates = rates.map(function (val) {
            val = val + modifier;
            return val;
          });
        }
        if (data.price < 40000) {
          // No stamp duty on additional properties under 40,000
          rates[0] = 0;
        }
      }
      /*
       * Stampy duty calculation (Part 1)
       */
      for (var i = 0; i < bands.length; i++) {
        if (data.price > bands[i]) {
          if (i === bands.length - 1 || data.price - bands[i + 1] < 0) {
            amounts[i] = data.price - bands[i];
          } else {
            amounts[i] = bands[i + 1] - bands[i];
          }
        }
      }
      /*
       * Stampy duty calculation (Part 2)
       *
       * For each value in the amounts array, apply the appropraite rate
       * to the amount and add it to the stamp duty total.
       */
      for (var _i = 0; _i < amounts.length; _i++) {
        stampDuty = stampDuty + amounts[_i] * rates[_i];
      }
      stampDuty = parseFloat(stampDuty).toFixed(2);
      self.service.results(form, self.service.beautify(stampDuty));
    }
  }
};

},{}],17:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var $ = jQuery.noConflict();
var Cookie = require('../utility/cookie.js');

var self = module.exports = {
  cookie: 'cookie-policy',

  init: function init(trigger) {
    self.events.click(trigger);
  },

  events: {
    click: function click(trigger) {
      $(document).on('click', trigger, function (event) {
        var target;

        if ($(this).parent().hasClass('menu-item-has-children')) {
          target = $(this).siblings('.sub-menu');
        } else if ($(this).hasClass('nav__close')) {
          target = $(this).data('collapse');
        } else {
          target = $(this).data('collapse');
        }

        if ($(this).is('a, button')) {
          event.preventDefault();
        }

        if ($(this).is('a, button')) {

          if ($(this).attr('data-collapse') == '#property-search-filters') {
            $(this).parent().toggleClass('show');
            $('.property-search__filters').slideToggle('fast');
          }
          event.preventDefault();
        }

        self.service.toggle(target);
      });
    }
  },

  service: {
    toggle: function toggle(target) {
      var el = $(target).closest('.menu-item-has-children');
      var group = _typeof($(target).data('group')) ? $('[data-group="' + $(target).data('group') + '"]') : null;
      var nav = $(target).hasClass('sub-menu') ? $(target).closest('.nav__burger') : null;

      if (group) {
        self.service.hideGroup(group, target);
      }

      if (nav) {
        self.service.hideGroup('.sub-menu', target);
        $(el).siblings().removeClass('show');
        $(el).toggleClass('show');
      }

      if ($(target).hasClass('show')) {
        $(target).removeClass('show');

        if (nav) {
          $(nav).removeClass('double');
        }

        if ($(target).hasClass('nav')) {
          $(target).removeClass('double');
          self.service.hideGroup('.sub-menu', target);
        }
      } else {
        $(target).addClass('show');

        if (nav) {
          $(nav).addClass('double');
        }
      }

      if (target === '#alert-cookie') {
        // console.log('hello')
        Cookie.store(self.cookie, 'accepted');
      }
    },

    hideGroup: function hideGroup(group, target) {
      $(group).not(target).each(function () {
        $(this).removeClass('show');
      });
    }
  }
};

},{"../utility/cookie.js":51}],18:[function(require,module,exports){
'use strict';

var $ = jQuery.noConflict();

var self = module.exports = {
  init: function init(trigger) {
    self.events.click(trigger);
    self.data = [];

    $("select[name='enquiry-type'] option").each(function (index, elem) {
      self.data.push({ type: $(elem).data('etype'), value: $(elem).val(), name: $(elem).text() });
    });

    self.service.manageOptions($('select[name="branch-enquiry-type"]'));
  },

  events: {
    click: function click(trigger) {
      $(document).on('change', '#contact-branch-enquiry-type', function (event) {
        event.preventDefault();
        self.service.manageOptions(event.target);
      });
    }
  },

  service: {
    manageOptions: function manageOptions(target) {
      var selectedValue = $(target).find(":selected").val(),
          optionHtml = "",
          selectedDataType = $(target).find(":selected").data('type');

      $("select[name='enquiry-type']").prop('selectedIndex', 0).change();

      if (selectedDataType == 'global') {
        optionHtml = '';
        $(target).parent().next().hide();
      } else {
        $(target).parent().next().show();
      }

      self.data.map(function (elem) {
        if (selectedValue == elem.type) {
          optionHtml += '<option value="' + elem.value + '">' + elem.name + '</option>';
        }
      });

      $('#contact-enquiry-type').html(optionHtml);
    }
  }
};

},{}],19:[function(require,module,exports){
'use strict';

var $ = jQuery.noConflict();

$.fn.extend({
  copy: function copy() {
    self.init(this.selector);
  }
});

var self = module.exports = {
  init: function init(trigger) {
    self.events.click(trigger);
  },

  events: {
    click: function click(trigger) {
      $(document).on('click', trigger, function (event) {
        var text = $(this).data('text') ? $(this).data('text') : $(this).attr('href');

        event.preventDefault();
        self.service.class(this);
        self.service.copy(text);
        self.service.reset(this);
      });
    }
  },

  service: {
    class: function _class(target) {
      $(target).addClass('copied').blur();
    },

    copy: function copy(text) {
      var temp = $('<input>');
      $('body').append(temp);
      temp.val(text).select();
      document.execCommand('copy');
      temp.remove();
    },
    reset: function reset(target) {
      clearTimeout(self.timeOut);
      self.timeOut = setTimeout(function () {
        $(target).removeClass('copied').blur();
      }, 2000);
    }
  }
};

},{}],20:[function(require,module,exports){
'use strict';

var $ = jQuery.noConflict();

var self = module.exports = {
  init: function init(trigger) {
    $(trigger).each(function () {
      var endTime = $(this).data('countdown-timer-date');
      var ended = $(this).closest('.countdown-timer').find('[data-countdown-timer-ended]');
      // var endTime = '02 Jan 1970 00:00:00 GMT'

      if (endTime) {
        self.event.interval(this, endTime, ended);
      }
    });
  },

  event: {
    interval: function interval(countdownTimer, endTime, ended) {
      self.service.makeTimer(countdownTimer, endTime, ended);

      setInterval(function () {
        self.service.makeTimer(countdownTimer, endTime, ended);
      }, 1000);
    }
  },

  service: {
    makeTimer: function makeTimer(countdownTimer, endTime, ended) {
      endTime = Date.parse(endTime) / 1000;

      var now = new Date();
      now = Date.parse(now) / 1000;

      var timeLeft = endTime - now;

      if (timeLeft <= 0) {
        var days = 0;
        var hours = 0;
        var minutes = 0;
        var seconds = 0;

        if (ended) {
          ended.text(ended.data('countdown-timer-ended'));
        }
      } else {
        var days = Math.floor(timeLeft / 86400);
        var hours = Math.floor((timeLeft - days * 86400) / 3600);
        var minutes = Math.floor((timeLeft - days * 86400 - hours * 3600) / 60);
        var seconds = Math.floor(timeLeft - days * 86400 - hours * 3600 - minutes * 60);
      }

      if (hours < "10") {
        hours = "0" + hours;
      }

      if (minutes < "10") {
        minutes = "0" + minutes;
      }

      if (seconds < "10") {
        seconds = "0" + seconds;
      }

      $(countdownTimer).children('.days').html(days + "<span>Days</span>");
      $(countdownTimer).children('.hours').html(hours + "<span>Hours</span>");
      $(countdownTimer).children('.minutes').html(minutes + "<span>Minutes</span>");
      $(countdownTimer).children('.seconds').html(seconds + "<span>Seconds</span>");
    }
  }
};

},{}],21:[function(require,module,exports){
'use strict';

var $ = jQuery.noConflict();

var CRAFTYCLICKS = {};

CRAFTYCLICKS.url = 'https://pcls1.CRAFTYCLICKS.co.uk/json/rapidaddress';
CRAFTYCLICKS.response = 'data_formatted';
CRAFTYCLICKS.sort = 'asc';
CRAFTYCLICKS.key = '7e1b6-56b1e-300e8-05a93';
CRAFTYCLICKS.hint = '<option>Look up your address by entering your postcode and clicking \'Find Address\'</option>';

// $.fn.craftyclicks = function() {
//   var trigger = $(this);

//   $(trigger).each(function() {
//     CRAFTYCLICKS.init(this);
//   });
// };

var self = module.exports = {
  init: function init(trigger) {
    $(trigger).on('change', function () {
      CRAFTYCLICKS.trigger(this);
    });
  }
};

CRAFTYCLICKS.trigger = function (trigger) {
  var input = $(trigger);
  var output = $(trigger).data('target');
  var postcode = $(input).val();

  CRAFTYCLICKS.getData(output, postcode);
};

CRAFTYCLICKS.processData = function (output, data) {
  var options = CRAFTYCLICKS.sortData(data);
  CRAFTYCLICKS.update(output, options);
};

CRAFTYCLICKS.reset = function (output, error) {
  $(output).prop('disabled', true);
  // console.log(error);

  if (error) {
    var html = '<option>' + error + '</option>';
    $(output).html(html);
  } else {
    $(output).html(CRAFTYCLICKS.hint);
  }
};

CRAFTYCLICKS.update = function (output, options) {
  $(output).html('');
  $(output).prop('disabled', false);

  for (var i = 0; i < options.length; i++) {
    $(output).append('<option value="' + options[i] + '">' + options[i] + '</option>');
  }

  $(output).closest('.form-group').removeClass('display-none');
};

// Get the address data
CRAFTYCLICKS.getData = function (output, postcode) {
  $.ajax({
    url: CRAFTYCLICKS.url,
    dataType: 'jsonp',
    data: {
      postcode: postcode,
      response: CRAFTYCLICKS.response,
      sort: CRAFTYCLICKS.sort,
      key: CRAFTYCLICKS.key
    },
    success: function success(data) {
      if (data.error_code != undefined) {
        CRAFTYCLICKS.reset(output, data.error_msg);
      } else {
        CRAFTYCLICKS.processData(output, data);
      }
    }
  });
};

// Sort data into array of address strings
CRAFTYCLICKS.sortData = function (data) {
  var town = data.town;
  var postcode = data.postcode;
  var points = data.delivery_points;
  var addresses = [];

  for (var i = 0; i < points.length; i++) {
    var address = '';
    address += points[i].organisation_name !== '' ? points[i].organisation_name + ', ' : '';
    address += points[i].department_name !== '' ? points[i].department_name + ', ' : '';
    address += points[i].line_1 !== '' ? points[i].line_1 + ', ' : '';
    address += points[i].line_2 !== '' ? points[i].line_2 + ', ' : '';
    address += town !== '' ? town + ', ' : '';
    address = address.replace(/,\s*$/, "");
    addresses.push(address);
  }
  return addresses;
};

},{}],22:[function(require,module,exports){
'use strict';

var $ = jQuery.noConflict();
function noSundays(date) {
  return [date.getDay() != 0, ''];
}
var self = module.exports = {
  props: {
    options: {
      minDate: 0,
      maxDate: '+1M +10D',
      dateFormat: 'dd / mm / y',
      beforeShowDay: noSundays
    },

    icon: '[data-date-trigger]'
  },

  init: function init(selector) {
    $(selector).each(function () {
      $(this).datepicker(self.props.options);
      $(this).datepicker().datepicker('setDate', 'today');
    });

    self.events.iconClick(self.props.icon);
  },

  events: {
    iconClick: function iconClick(trigger) {
      $(document).on('click', trigger, function (e) {
        var input = $(this).siblings('[data-date]');
        $(input).datepicker('show');
      });
    }
  },

  service: {}
};

},{}],23:[function(require,module,exports){
'use strict';

var $ = jQuery.noConflict();
var Date = require('./date.js');

var self = module.exports = {
  props: {
    delete: {
      element: '<button type="button" class="form-staged__delete text--primary" data-delete-duplicate><i class="fas fa-times"></i></button>',
      selector: '[data-delete-duplicate]'
    }
  },

  init: function init(trigger) {
    self.events.click(trigger);
    self.events.delete(self.props.delete.selector);
  },

  events: {
    click: function click(trigger) {
      $(document).on('click', trigger, function (e) {
        var count = $(this).data('count');
        var target = $(this).data('duplicate');
        var next = count + 1;

        $(this).data('count', next);
        self.service.duplicate(target, next);
      });
    },

    delete: function _delete(trigger) {
      $(document).on('click', trigger, function (e) {
        var parent = $(this).parent();
        self.service.delete(parent);
      });
    }
  },

  service: {
    duplicate: function duplicate(target, next) {
      var parent = $(target).parent();
      var clone = $(target).clone();
      var first = 1;
      $(clone).appendTo($(parent));

      var id = $(clone).attr('id');
      var inputs = $(clone).find('input');
      var labels = $(clone).find('label');
      id = id.replace(first, next);

      $(clone).attr('id', id);

      self.service.buttonAppend('#' + id);

      $(inputs).each(function () {
        var id = $(this).attr('id');
        var type = $(this).attr('type');
        var name = $(this).attr('name');
        var label = $(this).data('label');
        var date = $(this).data('date');

        id = id.replace(first, next);
        name = name.replace(first, next);

        $(this).attr('id', id);
        $(this).attr('name', name);

        if (type === 'checkbox' || type === 'radio') {
          $(this).prop('checked', false);
          $(this).attr('checked', false);
        } else {
          $(this).val('');
        }

        if (typeof label !== 'undefined') {
          var labelText = label.replace(first, next);
          $(this).attr('data-label', labelText);
        }

        if (typeof date !== 'undefined') {
          $(this).removeClass('hasDatepicker');
          $(this).datepicker(Date.props.options);
        }
      });

      $(labels).each(function () {
        var attrFor = $(this).attr('for');

        if (typeof attrFor !== 'undefined') {
          attrFor = attrFor.replace(first, next);
          $(this).attr('for', attrFor);
        }
      });
    },

    delete: function _delete(target) {
      var prev = $(target).prev();

      if ($(target).siblings().length > 1) {
        $(prev).append(self.props.delete.element);
      } else {
        $(target).find(self.props.delete.selector).remove();
      }

      $(target).remove();
    },

    buttonAppend: function buttonAppend(target) {
      var prev = $(target).prev();
      var button = $(target).find(self.props.delete.selector);

      $(prev).find(self.props.delete.selector).remove();
      $(button).find(self.props.delete.selector).remove();
      $(target).append(self.props.delete.element);
    }
  }
};

},{"./date.js":22}],24:[function(require,module,exports){
'use strict';

var $ = jQuery.noConflict();

var self = module.exports = {
  options: {
    method: 'GET',
    url: ajax.ajaxurl,
    dataType: 'json',
    contentType: false,
    processData: false
  },

  init: function init(selector) {
    self.events.click(selector);
  },

  events: {
    click: function click(selector) {
      $(document).on('click', selector, function () {
        var target = $(this).data('proxy');
        var data = {
          action: 'fetch'
        };

        data = $.param(data);
        self.service.post(data, target);
      });
    }
  },

  service: {
    post: function post(data, target) {
      $.ajax({
        method: self.options.method,
        url: self.options.url,
        data: data,
        dataType: self.options.dataType,
        contentType: self.options.contentType,
        processData: self.options.processData,
        success: function success(response) {
          self.service.show(response, target);
        },
        error: function error(data) {
          // console.log(data)
        }
      });
    },

    show: function show(response, target) {
      $(target).html(response);
    }
  }
};

},{}],25:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var $ = jQuery.noConflict();
var Validation = require('../plugins/validation.js');

var self = module.exports = {
  props: {
    input: '.form-staged input, .form-staged select, .form-staged textarea',
    next: '.form-staged__next',
    prev: '.form-staged__prev',
    tabs: '.tabs-steps',
    step: '.form-staged__step',
    submit: '.form-staged__submit',
    heading: '.form-staged__heading'
  },

  init: function init(form) {
    $(form).each(function () {
      self.service.init(this);
    });

    self.events.nextClick(self.props.next);
    self.events.prevClick(self.props.prev);
    self.events.enterKeydown(self.props.input);
    self.events.submitClick(self.props.submit);
    self.events.submitForm(form);
  },

  events: {
    nextClick: function nextClick(trigger) {
      $(document).on('click', trigger, function () {
        var form = $(this).closest('.form-staged');

        self.service.check(this, form);
      });
    },

    prevClick: function prevClick(trigger) {
      $(document).on('click', trigger, function () {
        var form = $(this).closest('.form-staged');

        self.service.prev(this, form);
      });
    },

    enterKeydown: function enterKeydown(trigger) {
      $(document).on('keydown', trigger, function (e) {
        var $this = $(this);
        var form = $(this).closest('.form-staged');
        var steps = self.service.getSteps(form);
        var step = $(this).closest('[data-step]').data('step');

        // If key pressed is Enter and this is textarea
        if ($this.is("textarea")) {
          if (e.which == 13) {
            e.preventDefault();
            var s = $(this).val();
            $(this).val(s + "\n");
            return false;
          }
        }

        // If key pressed is Enter and this is not the final step
        if (e.which == 13 && step !== steps) {
          e.preventDefault();
          self.service.check(this, form);
        }
      });
    },

    submitClick: function submitClick(trigger) {
      $(document).on('click', trigger, function (e) {
        var form = $(this).closest('.form-staged');
        e.preventDefault();

        self.service.check(this, form);
      });
    },

    submitForm: function submitForm(form) {
      $(document).on('submit', form, function (e) {
        self.service.submit(this);
      });
    }
  },

  service: {
    init: function init(form) {
      var first = self.service.getSteps(form);
      var steps = self.service.getSteps(form);

      self.service.updateTabs(form, 1);
      self.service.updateProgress(form, 1);
    },

    check: function check(trigger, form) {
      if (self.service.validate(trigger, form)) {
        self.service.next(trigger, form);
      } else {
        self.service.error(trigger);
      }
    },

    next: function next(trigger, form) {
      var current = $(trigger).closest('.form-staged__step');
      var number = $(current).data('step');
      var next = number + 1;
      var page = $(form).find('[data-step="' + next + '"]');
      var error = $(current).find('.form-staged__error');
      var steps = self.service.getSteps(form);

      $(error).removeClass('active');
      self.service.updateHeading(form, next);
      self.service.updateProgress(form, next);
      self.service.updateTabs(form, next);

      if (number == steps) {
        $(form).trigger('submit');
      } else {
        self.service.updatePage(current, page);
      }
    },

    prev: function prev(trigger, form) {
      var current = $(trigger).closest('.form-staged__step');
      var number = $(current).data('step');
      var prev = number - 1;
      var page = $(form).find('[data-step="' + prev + '"]');

      self.service.updatePage(current, page);
      self.service.updateHeading(form, prev);
      self.service.updateProgress(form, prev);
      self.service.updateTabs(form, prev);
    },

    validate: function validate(trigger, form) {
      var page = $(trigger).closest('.form-staged__step');
      var fields = $(page).find('[data-validate]');
      var valid = true;

      // Loop through inputs and check validation
      $(fields).each(function () {
        if (Validation.service.validate(this) === true) {
          Validation.service.success(this);
        } else {
          valid = false;
          Validation.service.fail(this);
        }
      });

      return valid;
    },

    getSteps: function getSteps(form) {
      // Counts number of stages in form
      var steps = $(form).find(self.props.step).length;
      return steps;
    },

    updateTabs: function updateTabs(form, current) {
      var tabs = $(form).find(self.props.tabs);
      var items = $(tabs).find('li');
      var count = 1;

      $(items).each(function () {
        if (count <= current) {
          $(this).addClass('active');
        } else {
          $(this).removeClass('active');
        }
        count++;
      });
    },

    updateProgress: function updateProgress(form, current) {
      var steps = self.service.getSteps(form);
      var percent = parseFloat(100 / steps) * current;
      percent = percent.toFixed();

      $(form).find('.progress-bar').css('width', percent + '%').html(percent + '%');
    },

    updateHeading: function updateHeading(form, current) {
      var heading = $(form).find(self.props.heading);
      var update = $(form).find('[data-heading-value]');

      if (current > 1) {
        $(heading).addClass('muted');
      } else {
        $(heading).removeClass('muted');
      }

      if (update.length) {
        var text = $(heading).data('heading-text');
        var value = $(update).val();
        value = value.toLowerCase();
        $(heading).html(text);

        var span = $(heading).find('span');
        $(span).html(value);
      }
    },

    updatePage: function updatePage(current, page) {
      var firstInput = $(page).find('.form-input').first();
      var autocomplete = $(firstInput).attr('data-autocomplete');
      var date = $(firstInput).attr('data-date');

      $(current).removeClass('active');
      $(page).addClass('active');

      // If the first input is a date picker or autocomplete, don't select it.
      if ((typeof autocomplete === 'undefined' ? 'undefined' : _typeof(autocomplete)) !== (typeof undefined === 'undefined' ? 'undefined' : _typeof(undefined)) && autocomplete !== false || (typeof date === 'undefined' ? 'undefined' : _typeof(date)) !== (typeof undefined === 'undefined' ? 'undefined' : _typeof(undefined)) && date !== false) {
        return;
      } else {
        $(firstInput).focus();
      }
    },

    error: function error(trigger) {
      var error = $(trigger).closest('.form-staged__step').find('.form-staged__error');

      $(error).addClass('active');
    },

    reset: function reset(form) {
      var first = $(form).find('[data-step="1"]');
      var success = $(form).find('.form-staged__success');

      window.setTimeout(function () {
        if ($(form).hasClass('form--submitting') || $(form).hasClass('form--submitted')) {
          self.service.updatePage(success, first);
          self.service.updateProgress(form, 1);
          self.service.updateTabs(form, 1);
          $(form).closest('.modal').removeClass('success');
        }
      }, 15000);
    },

    submit: function submit(form) {
      var steps = self.service.getSteps(form);
      var first = $(form).find('[data-step="1"]');
      var last = $(form).find('[data-step="' + steps + '"]');
      var final = steps + 1;
      var modal = $(form).closest('.modal');

      $(last).removeClass('active');
      self.service.updateTabs(form, final);
      modal.addClass('success');
      modal.addClass('border-position-color-white');
      self.service.reset(form);
    }
  }
};

},{"../plugins/validation.js":49}],26:[function(require,module,exports){
'use strict';

var $ = jQuery.noConflict();

var self = module.exports = {
  options: {
    proxy: '[data-proxy]'
  },
  init: function init(form) {
    self.events.submitted(form);
    self.events.proxy(self.options.proxy);
  },

  events: {
    proxy: function proxy(trigger) {
      $(document).on('click', trigger, function (event) {
        var target = $(this).data('proxy');
        var value = $(this).data('value');
        self.service.updateField(target, value);
      });
    },

    submitted: function submitted(form) {
      $(form).on('submitted', function (event) {
        var inner = $(this).find('.form__inner');
        var success = $(this).closest('[data-success]');

        if (success.length) {
          self.service.success(success);
        } else {
          self.service.hide(inner);
        }
      });
    }
  },

  service: {
    updateField: function updateField(target, value) {
      // console.log('updateField ', target, value);
      if (value) {
        $(target).val(value);
      }
    },
    hide: function hide(target) {
      // $(target).slideUp()

      if (target === '#alert-cookie') {
        $('#header').header();
      }
    },
    success: function success(target) {
      var panel = $(target).data('success');
      var success = $(target).find(panel);

      $(success).addClass('active');
    }
  }
};

},{}],27:[function(require,module,exports){
'use strict';

var $ = jQuery.noConflict();

var self = module.exports = {
  init: function init(parent) {

    if (window.innerWidth >= 1024) {
      self.service.each(parent);
      self.events.resize(parent);
      self.events.scroll(parent);
    }
  },

  events: {
    scroll: function scroll(parent) {
      $(window).on('resize', function () {
        self.service.each(parent);
      });
    },

    resize: function resize(parent) {
      $(window).scroll(function () {
        if (window.innerWidth >= 1024) {
          self.service.each(parent);
        }
      });
    }
  },

  service: {
    each: function each(parent) {
      $(parent).each(function () {
        self.service.freeze(this);
      });
    },

    freeze: function freeze(parent) {
      var header = $('#header');
      var target = $(parent).data('freeze');
      var offset = $(parent).data('offset') ? $(parent).data('offset') : 0;
      var paddingTop = parseInt($(parent).css('padding-top'));
      var paddingBottom = parseInt($(parent).css('padding-bottom'));
      var windowTop = $(window).scrollTop();
      var parentTop = $(parent).offset().top;
      var parentHeight = $(parent).outerHeight();
      var parentBottom = parentTop + parentHeight;
      var targetTop = $(target).offset().top;
      var targetLeft = $(target).offset().left;
      var targetWidth = $(target).outerWidth();
      var targetHeight = $(target).outerHeight();
      var headerHeight = $(header).outerHeight();
      var diffTop = parentTop - (windowTop + headerHeight);
      var bottomMax = parentBottom;

      var bottomPos = windowTop + headerHeight + targetHeight + paddingTop + paddingBottom - 0;

      if (bottomPos >= bottomMax) {
        $(target).css({
          'position': 'absolute',
          'top': '',
          'bottom': '0px',
          // 'left': offset,
          'width': targetWidth,
          'height': targetHeight
        });
      } else if (diffTop <= 0) {
        $(target).css({
          'position': 'fixed',
          'top': headerHeight + paddingTop,
          'bottom': '',
          // 'left': targetLeft,
          'width': targetWidth,
          'height': targetHeight
        });
      } else {
        $(target).css({
          'position': '',
          'top': '',
          'bottom': '',
          'left': '',
          'width': '',
          'height': ''
        });
      }

      $(window).on('resize', function () {
        $(target).css({
          'position': '',
          'top': '',
          'bottom': '',
          'left': '',
          'width': '',
          'height': ''
        });
      });
    }
  }

  // fixed height similer div
};if ($(window).width() >= 1024) {
  $('#process__tabs').css({ 'min-height': $('#process__tabs').innerHeight() });
}

},{}],28:[function(require,module,exports){
"use strict";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var $ = jQuery.noConflict();

$.fn.extend({
  locrating: function locrating() {
    self.init(this.selector);
  }
});

var self = module.exports = {
  init: function init(el) {
    $(el).each(function () {
      var load = $(this).data("load");

      if (typeof load !== "undefined" && load == true) {
        self.service.init(this);
      }
    });
  },

  service: {
    init: function init(el) {
      var _frame;

      var iframe = $(el).find("iframe");
      var frame = (_frame = {
        id: $(iframe).attr("id"),
        lat: $(iframe).data("lat"),
        lng: $(iframe).data("lng"),
        icon: $(iframe).data("ico"),
        'mapstyle': $(iframe).data('mapstyle'),
        'menucolor': $(iframe).data('menucolor'),
        'menubackcolor': $(iframe).data('menubackcolor'),
        'menuselectcolor': $(iframe).data('menuselectcolor'),
        'menuselectbackcolor': $(iframe).data('menuselectbackcolor'),
        'menuallcaps': $(iframe).data('menuallcaps')
      }, _defineProperty(_frame, "menuallcaps", $(iframe).data('menuallcaps')), _defineProperty(_frame, 'showtransporttab', $(iframe).data('showtransporttab')), _frame);

      switch ($(iframe).data("type")) {
        case "schools-map":
          frame.type = "schools";
          // frame.maxschools= '5';
          break;
        case "stations-map":
          frame.type = "localinfo";
          frame.showstations = "only";
          frame.zoom = "12";
          break;
        case "stations-list":
          frame.type = "stations";
          // frame.maxstations= '5';
          break;
        case "localinfo-map":
          frame.type = "localinfo";
          break;
        case "all-in-one":
          frame.type = "all";
          frame.menuallcaps = "true";
          break;
        case "localinfo-list":
          // frame.type = '';
          break;
        default:
          break;
      }

      try {
        setLocratingIFrameProperties(frame);
        frame;
      } catch (err) {}
    }
  }
};

},{}],29:[function(require,module,exports){
'use strict';

var $ = jQuery.noConflict();
var COLLAPSE = require('./collapse.js');
var FETCH = require('./fetch.ajax.js');

var self = module.exports = {
  map: '',
  aciveWindow: null,

  init: function init(selector) {
    $(selector).each(function () {
      self.service.initMap(this);
    });
  },

  service: {
    initMap: function initMap(map) {
      var markers = $(map).find('.marker');
      var offset = $(map).data('offset') || 0;
      var args = {
        zoom: 14,
        center: new google.maps.LatLng(0, 0),
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        scrollwheel: false
      };

      self.map = new google.maps.Map($(map)[0], args);
      self.map.markers = [];

      $(markers).each(function () {
        self.service.addMarker(self.map, this);
      });

      self.service.centerMap(self.map, offset);

      google.maps.event.addDomListener(window, 'resize', function () {
        var center = self.map.getCenter();

        google.maps.event.trigger(self.map, 'resize');
        self.map.centerMap(center);
      });

      return self.map;
    },

    addMarker: function addMarker(map, marker) {
      var lat = $(marker).data('lat');
      var lng = $(marker).data('lng');
      var position = new google.maps.LatLng(lat, lng);
      var icon = $(marker).data('ico');

      // Sidebar variables
      var collapse = $(marker).data('collapse');
      var id = $(marker).data('id');
      var target = $(marker).data('target');
      var type = $(marker).data('type');

      var args = {
        position: position,
        map: map,
        animation: google.maps.Animation.DROP
      };

      if (icon) {
        args.icon = icon;
      }

      var newMarker = new google.maps.Marker(args);
      map.markers.push(newMarker);

      if ($(marker).html().length) {
        var infowindow = new google.maps.InfoWindow({
          content: $(marker).html()
        });

        google.maps.event.addListener(newMarker, 'click', function () {
          if (self.activeWindow) {
            self.activeWindow.close();
          }
        });
      }

      if (collapse) {
        google.maps.event.addListener(newMarker, 'click', function () {
          if (!$(collapse).hasClass('show')) {
            COLLAPSE.service.toggle(collapse);
          }
        });
      }

      if (id) {
        google.maps.event.addListener(newMarker, 'click', function () {
          if (type === 'undefined') {
            type = 'property';
          }

          var data = {
            action: 'fetch',
            file: 'components/' + type + '/sidebar.php',
            args: {
              id: id
            }
          };

          data = $.param(data);
          FETCH.service.post(data, target);
        });
      }
    },

    centerMap: function centerMap(map, offset) {
      var bounds = new google.maps.LatLngBounds();

      $.each(map.markers, function (i, marker) {
        var lat = marker.position.lat();
        var lng = marker.position.lng();
        var pos = new google.maps.LatLng(lat, lng);

        bounds.extend(pos);
      });

      if (map.markers.length == 1) {
        map.setCenter(bounds.getCenter());
        map.panBy(offset, 0);
        map.setZoom(14);
      } else {
        map.fitBounds(bounds);
      }
    }
  }
};

},{"./collapse.js":17,"./fetch.ajax.js":24}],30:[function(require,module,exports){
'use strict';

var $ = jQuery.noConflict();

var self = module.exports = {
  init: function init(selector) {
    var items = $(selector);

    self.service.init(items);
  },

  service: {
    init: function init(items) {
      var targets = [];

      $(items).each(function () {
        var target = $(this).data('match-height');

        if ($.inArray(target, targets) == -1) {
          targets.push(target);
        }
      });

      for (var i = 0; i < targets.length; i++) {
        var itemx = $('[data-match-height="' + targets[i] + '"]');
        var tallest = self.service.calculate(itemx);
        self.service.apply(itemx, tallest);
      }
    },

    calculate: function calculate(items) {
      var heights = [];
      var tallest;

      $(items).each(function () {
        heights.push($(this).outerHeight());
      });

      tallest = Math.max.apply(null, heights); //cache largest value
      return tallest;
    },

    apply: function apply(items, tallest) {
      $(items).each(function () {
        $(this).css('height', tallest + 'px');
      });
    }
  }
};

},{}],31:[function(require,module,exports){
'use strict';

var $ = jQuery.noConflict();

var self = module.exports = {
  init: function init(selector) {
    var items = $(selector);

    self.service.apply(items);
  },

  service: {
    apply: function apply(items) {
      var tallest = 0;
      var row = 0;
      var divs = 0;
      var rowDivs = [];
      var top = 0;

      $(items).each(function () {
        $(this).outerHeight('auto');
        top = $(this).offset().top;

        if (row != top) {
          for (divs = 0; divs < rowDivs.length; divs++) {
            rowDivs[divs].outerHeight(tallest);
          }

          rowDivs.length = 0; // empty the array
          row = top;
          tallest = $(this).outerHeight();
          rowDivs.push($(this));
        } else {
          rowDivs.push($(this));
          tallest = tallest < $(this).outerHeight() ? $(this).outerHeight() : tallest;
        }

        for (divs = 0; divs < rowDivs.length; divs++) {
          rowDivs[divs].outerHeight(tallest);
        }
      });
    }
  }
};

},{}],32:[function(require,module,exports){
'use strict';

var $ = jQuery.noConflict();
var COLLAPSE = require('./collapse.js');

var self = module.exports = {
  status: false,
  options: {
    trigger: ''
  },

  init: function init(selector) {
    self.options.trigger = '[data-modal], [href*="#modal-"]';

    self.events.click(selector, self.options.trigger);

    self.events.close(selector);
    self.service.init('#wrapper', selector);
  },

  events: {
    click: function click(selector, trigger) {
      $(document).on('click', trigger, function (e) {
        var parent = $(this);
        var nav = $(parent).closest('.nav');
        var modal = '';
        var timeout = '';

        if (typeof $(parent).data('timeout') !== 'undefined') {
          var timeout = $(parent).data("timeout") * 1000;
        }

        if (typeof $(parent).data('modal') !== 'undefined') {
          modal = $(parent).data('modal');
        } else {
          modal = $(parent).attr('href');
        }

        if (modal !== '') {
          if (!self.status) {
            self.service.open(modal, timeout);
            if (timeout) {
              setTimeout(function () {
                self.service.close(modal);
              }, timeout);
            }
          } else {
            self.service.close(modal);
          }
        }

        if (typeof $(parent).data('slide') !== 'undefined') {
          var slide = $(parent).data('slide');

          self.service.slide(modal, slide);
        }

        if (typeof nav !== 'undefined') {
          COLLAPSE.service.toggle(nav);
        }

        e.preventDefault();
      });
    },

    close: function close(selector) {
      $(document).on('click', selector, function (e) {
        if (e.target !== e.currentTarget) return;
        var modal = $(e.target);
        var id = $(modal).attr('id');

        modal = '#' + id;
        self.service.close(modal);
      });
    }
  },

  service: {
    init: function init(parent, selector) {
      var modals = $(parent).find(selector);

      $(modals).each(function () {
        $(selector).appendTo('body');
      });
    },

    open: function open(modal, timeout) {
      self.status = true;

      $(modal).trigger('opened');

      if (timeout === undefined || timeout === 'undefined' || timeout === '') {
        $('body').addClass('prevent-scroll');
        $('html').addClass('prevent-scroll');
      }

      if ($('body.ipad').length) {
        $('html').addClass('prevent-scroll');
      }

      $(modal).addClass('active');

      var modalIframes = $(modal).find('iframe');
      if (modalIframes.length) {
        $(modalIframes).each(function () {
          $(this).attr('src', $(this).attr('data-src'));
        });
      }

      var open = setTimeout(function () {
        $(modal + ' .modal__inner').addClass('active');
      }, 100);

      if (typeof ga == 'function') {
        var gaLabel = modal;
        var gaEvent = 'Opened';
        var gaCategory = 'Popup';
        ga('send', 'event', gaCategory, gaEvent, gaLabel);
      }
    },

    close: function close(modal) {
      $(modal).trigger('closed');
      self.status = false;

      $('body').removeClass('prevent-scroll');
      $('html').removeClass('prevent-scroll');

      if ($('body.ipad').length) {
        $('html').removeClass('prevent-scroll');
      }

      $(modal + ' .modal__inner').removeClass('active');

      var open = setTimeout(function () {
        $(modal).removeClass('active');
      }, 100);

      $(document).trigger('modalclose', modal);

      var modalIframes = $(modal).find('iframe');
      if (modalIframes.length) {
        $(modalIframes).each(function () {
          $(this).attr('src', '');
        });
      }
    },

    slide: function slide(modal, _slide) {
      if ($(modal).find('.slick').length !== 0) {
        var slick = $(modal).find('.slick').first();

        $(slick).find('.slick-slide').height('auto');
        $(slick).slick('setOption', '', '', true);

        $(slick).slick('slickGoTo', _slide);
      }
    }
  }
};

$('.success-close-btn').on('click', function (e) {
  $('.modal').removeClass('active');
  $('.form-staged__success').removeClass('active');
  $('.form-staged__step[data-step="1"]').addClass('active');
});

},{"./collapse.js":17}],33:[function(require,module,exports){
'use strict';

var $ = jQuery.noConflict();

var self = module.exports = {
  init: function init(trigger) {
    self.events.click(trigger);
  },

  events: {
    click: function click(trigger) {
      $(document).on('click', trigger, function (event) {
        event.preventDefault();
        self.service.print();
      });
    }
  },

  service: {
    print: function print() {
      window.print();
    }
  }
};

},{}],34:[function(require,module,exports){
'use strict';

var $ = jQuery.noConflict();

var self = module.exports = {
  init: function init(trigger) {
    self.events.click(trigger);
    self.events.change(trigger);
  },

  events: {
    click: function click(trigger) {
      $(document).on('click', trigger, function () {
        if ($(this).is('a, button')) {
          var target = $(this).attr('data-proxy');
          var value = $(this).attr('data-proxy-value');

          if (value === undefined) {
            value = $(this).attr('data-value');
          }

          if (Array.isArray(target) && Array.isArray(value)) {
            for (var i = 0; i < target.length; i++) {
              self.service.change(target[i], value[i]);
            }
          } else {
            self.service.change(target, value);
          }
        }
      });
    },

    change: function change(trigger) {
      $(document).on('change', trigger, function () {
        var target = $(this).attr('data-proxy');
        var value = $(this).val();

        if (typeof $(this).attr('data-value') !== 'undefined') {
          value = $(this).attr('data-value');
        }

        self.service.change(target, value);
      });
    }
  },

  service: {
    change: function change(target, value) {
      $(target).val(value);
      $(target).text(value);
    }
  }
};

},{}],35:[function(require,module,exports){
'use strict';

var $ = jQuery.noConflict();
var SLIDER = require('./slider.slick.js');

$.fn.extend({
  reviews: function reviews() {
    self.init(this.selector);
  }
});
var ps3;

var self = module.exports = {
  props: {
    more: '.more',
    method: 'GET',
    url: ajax.ajaxurl,
    dataType: 'json',
    contentType: false,
    processData: false
  },

  init: function init(selector) {
    $(selector).each(function () {
      self.service.init(this);
    });

    self.events.click(self.props.more);
  },

  events: {
    click: function click(selector) {
      $(document).on('click', selector, function () {
        var target = $(this).data('proxy');

        self.service.submit(target);
      });
    }
  },

  service: {
    init: function init(selector) {
      var target = $(selector);

      self.service.submit(target);
    },

    submit: function submit(target) {
      var data = {
        action: 'reviews'
      };

      if (typeof $(target).data('template') !== 'undefined') {
        data.template = $(target).data('template');
        // console.log('FOUND DATA TEMPLATE: ' + data.template)
      } else {
        data.template = 'review-google';
        // console.log('NOT FOUND DATA TEMPLATE: ' + data.template)
      }

      if (typeof $(target).data('view') !== 'undefined') {
        data.view = $(target).data('view');
        // console.log('FOUND VIEW MODE: ' + data.view)
      } else {
        data.view = 'list';
        // console.log('NOT FOUND VIEW MODE: ' + data.view)
      }

      if (typeof $(target).data('location') !== 'undefined') {
        data.location = $(target).data('location');
      }

      data = $.param(data);
      self.service.post(data, target);
    },

    post: function post(data, target) {
      $.ajax({
        method: self.props.method,
        url: self.props.url,
        data: data,
        dataType: self.props.dataType,
        contentType: self.props.contentType,
        processData: self.props.processData,
        success: function success(response) {
          self.service.show(response, target);
        },
        error: function error(xhr, status, _error) {
          // console.log('Error', self.props.url, self.props.dataType, xhr.status + ': ' + xhr.statusText, error)
        }
      });
    },

    show: function show(response, target) {
      $(target).html(response.html);

      if (response.view.indexOf('slider') != -1) {
        var slider = $(target).find('.slick');
        var sliderType = $(target).find('.slick').attr('slick-type');
        SLIDER.service.init(slider, sliderType);

        setTimeout(function () {
          var $count = $('.slider-nav').attr("nav-items");
          $('.slider-nav').slick('slickGoTo', $count - 1, true);
        }, 3000);
      }
    }
  }
};

},{"./slider.slick.js":41}],36:[function(require,module,exports){
'use strict';

var $ = jQuery.noConflict();
var COOKIE = require('../utility/cookie.js');

var self = module.exports = {
  options: {
    separator: ','
  },

  init: function init(selector) {
    self.events.click(selector);
  },

  events: {
    click: function click(button) {
      $(document).on('click', button, function (e) {
        var type = $(this).data('save');
        var name = $(this).data('cookie');
        var value = $(this).data('value');
        var button = $(this);

        e.preventDefault();
        self.service.process(type, name, value);

        if (typeof $(this).data('text') !== 'undefined') {
          self.service.text(this);
        }

        $(this).toggleClass('saved');

        if ($(button).hasClass('saved')) {
          $('#fav-modal-heart').toggleClass('saved');
          $(button).attr('data-proxy-value', 'removed from');
        } else {
          $(button).attr('data-proxy-value', 'added to');
        }
      });
    }
  },

  service: {
    process: function process(type, name, value) {
      var data = COOKIE.get(name);
      // console.log(data, type)

      if (value === 'params') {
        value = window.location.search;
      }

      if (data) {
        data = data.split(self.options.separator);

        self.service[type](name, value, data);
      } else if (type == 'add' || type == 'toggle') {
        self.service.create(name, value);
      }
    },

    create: function create(name, value) {
      var data = [];
      data.push(value);
      COOKIE.store(name, data);
    },

    toggle: function toggle(name, value, data) {
      var index = data.indexOf(String(value));

      if (index > -1) {
        data.splice(index, 1);
      } else {
        data.push(value);
      }

      data.join(self.options.separator);
      COOKIE.store(name, data);
    },

    add: function add(name, value, data) {
      var index = data.indexOf(value);

      if (!(index > -1)) {
        data.push(value);
      }

      data.join(self.options.separator);
      COOKIE.store(name, data);
    },

    remove: function remove(name, value, data) {
      var index = data.indexOf(value);

      if (index > -1) {
        data.splice(index, 1);
      }

      data.join(self.options.separator);
      COOKIE.store(name, data);
    },

    text: function text(trigger) {
      var textA = $(trigger).text();
      var textB = $(trigger).data('text');

      $(trigger).text(textB).data('text', textA);
    }
  }
};

},{"../utility/cookie.js":51}],37:[function(require,module,exports){
'use strict';

var $ = jQuery.noConflict();

var self = module.exports = {
  init: function init(trigger) {
    self.events.click(trigger);
  },

  events: {
    click: function click(trigger) {
      $(document).on('click', trigger, function (e) {
        var target = $(this).data('scroll') ? $(this).data('scroll') : $(this).attr('href');
        var offset = $(this).data('offset') ? $(this).data('offset') : $('#header').outerHeight();
        var speed = $(this).data('speed') ? $(this).data('speed') : 200;

        self.service.scroll(target, offset, speed);
        e.preventDefault();
      });
    }
  },

  service: {
    scroll: function scroll(target, offset, speed) {
      offset = offset || 0;
      speed = speed || 200;

      if (target.length) {
        $('html, body').animate({
          scrollTop: $(target).offset().top - offset
        }, speed);
      }
    }
  }
};

},{}],38:[function(require,module,exports){
"use strict";

var $ = jQuery.noConflict();
var Match_Height = require("./match-height.js");
var Match_Row = require("./match-row.js");
var Maps = require("./maps.google.js");
var Slider = require("./slider.slick.js");

var self = module.exports = {
  options: {
    method: "GET",
    url: ajax.ajaxurl,
    dataType: "json",
    contentType: false,
    processData: false
  },

  init: function init(selector) {
    // console.log('selector' , selector);

    self.events.change(selector);
    self.events.page("[data-page]");
    self.events.submit(selector);
    self.events.more("[data-more]");
    self.events.navigate();
    //self.events.getSearchData(selector);
  },

  events: {

    change: function change(form) {
      $("input[name=view]").on("click", function () {
        var page = $(form).find('[name="page"]');
        $(page).val(1);
      });

      $(".post-cat-btn").on("click", function (e) {
        e.preventDefault();
        var cat_ids = $(this).data('value');
        $(".post-cat-btn").removeClass('active');
        $(this).addClass('active');

        $("#post-search-category").val(cat_ids).change();
      });

      // console.log('get_form 1', form);
      $(form).on("change", "input[type=hidden], input[type=radio], input[type=checkbox], input[type=text], select", function () {
        if ($(this).attr("name") !== "page") {
          var page = $(form).find('[name="page"]');
          $(page).val(1);
        }
      });

      $('#property-view-sort').on("change", function () {
        if ($(this).attr("name") !== "page") {
          var page = $(form).find('[name="page"]');
          $(page).val(1);
        }
      });

      $(".property-search__tenure input[name=tenure]").on("change", function () {
        if ($(this).attr("name") !== "page") {
          var page = $(form).find('[name="page"]');
          $(page).val(1);
        }
        $('.property-search__search').trigger('click');
      });
    },

    page: function page(trigger) {
      $(document).on("click", trigger, function (e) {
        var parent = $(this).closest("[data-target]");
        var form = $(parent).data("target");
        var page = $(form).find('[name="page"]');
        var next = parseInt($(this).data("page"));
        e.preventDefault();

        $(page).val(next);
        $(form).trigger("submit");
      });
    },

    more: function more(trigger) {
      $(document).on("click", trigger, function (e) {
        var parent = $(this).closest("[data-target]");
        var form = $(parent).data("target");
        var page = $(form).find('[name="page"]');
        var curr = parseInt($(page).val());
        var next = curr + 1;
        $(page).val(next);
        $(form).trigger("submit");
      });
    },

    submit: function submit(parent) {
      $(document).on("submit", parent, function (e) {
        var form = $(this);
        var data = {};
        var target = $(form).data("target");
        var pagination = $(form).data("pagination");
        var more = $(form).data("more");
        var page = $(form).find('[name="page"]');
        var pageNum = parseInt($(page).val());
        var submit = $(form).find('[type="submit"]');

        e.preventDefault();

        // console.table(location,tenure,priceMin,priceMax,bedroomsMin );

        if ($(form).hasClass("submitting")) {
          return;
        }

        if (target && (more === "undefined" || pageNum === 1)) {
          $(target).html("");
          if ($(form).first().attr("data-no-scroll") === undefined) {
            $("html, body").animate({
              //scrollTop: $(target).offset().top,
            }, 200);
          }
        }

        if (pagination) {
          $(pagination).each(function () {
            var list = $(this).find("ul");
            $(list).html("");
          });
        }

        if (more) {
          $(more).each(function () {
            $(this).html("");
          });
        }

        $(submit).prop("disabled", true);

        if (pageNum === 1) {
          $(target).removeClass("active");
        }

        data = $(form).serialize();
        var query = "?" + data;
        history.pushState(query, null, query);
        self.service.updateLinks(query);
        self.service.post(form, data);
        self.events.getSearchData(form);
      });
    },

    navigate: function navigate() {
      window.addEventListener("popstate", function (e) {
        location.reload(true);
      });
    },

    getSearchData: function getSearchData(form) {
      // var form = $(this);
      // console.log('form', form);

      var location = $(form).find('[name="location"]').val();
      var tenure = $(form).find('[name="tenure"]:checked').val();
      var priceMin = $(form).find('[name="' + tenure + '-price-min"] option:selected');
      var priceMax = $(form).find('[name="' + tenure + '-price-max"] option:selected');
      var bedroomsMin = $(form).find('[name="bedrooms-min"]').val();

      var tenure = tenure == 'sales' ? 'sale' : 'rent';

      //console.table(location,tenure,priceMin,priceMax,bedroomsMin );

      if (!location.length) {
        $(".search-data").html(" Property for " + tenure + " in Berkshire");
      }
      if (location.length) {
        $(".search-data").html(" Property for " + tenure + " in " + location + " ");
      }

      if (location.length && bedroomsMin != 0) {
        $(".search-data").html(" " + bedroomsMin + " bedroom property for " + tenure + " in " + location + " ");
      }

      // if(location.length && (priceMin.length || priceMax.length)){
      //   $(".search-data").html(" Property for "+tenure+" in "+location+" between "+priceMin+" to "+priceMax+" ");
      // }


      if (location.length && priceMin.val() != 0 && priceMax.val() != 999999999999) {
        $(".search-data").html(" Property for " + tenure + " in " + location + " between " + priceMin.text() + " to " + priceMax.text() + " ");
      }
      if (location.length && priceMin.val() != 0 && priceMax.val() != 999999999999 && bedroomsMin != 0) {
        $(".search-data").html(" " + bedroomsMin + " bedroom property for " + tenure + " in " + location + " between " + priceMin.text() + " to " + priceMax.text() + " ");
      }
    }
  },

  service: {
    post: function post(form, data) {
      $.ajax({
        method: self.options.method,
        url: self.options.url,
        data: data,
        dataType: self.options.dataType,
        contentType: self.options.contentType,
        processData: self.options.processData,
        success: function success(response) {
          self.service.show(response, form);

          // $('html, body').animate({
          //   scrollTop: $(form).offset().top
          // }, 900)
        },
        error: function error(data) {
          // console.log(data);
        }
      });
    },

    show: function show(response, form) {
      var target = $(form).data("target");
      var pagination = $(form).data("pagination");
      var more = $(form).data("more");
      var count = $(form).data("count");
      var page = $(form).find('[name="page"]');
      var pageNum = parseInt($(page).val());
      var submit = $(form).find('[type="submit"]');
      var button = $(form).data("button");

      if (more && pageNum > 1) {
        var newHtml = $.parseHTML(response.html);
        $(target).children(".row").first().append(newHtml[0].innerHTML);
        Match_Height.init("[data-match-height]");
        Match_Row.init("[data-match-row]");
      } else {
        $(target).html(response.html);
      }

      if (pagination) {
        $(pagination).each(function () {
          var list = $(this).find("ul");
          $(list).html(response.pagination);
        });
      }

      // console.log(more, response);
      if (more) {
        $(more).each(function () {
          $(this).html(response.more);
        });
      }

      if (button) {
        $(button).removeClass("display-none");
      }

      if (count) {
        $(count).html(response.count);
      }

      // console.log(count, response)
      // if (count && response.total === 0) {
      //   $(count).html("");
      // } else if (count) {
      //   if (more === "undefined") {
      //     $(count).find(".count-from").html(response.from);
      //   }

      //   $(count).find(".count-to").html(response.to);
      //   $(count).find(".count-total").html(response.total);
      // }

      var map = $(target).find(".map");
      var slick = $(target).find(".slick");

      if (map) {
        $(map).each(function () {
          Maps.service.initMap(this);
        });
      }

      if (slick.length) {
        $(slick).not(".slick-initialized").each(function () {
          Slider.service.init(this);
        });
      }

      $(target).addClass("loaded");
      $(form).removeClass("submitting");
      $(submit).prop("disabled", false);
      Match_Height.init("[data-match-height]");
      Match_Row.init("[data-match-row]");
      $(window).resize();
    },

    updateLinks: function updateLinks(query) {
      var propertyPage = $("[name=property-page]").val();
      var mapPage = $("[name=map-page]").val();

      var gridLink = $('[data-view="grid"]');
      var listLink = $('[data-view="list"]');
      var mapLink = $('[data-view="map"]');

      $(gridLink).attr("href", propertyPage + query.replace("view=map", "view=list").replace("view=list", "view=grid").replace("per-page=-1", "per-page=12"));
      $(listLink).attr("href", propertyPage + query.replace("view=map", "view=grid").replace("view=list", "view=list").replace("per-page=-1", "per-page=12"));
      $(mapLink).attr("href", mapPage + query.replace("view=grid", "view=map").replace("view=list", "view=map").replace("per-page=12", "per-page=-1"));
    },

    submit: function submit(form) {
      $(form).submit();
    }
  }
};

},{"./maps.google.js":29,"./match-height.js":30,"./match-row.js":31,"./slider.slick.js":41}],39:[function(require,module,exports){
'use strict';

var $ = jQuery.noConflict();

var self = module.exports = {
  init: function init(trigger) {
    self.events.click(trigger);
  },

  events: {
    click: function click(trigger) {
      $(document).on('click', trigger, function (event) {
        self.service.class(this);
      }), $(document).on('click', '.post-share-btn', function (event) {
        $('.property-header__share-warp').addClass('show');
        $("html, body").animate({ scrollTop: 0 }, "slow");
      }), $(document).on('click', '.property-header__share-warp__close', function (event) {
        $('.property-header__share-warp').removeClass('show');
      });
    }
  },

  service: {
    class: function _class(target) {
      $(target).toggleClass('active').blur();
    },

    copy: function copy(text) {
      var temp = $('<input>');
      $('body').append(temp);
      temp.val(text).select();
      document.execCommand('copy');
      temp.remove();
    }
  }
};

},{}],40:[function(require,module,exports){
'use strict';

var $ = jQuery.noConflict();

var self = module.exports = {
  props: {
    ps: null,
    container: null,
    windowSize: $(window).width()
  },
  init: function init(trigger) {
    $(trigger).each(function (index) {

      var id = $(this).attr('id');
      self.service.activateScrollbar('#' + id);
      self.events.windowResize('#' + id);
    });
  },

  events: {
    //Destroys scrollbar if it is a mobile only version.
    windowResize: function windowResize(target) {
      $(window).on('resize', function () {
        self.props.windowSize = $(window).width();

        if (self.props.windowSize >= 1024) {
          if ($(target).hasClass("side-scroll--mobile")) {
            self.props.ps.destroy();
            self.props.ps = null;
          }
        } else {
          if ($(target).hasClass("side-scroll--mobile") && !$(target).hasClass("ps")) {
            self.props.ps = new PerfectScrollbar(self.props.container);
          }
        }
      });
    }
  },

  service: {
    //Activates scrollbar if it exists.
    activateScrollbar: function activateScrollbar(target) {
      self.props.container = document.querySelector(target);

      if ($(target).length > 0) {
        self.props.ps = new PerfectScrollbar(self.props.container);
      }
    }
  }
};

},{}],41:[function(require,module,exports){
'use strict';

var $ = jQuery.noConflict();

// POST commands to YouTube or Vimeo API
function postMessageToPlayer(player, command) {
  // console.log("COMMAND EXECUTED", player, command)
  if (player == null || command == null) return;

  // console.log("COMMAND EXECUTED", player, command)
  player.contentWindow.postMessage(JSON.stringify(command), "*");
}

var $countSub;
var self = module.exports = {
  widths: [0, 575, 767, 1023, 1279, 1599],

  init: function init(selector) {
    $(selector).each(function () {
      self.service.init(this, $(this).attr('slick-type'));
    });
  },

  service: {
    init: function init(slider, slickType) {
      var settings = {
        infinite: true,
        pauseOnHover: false,
        swipeToSlide: true,
        touchMove: true,
        swipe: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dotsClass: 'slick__dots',
        nextArrow: '<button type="button" class="slick__next"><i class="fas fa-fw fa-angle-right"></i></button>',
        prevArrow: '<button type="button" class="slick__prev"><i class="fas fa-fw fa-angle-left"></i></button>',
        mobileFirst: true
      };
      if (slickType == 'no-infinite-full-width') {
        settings = {
          infinite: false,
          dotsClass: 'slick__dots',
          nextArrow: '<button type="button" class="slick__next"><i class="fas fa-fw fa-angle-right"></i></button>',
          prevArrow: '<button type="button" class="slick__prev"><i class="fas fa-fw fa-angle-left"></i></button>',
          mobileFirst: true,
          responsive: [{
            breakpoint: 1600,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          }, {
            breakpoint: 1280,
            settings: {
              slidesToShow: 4.4,
              slidesToScroll: 1
            }
          }, {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3.4,
              slidesToScroll: 1
            }
          }, {
            breakpoint: 991,
            settings: {
              slidesToShow: 3.3,
              slidesToScroll: 1
            }
          }, {
            breakpoint: 600,
            settings: {
              slidesToShow: 2.3,
              slidesToScroll: 1
            }
          }, {
            breakpoint: 576,
            settings: {
              slidesToShow: 2.3,
              slidesToScroll: 1
            }
          }, {
            breakpoint: 480,
            settings: {
              slidesToShow: 1.2,
              slidesToScroll: 1
            }
          }, {
            breakpoint: 0,
            settings: {
              slidesToShow: 1.1,
              slidesToScroll: 1
            }
          }]
        };
      }
      if (slickType == 'pagelinks-no-infinite-full-width') {
        settings = {
          infinite: false,
          dotsClass: 'slick__dots',
          nextArrow: '<button type="button" class="slick__next"><i class="fas fa-fw fa-angle-right"></i></button>',
          prevArrow: '<button type="button" class="slick__prev"><i class="fas fa-fw fa-angle-left"></i></button>',
          mobileFirst: true,
          responsive: [{
            breakpoint: 1600,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          }, {
            breakpoint: 1280,
            settings: {
              slidesToShow: 3.1,
              slidesToScroll: 1
            }
          }, {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2.3,
              slidesToScroll: 1
            }
          }, {
            breakpoint: 991,
            settings: {
              slidesToShow: 2.3,
              slidesToScroll: 1
            }
          }, {
            breakpoint: 600,
            settings: {
              slidesToShow: 2.3,
              slidesToScroll: 1
            }
          }, {
            breakpoint: 576,
            settings: {
              slidesToShow: 2.3,
              slidesToScroll: 1
            }
          }, {
            breakpoint: 480,
            settings: {
              slidesToShow: 1.2,
              slidesToScroll: 1
            }
          }, {
            breakpoint: 0,
            settings: {
              slidesToShow: 1.1,
              slidesToScroll: 1
            }
          }]
        };
      }
      if (slickType == 'news-no-infinite-full-width') {
        settings = {
          infinite: false,
          dotsClass: 'slick__dots',
          nextArrow: '<button type="button" class="slick__next"><i class="fas fa-fw fa-angle-right"></i></button>',
          prevArrow: '<button type="button" class="slick__prev"><i class="fas fa-fw fa-angle-left"></i></button>',
          mobileFirst: true,
          responsive: [{
            breakpoint: 1600,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          }, {
            breakpoint: 1280,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1
            }
          }, {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          }, {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          }, {
            breakpoint: 600,
            settings: {
              slidesToShow: 2.3,
              slidesToScroll: 1
            }
          }, {
            breakpoint: 576,
            settings: {
              slidesToShow: 2.3,
              slidesToScroll: 1
            }
          }, {
            breakpoint: 480,
            settings: {
              slidesToShow: 1.2,
              slidesToScroll: 1
            }
          }, {
            breakpoint: 0,
            settings: {
              slidesToShow: 1.2,
              slidesToScroll: 1
            }
          }]
        };
      }
      if (slickType == 'reviews-slider-for') {
        settings = {
          slidesToShow: 1,
          slidesToScroll: 1,
          asNavFor: '.slider-nav',
          draggable: false,
          infinite: false
        };
      }
      if (slickType == 'reviews-slider-nav') {
        var $slider1 = $('.slider-nav');
        $slider1.on('init', function (event, slick, currentSlide, nextSlide) {
          $countSub = slick.slideCount / 2;
          $countSub = Math.round($countSub);
          $slider1.attr("nav-items", $countSub);
        });

        settings = {
          dotsClass: 'slick__dots',
          nextArrow: '<button type="button" class="slick__next"><i class="fas fa-fw fa-angle-right"></i></button>',
          prevArrow: '<button type="button" class="slick__prev"><i class="fas fa-fw fa-angle-left"></i></button>',
          centerMode: true,
          asNavFor: '.slider-for',
          focusOnSelect: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: false,
          //initialSlide: 2,
          variableWidth: true
        };
      }

      var calculate_height = function calculate_height() {
        var rat1 = 16;var rat2 = 9;
        var ratio = $(window).width() / rat1;
        var calculated_height = ratio * rat2;
        //$('.hero-large').css('height', calculated_height)
      };
      if ($(slider).data('slidertype') == 'video') {
        $(window).resize(calculate_height);
        calculate_height();
      }

      var data = Object.entries($(slider).data());

      for (var i = 0; i < data.length; i++) {
        data[i] = self.service.processData(data[i][0], data[i][1]);
      }

      for (var i = 0; i < data.length; i++) {
        settings[data[i][0]] = data[i][1];
      }

      $(slider).on('init', function (slick, currentSlide) {
        slick = $(slick.currentTarget);
        setTimeout(function () {
          self.service.playVideo(slick, "play");
        }, 1000);
      });

      $(slider).on('afterChange', function (event, slick, currentSlide) {
        slick = $(slick.$slider);
        //playPauseVideo(slick,"play");
      });

      $(slider).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var slide = $(slick.$slides.get(currentSlide));
        var next = $(slick.$slides.get(nextSlide));
        var counter = $(slider).data('counter');
        self.service.stopVideo($(slide));

        if (counter) {
          var count = $(next).data('count');
          $(counter).text(count);
        }
      });

      $(slider).slick(settings);

      if (settings.autoplay === true) {
        // slick($(slider), 'Next')
        // slick($(slider), 'slickPlay')
      }
    },

    playVideo: function playVideo(slide) {
      player = slide.find("iframe").get(0);
      postMessageToPlayer(player, {
        "event": "command",
        "func": "mute"
      });
      postMessageToPlayer(player, {
        "event": "command",
        "func": "playVideo"
      });
    },

    stopVideo: function stopVideo(slide) {
      player = slide.find("iframe").get(0);
      postMessageToPlayer(player, {
        "event": "command",
        "func": "pauseVideo"
      });
    },

    processData: function processData(label, value) {
      switch (label) {
        case 'responsive':
          var max = self.widths.length;
          var responsive = [];

          for (var i = 0; i < max; i++) {
            var rule = {
              breakpoint: self.widths[i],
              settings: {
                slidesToShow: value[i]
              }
            };

            responsive.push(rule);
          }
          return [label, responsive];
          break;
        case 'autospeed':
          return ['autoplaySpeed', value];
          break;
        case 'nav':
          return ['asNavFor', value];
          break;
        default:
          return [label, value];
      }
    }
  }
};
setTimeout(function () {
  var $count = $('.slider-nav').attr("nav-items");
  $('.slider-nav').slick('slickGoTo', $count - 1, true);
}, 3000);

},{}],42:[function(require,module,exports){
'use strict';

var $ = jQuery.noConflict();

var self = module.exports = {
  duration: 1000,

  delimiter: wNumb({
    decimals: 0,
    mark: '.',
    thousand: ','
  }),

  init: function init(trigger) {
    self.events.scroll(trigger);
  },

  events: {
    scroll: function scroll(trigger) {
      $(window).on('scroll', function () {
        $(trigger).each(function () {
          self.service.check(this);
        });
      });
    }
  },

  service: {
    count: function count(target, start, end) {
      var range = end - start;
      var increment = self.service.secure(range);
      var stepTime = range <= 1000 ? Math.ceil(self.duration / range) : 10;
      var current = start;

      var timer = setInterval(function () {
        current += increment;
        $(target).html(self.service.delimit(current));

        if (current >= end) {
          clearInterval(timer);
          $(target).html(self.service.delimit(end));
        }
      }, stepTime);
    },

    secure: function secure(number) {
      if (number > 1000) {
        number = number / 100;
      } else {
        number = 1;
      }

      return number;
    },

    delimit: function delimit(number) {
      number = self.delimiter.to(number);
      return number;
    },

    concat: function concat(number) {
      if (typeof number === 'string') {
        number = self.delimiter.from(number);
      }

      return number;
    },

    check: function check(trigger) {
      if ($(trigger).hasClass('arrived') && !$(trigger).hasClass('counted')) {
        var start = 0;
        var end = self.service.concat($(trigger).data('stat'));

        self.service.count(trigger, start, end);
        $(trigger).addClass('counted');
      }
    }
  }
};

},{}],43:[function(require,module,exports){
'use strict';

var $ = jQuery.noConflict();

var self = module.exports = {
  init: function init(selector) {
    $(selector).each(function () {
      self.service.initStreet(this);
      self.events.streetShown(this);
    });
  },

  events: {
    streetShown: function streetShown(street) {
      $(document).on('streetShown', function () {
        self.service.initStreet(street);
      });
    }
  },

  service: {
    initStreet: function initStreet(street) {
      var sv = new google.maps.StreetViewService();
      var panorama = new google.maps.StreetViewPanorama(street);
      var marker = $(street).find('.marker');
      var lat = $(marker).data('lat');
      var lng = $(marker).data('lng');

      var center = {
        lat: parseFloat(lat),
        lng: parseFloat(lng)
      };

      sv.getPanorama({
        location: center,
        radius: 500
      }, function (data, status) {
        if (status === 'OK') {
          self.service.showStreet(panorama, data.location.pano);
        }
      });
    },

    showStreet: function showStreet(panorama, location) {
      panorama.setPano(location);
      panorama.setPov({
        heading: 270,
        pitch: 0
      });
      panorama.setVisible(true);
    }
  }
};

},{}],44:[function(require,module,exports){
'use strict';

var $ = jQuery.noConflict();

var self = module.exports = {
  init: function init(trigger) {
    self.events.click(trigger);
    self.events.change(trigger);
    self.events.load();
  },

  events: {
    click: function click(trigger) {
      $(document).on('click', trigger, function (e) {

        var target = $(this).data('submit');

        var form = target ? target : $(this).closest('form');

        if ($(this).is('a, button')) {
          self.service.submit(form);
        }

        if ($(form).attr("id") === "property-search") {
          self.service.updatePropertySearchTitle(form);
        }
      });
    },

    change: function change(trigger) {
      $(document).on('change', trigger, function (e) {
        var target = $(this).data('submit');
        var form = target ? target : $(this).closest('form');
        var inputName = $(this).attr('name');

        if (inputName == 'location') {
          self.service.updateSort();
        }

        self.service.submit(form);
      });
    },
    load: function load() {
      var location = $("#property-search-location").val();
      // alert(location);
      if (location) {
        $("#property-search-radius").prop("selectedIndex", 0);
        self.service.submit('#property-search');
      }
    }
  },

  service: {
    submit: function submit(form) {
      $(form).trigger('submit');
    },
    updateSort: function updateSort(form) {
      var sort = $('[name="sort"]');
      $(sort).val('distance');
    },

    updatePropertySearchTitle: function updatePropertySearchTitle(form) {
      var searchTitle = $("#property-search-title");
      var searchDescription = $('#property-search-description');
      var location = $("#property-search-location").val();
      var searchLocation = $("#property-search-search-title").val();
      var searchDescriptionForm = $("#property-search-search-description").val();
      var searchDescriptionAjax = ajax.search_description;
      // console.log(searchDescriptionAjax);

      /*if(searchDescriptionAjax){
        $(searchDescriptionAjax).each(function(index, value){  
            if(value.link.title.toUpperCase() == location.toUpperCase()){
              searchDescription.text(value.description);
            }
        });  
      }*/

      if (location.toUpperCase() == searchLocation.toUpperCase()) {
        searchDescription.text(searchDescriptionForm);
      } else {
        searchDescription.text('');
      }
    }

  }
};

},{}],45:[function(require,module,exports){
'use strict';

var $ = jQuery.noConflict();
var MAPS = require('./maps.google.js');
var LOCRATING = require('./locrating.js');

var self = module.exports = {
  init: function init(trigger) {
    self.events.click(trigger);
    self.events.change(trigger);
  },

  events: {
    click: function click(trigger) {
      $(document).on('click', trigger + ' a', function (e) {
        var el = $(e.target).closest(trigger);
        var panel = $(el).data('tab');

        self.service.toggle(el);
        self.service.show(panel);
        e.preventDefault();
      });
    },

    change: function change(trigger) {
      $(document).on('change', trigger, function () {
        var value = $(this).val();
        var option = $(this).find('option[value="' + value + '"]');
        var panel = $(option).data('tab');

        self.service.show(panel);
      });
    }
  },

  service: {
    toggle: function toggle(trigger) {
      $(trigger).addClass('active').siblings().removeClass('active');

      if ($(trigger).find('.street')) {
        $(document).trigger('streetShown');
      }
    },

    show: function show(panel) {
      var slider = $(panel).find('[class*="slick"]');
      var map = $(panel).find('.map');
      var locrating = $(panel).find('.locrating');

      $(panel).addClass('active').siblings().removeClass('active');

      if (locrating.length) {
        LOCRATING.service.init(locrating);
      }
    }
  }
};

},{"./locrating.js":28,"./maps.google.js":29}],46:[function(require,module,exports){
'use strict';

var $ = jQuery.noConflict();

var self = module.exports = {
  init: function init(trigger) {
    self.events.click(trigger);
  },

  events: {
    click: function click(trigger) {
      $(document).on('click', trigger, function (event) {
        if (typeof $(this).data('text') !== 'undefined') {
          self.service.text(this);

          if (typeof $(this).data('twin') !== 'undefined') {
            var twin = $(this).data('twin');
            self.service.text($(twin));
          }
        }
      });
    }
  },

  service: {
    text: function text(trigger) {
      var original = $(trigger).html();
      var updated = $(trigger).data('text');

      $(trigger).html(updated).data('text', original);
    }
  }
};

},{}],47:[function(require,module,exports){
'use strict';

var $ = jQuery.noConflict();
var PROXY = require('./proxy.js');

var self = module.exports = {
  init: function init(trigger) {
    self.events.change(trigger);
  },

  events: {
    change: function change(trigger) {
      $(document).on('change', trigger, function (event) {
        if (typeof $(this).data('toggle') !== 'undefined') {
          self.service.toggle(this);
        }
      });
    }
  },

  service: {
    toggle: function toggle(trigger) {
      var original = $(trigger).val();
      var updated = $(trigger).data('toggle');

      $(trigger).val(updated);
      $(trigger).data('toggle', original);

      if (typeof $(trigger).data('proxy') !== 'undefined') {
        var target = $(trigger).data('proxy');
        PROXY.service.change(target, updated);
      }
    }
  }
  // toggle form selling and letting for lead magnet for multi form
};$('input[type=radio][name=lead-val]').change(function () {
  if (this.value == 'resale') {
    $('.lead-magnet-split__selling').show();
    $('.lead-magnet-split__letting').hide();
    $('.selling-img').show();
    $('.lettings-img').hide();
  } else if (this.value == 'lettings') {
    $('.lead-magnet-split__selling').hide();
    $('.lead-magnet-split__letting').show();
    $('.lettings-img').show();
    $('.selling-img').hide();
  }
});

$('input[name=property-book-viewing-appointment-1-times]:checkbox').change(function () {
  var selectedValue = $(this).val();
  if (selectedValue == 'Evening') {
    if ($(this).is(':checked')) {
      $('.day-time').hide();
      $('.evening-time').show();
    } else {
      $('.day-time').show();
      $('.evening-time').hide();
    }
  }
});

},{"./proxy.js":34}],48:[function(require,module,exports){
'use strict';

var $ = jQuery.noConflict();

var self = module.exports = {
  init: function init(parent) {
    self.events.click(parent);
  },

  events: {
    click: function click(trigger) {
      $(document).on('click', trigger, function () {
        var tip = $(this).find('.tooltip__content');

        self.service.toggle(tip);
      });
    }
  },

  service: {
    toggle: function toggle(target) {
      $(target).toggleClass('active');
    }
  }
};

},{}],49:[function(require,module,exports){
'use strict';

var $ = jQuery.noConflict();

function validateEmail(email) {
  if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
    if (email.indexOf('.co.uk') > -1) {
      return true;
    } else if (email.indexOf('.com') > -1) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
}

validator.rules.email = function (value, type, name, formID) {
  if (value.length) {
    if (validateEmail(value)) {
      $(".error__email").hide();
      return true;
    }
    $(".error__email").show();
    return false;
  }
  return null;
};

var self = module.exports = {
  props: {
    icons: {
      class: '.form-input-validation',
      success: '<span class="form-input-validation fas fa-check-circle text-success"></span>',
      fail: '<span class="form-input-validation fas fa-exclamation-triangle text-error"></span>'
    }
  },

  init: function init(trigger) {
    self.events.change(trigger);
    self.events.typing(trigger);
  },

  events: {
    change: function change(trigger) {
      $(document).on('change', trigger, function (event) {
        self.service.check(this);
      });
    },

    typing: function typing(trigger) {
      $(trigger).doneTyping(function () {
        if ($(this).hasClass('fail')) {
          self.service.check(this);
        }
      });
    }
  },

  service: {
    check: function check(field) {
      if (self.service.validate(field) == true) {
        self.service.success(field);
      } else {
        self.service.fail(field);
      }
    },

    validate: function validate(field) {
      var value = $(field).val();
      var type = $(field).attr('type');
      var name = $(field).attr('name');
      var formID = $(field).closest('form').attr('id');
      var validation = $(field).data('validate').split(' ');
      var result = true;

      for (var i = 0, l = validation.length; i < l; i++) {
        if (typeof validator.rules[validation[i]] !== 'function') {
          continue;
        }

        var validated = validator.rules[validation[i]](value, type, name, formID);

        if (validated === false) {
          result = false;
        }
      }

      return result;
    },

    success: function success(field) {
      $(field).removeClass('fail').addClass('success');

      if ($(field).hasClass('form-input')) {
        var parent = $(field).parent();
        $(parent).find(self.props.icons.class).remove();
        $(parent).prepend(self.props.icons.success);
      }
    },

    fail: function fail(field) {
      $(field).removeClass('success').addClass('fail');

      if ($(field).hasClass('form-input')) {
        var parent = $(field).parent();
        $(parent).find(self.props.icons.class).remove();
        $(parent).prepend(self.props.icons.fail);
      }
    }
  }
};

},{}],50:[function(require,module,exports){
'use strict';

var $ = jQuery.noConflict();

var self = module.exports = {
  init: function init() {
    self.events.mouseOver();
  },

  events: {
    mouseOver: function mouseOver() {
      var player;
      function onYouTubePlayerAPIReady() {

        jQuery(document).find('.ytplayer').map(function (index, elem) {

          player = new YT.Player(jQuery(elem).attr('id'), {
            height: '360',
            width: '640',
            videoId: jQuery(elem).data('video-id'),
            playerVars: {
              loop: 1,
              controls: 1,
              rel: 0,
              fs: 0,
              showinfo: 0,
              disablekb: 1
            }
          });

          var playVideo = function playVideo(event) {

            var parent = jQuery(this).closest('.split__media');
            parent.find('.video__overlay').hide();

            event.data.playVideo();
          };

          jQuery(document).find(jQuery(elem).data('trigger')).bind('click', player, playVideo);
        });
      }
    }
  }
};

},{}],51:[function(require,module,exports){
'use strict';

module.exports = {
  get: function get(cname) {
    var name = cname + '=';
    var ca = document.cookie.split(';');

    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
    }
    return '';
  },

  store: function store(cname, cvalue) {
    var expires = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3600 * 1000 * 24 * 365;

    var d = new Date();
    d.setTime(d.getTime() + expires);
    document.cookie = cname + '=' + cvalue + ';expires=' + d.toUTCString() + ';path=/';
  }
};

},{}],52:[function(require,module,exports){
'use strict';

var $ = jQuery.noConflict();

$.fn.doneTyping = function (callback, timeout) {
  timeout = timeout || 1e3; // 1 second default timeout
  var timeoutReference;
  var doneTyping = function doneTyping(el) {
    if (!timeoutReference) return;
    timeoutReference = null;
    callback.call(el);
  };

  return this.each(function (i, el) {
    var $el = $(el);
    // Chrome Fix (Use keyup over keypress to detect backspace)
    $el.is(':input') && $el.on('keyup keypress paste', function (e) {
      // This catches the backspace button in chrome, but also prevents
      // the event from triggering too preemptively. Without this line,
      // using tab/shift+tab will make the focused element fire the callback.
      if (e.type === 'keyup' && e.keyCode !== 8) return;

      // Check if timeout has been set. If it has, "reset" the clock and
      // start over again.
      if (timeoutReference) clearTimeout(timeoutReference);
      timeoutReference = setTimeout(function () {
        // if we made it here, our timeout has elapsed. Fire the
        // callback
        doneTyping(el);
      }, timeout);
    }).on('blur', function () {
      // If we can, fire the event since we're leaving the field
      doneTyping(el);
    });
  });
};

},{}],53:[function(require,module,exports){
'use strict';

var $ = jQuery.noConflict();

var self = module.exports = {
  init: function init(trigger) {
    self.events.load(trigger);
  },

  events: {
    load: function load(trigger) {
      $(window).scroll(function () {
        $(trigger).each(function () {
          if ($(this).attr('data-src') && !$(this).closest('.modal').length && $(this).attr('src') == '') {
            if ($(window).scrollTop() > $(this).offset().top - 300) {
              $(this).attr('src', $(this).attr('data-src'));
            }
          }
        });
      });
    }
  }
};

},{}],54:[function(require,module,exports){
"use strict";

if (!Object.entries) {
  Object.entries = function (obj) {
    var ownProps = Object.keys(obj),
        i = ownProps.length,
        resArray = new Array(i); // preallocate the Array
    while (i--) {
      resArray[i] = [ownProps[i], obj[ownProps[i]]];
    }return resArray;
  };
}

},{}],55:[function(require,module,exports){
"use strict";

// requestAnimationFrame() shim by Paul Irish
// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
window.requestAnimFrame = function () {
  return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function ( /* function */callback, /* DOMElement */element) {
    window.setTimeout(callback, 1000 / 60);
  };
}();

/**
 * Behaves the same as setTimeout except uses requestAnimationFrame() where possible for better performance
 * @param {function} fn The callback function
 * @param {int} delay The delay in milliseconds
 */

window.requestTimeout = function (fn, delay) {
  if (!window.requestAnimationFrame && !window.webkitRequestAnimationFrame && !(window.mozRequestAnimationFrame && window.mozCancelRequestAnimationFrame) && !window.oRequestAnimationFrame && !window.msRequestAnimationFrame) return window.setTimeout(fn, delay);

  var start = new Date().getTime(),
      handle = {};

  function loop() {
    var current = new Date().getTime(),
        delta = current - start;

    if (delta >= delay) {
      fn.call();
    } else {
      handle.value = requestAnimFrame(loop);
    }
  }

  handle.value = requestAnimFrame(loop);
  return handle;
};

/**
 * Behaves the same as clearTimeout except uses cancelRequestAnimationFrame() where possible for better performance
 * @param {int|object} fn The callback function
 */
window.clearrequestTimeout = function (handle) {
  return window.cancelAnimationFrame ? window.cancelAnimationFrame(handle.value) : window.webkitCancelAnimationFrame ? window.webkitCancelAnimationFrame(handle.value) : window.webkitCancelRequestAnimationFrame ? window.webkitCancelRequestAnimationFrame(handle.value) : /* Support for legacy API */
  window.mozCancelRequestAnimationFrame ? window.mozCancelRequestAnimationFrame(handle.value) : window.oCancelRequestAnimationFrame ? window.oCancelRequestAnimationFrame(handle.value) : window.msCancelRequestAnimationFrame ? window.msCancelRequestAnimationFrame(handle.value) : clearTimeout(handle);
};

},{}],56:[function(require,module,exports){
'use strict';

function handleFirstTab(e) {
  if (e.keyCode === 9) {
    // the "I am a keyboard user" key
    document.body.classList.add('user-is-tabbing');
    window.removeEventListener('keydown', handleFirstTab);
  }
}

window.addEventListener('keydown', handleFirstTab);

},{}]},{},[3])

